/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	
	(function( jQuery ) {
	    // Create the request object
	    // (This is still attached to ajaxSettings for backward compatibility)
	    jQuery.ajaxSettings.xdr = function() {
	        return (window.XDomainRequest ? new window.XDomainRequest() : null);
	    };
	
	    // Determine support properties
	    (function( xdr ) {
	        jQuery.extend( jQuery.support, { iecors: !!xdr });
	    })( jQuery.ajaxSettings.xdr() );
	
	    // Create transport if the browser can provide an xdr
	    if ( jQuery.support.iecors ) {
	
	        jQuery.ajaxTransport(function( s ) {
	            var callback,
	                xdr = s.xdr();
	
	            return {
	                send: function( headers, complete ) {
	                    xdr.onload = function() {
	                        var headers = { 'Content-Type': xdr.contentType };
	                        complete(200, 'OK', { text: xdr.responseText }, headers);
	                    };
	
	                    // Apply custom fields if provided
	                    if ( s.xhrFields ) {
	                        xhr.onerror = s.xhrFields.error;
	                        xhr.ontimeout = s.xhrFields.timeout;
	                    }
	
	                    xdr.open( s.type, s.url );
	
	                    // XDR has no method for setting headers O_o
	
	                    xdr.send( ( s.hasContent && s.data ) || null );
	                },
	
	                abort: function() {
	                    xdr.abort();
	                }
	            };
	        });
	    }
	})( jQuery );
	define("shared/scripts/libs/jquery/plugins/iecors/jquery.iecors", function(){});
	
	//     Underscore.js 1.7.0
	//     http://underscorejs.org
	//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (typeof exports !== 'undefined') {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.7.0';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var createCallback = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  _.iteratee = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return createCallback(value, context, argCount);
	    if (_.isObject(value)) return _.matches(value);
	    return _.property(value);
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    if (obj == null) return obj;
	    iteratee = createCallback(iteratee, context);
	    var i, length = obj.length;
	    if (length === +length) {
	      for (i = 0; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    if (obj == null) return [];
	    iteratee = _.iteratee(iteratee, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length),
	        currentKey;
	    for (var index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = function(obj, iteratee, memo, context) {
	    if (obj == null) obj = [];
	    iteratee = createCallback(iteratee, context, 4);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index = 0, currentKey;
	    if (arguments.length < 3) {
	      if (!length) throw new TypeError(reduceError);
	      memo = obj[keys ? keys[index++] : index++];
	    }
	    for (; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      memo = iteratee(memo, obj[currentKey], currentKey, obj);
	    }
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = function(obj, iteratee, memo, context) {
	    if (obj == null) obj = [];
	    iteratee = createCallback(iteratee, context, 4);
	    var keys = obj.length !== + obj.length && _.keys(obj),
	        index = (keys || obj).length,
	        currentKey;
	    if (arguments.length < 3) {
	      if (!index) throw new TypeError(reduceError);
	      memo = obj[keys ? keys[--index] : --index];
	    }
	    while (index--) {
	      currentKey = keys ? keys[index] : index;
	      memo = iteratee(memo, obj[currentKey], currentKey, obj);
	    }
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var result;
	    predicate = _.iteratee(predicate, context);
	    _.some(obj, function(value, index, list) {
	      if (predicate(value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    if (obj == null) return results;
	    predicate = _.iteratee(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(_.iteratee(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    if (obj == null) return true;
	    predicate = _.iteratee(predicate, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index, currentKey;
	    for (index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    if (obj == null) return false;
	    predicate = _.iteratee(predicate, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index, currentKey;
	    for (index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (obj.length !== +obj.length) obj = _.values(obj);
	    return _.indexOf(obj, target) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matches(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matches(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = obj.length === +obj.length ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = obj.length === +obj.length ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = obj && obj.length === +obj.length ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (obj.length !== +obj.length) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = _.iteratee(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = _.iteratee(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = low + high >>> 1;
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return obj.length === +obj.length ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = _.iteratee(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    if (n < 0) return [];
	    return slice.call(array, 0, n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return slice.call(array, Math.max(array.length - n, 0));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    for (var i = 0, length = input.length; i < length; i++) {
	      var value = input[i];
	      if (!_.isArray(value) && !_.isArguments(value)) {
	        if (!strict) output.push(value);
	      } else if (shallow) {
	        push.apply(output, value);
	      } else {
	        flatten(value, shallow, strict, output);
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (array == null) return [];
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = _.iteratee(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = array.length; i < length; i++) {
	      var value = array[i];
	      if (isSorted) {
	        if (!i || seen !== value) result.push(value);
	        seen = value;
	      } else if (iteratee) {
	        var computed = iteratee(value, i, array);
	        if (_.indexOf(seen, computed) < 0) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (_.indexOf(result, value) < 0) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true, []));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    if (array == null) return [];
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = array.length; i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(slice.call(arguments, 1), true, true, []);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function(array) {
	    if (array == null) return [];
	    var length = _.max(arguments, 'length').length;
	    var results = Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var idx = array.length;
	    if (typeof from == 'number') {
	      idx = from < 0 ? idx + from + 1 : Math.min(idx, from + 1);
	    }
	    while (--idx >= 0) if (array[idx] === item) return idx;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Reusable constructor function for prototype setting.
	  var Ctor = function(){};
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    args = slice.call(arguments, 2);
	    bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      Ctor.prototype = func.prototype;
	      var self = new Ctor;
	      Ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (_.isObject(result)) return result;
	      return self;
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    return function() {
	      var position = 0;
	      var args = boundArgs.slice();
	      for (var i = 0, length = args.length; i < length; i++) {
	        if (args[i] === _) args[i] = arguments[position++];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return func.apply(this, args);
	    };
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = hasher ? hasher.apply(this, arguments) : key;
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last > 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed before being called N times.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      } else {
	        func = null;
	      }
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    var source, prop;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	      source = arguments[i];
	      for (prop in source) {
	        if (hasOwnProperty.call(source, prop)) {
	            obj[prop] = source[prop];
	        }
	      }
	    }
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj, iteratee, context) {
	    var result = {}, key;
	    if (obj == null) return result;
	    if (_.isFunction(iteratee)) {
	      iteratee = createCallback(iteratee, context);
	      for (key in obj) {
	        var value = obj[key];
	        if (iteratee(value, key, obj)) result[key] = value;
	      }
	    } else {
	      var keys = concat.apply([], slice.call(arguments, 1));
	      obj = new Object(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        key = keys[i];
	        if (key in obj) result[key] = obj[key];
	      }
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(concat.apply([], slice.call(arguments, 1)), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	      var source = arguments[i];
	      for (var prop in source) {
	        if (obj[prop] === void 0) obj[prop] = source[prop];
	      }
	    }
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (
	      aCtor !== bCtor &&
	      // Handle Object.create(x) cases
	      'constructor' in a && 'constructor' in b &&
	      !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	        _.isFunction(bCtor) && bCtor instanceof bCtor)
	    ) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size, result;
	    // Recursively compare objects and arrays.
	    if (className === '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size === b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      size = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      result = _.keys(b).length === size;
	      if (result) {
	        while (size--) {
	          // Deep compare each member
	          key = keys[size];
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj) || _.isArguments(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around an IE 11 bug.
	  if (typeof /./ !== 'function') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = function(key) {
	    return function(obj) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
	  _.matches = function(attrs) {
	    var pairs = _.pairs(attrs), length = pairs.length;
	    return function(obj) {
	      if (obj == null) return !length;
	      obj = new Object(obj);
	      for (var i = 0; i < length; i++) {
	        var pair = pairs[i], key = pair[0];
	        if (pair[1] !== obj[key] || !(key in obj)) return false;
	      }
	      return true;
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = createCallback(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? object[property]() : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (typeof define === 'function' && define.amd) {
	    define('underscore', [], function() {
	      return _;
	    });
	  }
	}.call(this));
	
	define('Logger',[],function() {
	    return function() {
	        try {
	            window.onerror.apply(window, arguments);
	        } catch (e) {
	
	        }
	    }
	});
	/*
	---
	MooTools: the javascript framework
	
	web build:
	 - http://mootools.net/core/c1f223b3ac0d92e4d6f976c65e2dbc3a
	
	packager build:
	 - packager build Core/Core Core/Array Core/String Core/Number Core/Function Core/Event Core/Class Core/Class.Extras Core/JSON
	
	...
	*/
	
	/*
	---
	
	name: Core
	
	description: The heart of MooTools.
	
	license: MIT-style license.
	
	copyright: Copyright (c) 2006-2012 [Valerio Proietti](http://mad4milk.net/).
	
	authors: The MooTools production team (http://mootools.net/developers/)
	
	inspiration:
	  - Class implementation inspired by [Base.js](http://dean.edwards.name/weblog/2006/03/base/) Copyright (c) 2006 Dean Edwards, [GNU Lesser General Public License](http://opensource.org/licenses/lgpl-license.php)
	  - Some functionality inspired by [Prototype.js](http://prototypejs.org) Copyright (c) 2005-2007 Sam Stephenson, [MIT License](http://opensource.org/licenses/mit-license.php)
	
	provides: [Core, MooTools, Type, typeOf, instanceOf, Native]
	
	...
	*/
	
	(function(){
	
	this.MooTools = {
	    version: '1.4.5',
	    build: 'ab8ea8824dc3b24b6666867a2c4ed58ebb762cf0'
	};
	
	// typeOf, instanceOf
	
	var typeOf = this.typeOf = function(item){
	    if (item == null) return 'null';
	    if (item.$family != null) return item.$family();
	
	    if (item.nodeName){
	        if (item.nodeType == 1) return 'element';
	        if (item.nodeType == 3) return (/\S/).test(item.nodeValue) ? 'textnode' : 'whitespace';
	    } else if (typeof item.length == 'number'){
	        if (item.callee) return 'arguments';
	        if ('item' in item) return 'collection';
	    }
	
	    return typeof item;
	};
	
	var instanceOf = this.instanceOf = function(item, object){
	    if (item == null) return false;
	    var constructor = item.$constructor || item.constructor;
	    while (constructor){
	        if (constructor === object) return true;
	        constructor = constructor.parent;
	    }
	    /*<ltIE8>*/
	    if (!item.hasOwnProperty) return false;
	    /*</ltIE8>*/
	    return item instanceof object;
	};
	
	// Function overloading
	
	var Function = this.Function;
	
	var enumerables = true;
	for (var i in {toString: 1}) enumerables = null;
	if (enumerables) enumerables = ['hasOwnProperty', 'valueOf', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'constructor'];
	
	Function.prototype.overloadSetter = function(usePlural){
	    var self = this;
	    return function(a, b){
	        if (a == null) return this;
	        if (usePlural || typeof a != 'string'){
	            for (var k in a) self.call(this, k, a[k]);
	            if (enumerables) for (var i = enumerables.length; i--;){
	                k = enumerables[i];
	                if (a.hasOwnProperty(k)) self.call(this, k, a[k]);
	            }
	        } else {
	            self.call(this, a, b);
	        }
	        return this;
	    };
	};
	
	Function.prototype.overloadGetter = function(usePlural){
	    var self = this;
	    return function(a){
	        var args, result;
	        if (typeof a != 'string') args = a;
	        else if (arguments.length > 1) args = arguments;
	        else if (usePlural) args = [a];
	        if (args){
	            result = {};
	            for (var i = 0; i < args.length; i++) result[args[i]] = self.call(this, args[i]);
	        } else {
	            result = self.call(this, a);
	        }
	        return result;
	    };
	};
	
	Function.prototype.extend = function(key, value){
	    this[key] = value;
	}.overloadSetter();
	
	Function.prototype.implement = function(key, value){
	    this.prototype[key] = value;
	}.overloadSetter();
	
	// From
	
	var slice = Array.prototype.slice;
	
	Function.from = function(item){
	    return (typeOf(item) == 'function') ? item : function(){
	        return item;
	    };
	};
	
	Array.from = function(item){
	    if (item == null) return [];
	    return (Type.isEnumerable(item) && typeof item != 'string') ? (typeOf(item) == 'array') ? item : slice.call(item) : [item];
	};
	
	Number.from = function(item){
	    var number = parseFloat(item);
	    return isFinite(number) ? number : null;
	};
	
	String.from = function(item){
	    return item + '';
	};
	
	// hide, protect
	
	Function.implement({
	
	    hide: function(){
	        this.$hidden = true;
	        return this;
	    },
	
	    protect: function(){
	        this.$protected = true;
	        return this;
	    }
	
	});
	
	// Type
	
	var Type = this.Type = function(name, object){
	    if (name){
	        var lower = name.toLowerCase();
	        var typeCheck = function(item){
	            return (typeOf(item) == lower);
	        };
	
	        Type['is' + name] = typeCheck;
	        if (object != null){
	            object.prototype.$family = (function(){
	                return lower;
	            }).hide();
	            
	        }
	    }
	
	    if (object == null) return null;
	
	    object.extend(this);
	    object.$constructor = Type;
	    object.prototype.$constructor = object;
	
	    return object;
	};
	
	var toString = Object.prototype.toString;
	
	Type.isEnumerable = function(item){
	    return (item != null && typeof item.length == 'number' && toString.call(item) != '[object Function]' );
	};
	
	var hooks = {};
	
	var hooksOf = function(object){
	    var type = typeOf(object.prototype);
	    return hooks[type] || (hooks[type] = []);
	};
	
	var implement = function(name, method){
	    if (method && method.$hidden) return;
	
	    var hooks = hooksOf(this);
	
	    for (var i = 0; i < hooks.length; i++){
	        var hook = hooks[i];
	        if (typeOf(hook) == 'type') implement.call(hook, name, method);
	        else hook.call(this, name, method);
	    }
	
	    var previous = this.prototype[name];
	    if (previous == null || !previous.$protected) this.prototype[name] = method;
	
	    if (this[name] == null && typeOf(method) == 'function') extend.call(this, name, function(item){
	        return method.apply(item, slice.call(arguments, 1));
	    });
	};
	
	var extend = function(name, method){
	    if (method && method.$hidden) return;
	    var previous = this[name];
	    if (previous == null || !previous.$protected) this[name] = method;
	};
	
	Type.implement({
	
	    implement: implement.overloadSetter(),
	
	    extend: extend.overloadSetter(),
	
	    alias: function(name, existing){
	        implement.call(this, name, this.prototype[existing]);
	    }.overloadSetter(),
	
	    mirror: function(hook){
	        hooksOf(this).push(hook);
	        return this;
	    }
	
	});
	
	new Type('Type', Type);
	
	// Default Types
	
	var force = function(name, object, methods){
	    var isType = (object != Object),
	        prototype = object.prototype;
	
	    if (isType) object = new Type(name, object);
	
	    for (var i = 0, l = methods.length; i < l; i++){
	        var key = methods[i],
	            generic = object[key],
	            proto = prototype[key];
	
	        if (generic) generic.protect();
	        if (isType && proto) object.implement(key, proto.protect());
	    }
	
	    if (isType){
	        var methodsEnumerable = prototype.propertyIsEnumerable(methods[0]);
	        object.forEachMethod = function(fn){
	            if (!methodsEnumerable) for (var i = 0, l = methods.length; i < l; i++){
	                fn.call(prototype, prototype[methods[i]], methods[i]);
	            }
	            for (var key in prototype) fn.call(prototype, prototype[key], key)
	        };
	    }
	
	    return force;
	};
	
	force('String', String, [
	    'charAt', 'charCodeAt', 'concat', 'indexOf', 'lastIndexOf', 'match', 'quote', 'replace', 'search',
	    'slice', 'split', 'substr', 'substring', 'trim', 'toLowerCase', 'toUpperCase'
	])('Array', Array, [
	    'pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift', 'concat', 'join', 'slice',
	    'indexOf', 'lastIndexOf', 'filter', 'forEach', 'every', 'map', 'some', 'reduce', 'reduceRight'
	])('Number', Number, [
	    'toExponential', 'toFixed', 'toLocaleString', 'toPrecision'
	])('Function', Function, [
	    'apply', 'call', 'bind'
	])('RegExp', RegExp, [
	    'exec', 'test'
	])('Object', Object, [
	    'create', 'defineProperty', 'defineProperties', 'keys',
	    'getPrototypeOf', 'getOwnPropertyDescriptor', 'getOwnPropertyNames',
	    'preventExtensions', 'isExtensible', 'seal', 'isSealed', 'freeze', 'isFrozen'
	])('Date', Date, ['now']);
	
	Object.extend = extend.overloadSetter();
	
	Date.extend('now', function(){
	    return +(new Date);
	});
	
	new Type('Boolean', Boolean);
	
	// fixes NaN returning as Number
	
	Number.prototype.$family = function(){
	    return isFinite(this) ? 'number' : 'null';
	}.hide();
	
	// Number.random
	
	Number.extend('random', function(min, max){
	    return Math.floor(Math.random() * (max - min + 1) + min);
	});
	
	// forEach, each
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	Object.extend('forEach', function(object, fn, bind){
	    for (var key in object){
	        if (hasOwnProperty.call(object, key)) fn.call(bind, object[key], key, object);
	    }
	});
	
	Object.each = Object.forEach;
	
	Array.implement({
	
	    forEach: function(fn, bind){
	        for (var i = 0, l = this.length; i < l; i++){
	            if (i in this) fn.call(bind, this[i], i, this);
	        }
	    },
	
	    each: function(fn, bind){
	        Array.forEach(this, fn, bind);
	        return this;
	    }
	
	});
	
	// Array & Object cloning, Object merging and appending
	
	var cloneOf = function(item){
	    switch (typeOf(item)){
	        case 'array': return item.clone();
	        case 'object': return Object.clone(item);
	        default: return item;
	    }
	};
	
	Array.implement('clone', function(){
	    var i = this.length, clone = new Array(i);
	    while (i--) clone[i] = cloneOf(this[i]);
	    return clone;
	});
	
	var mergeOne = function(source, key, current){
	    switch (typeOf(current)){
	        case 'object':
	            if (typeOf(source[key]) == 'object') Object.merge(source[key], current);
	            else source[key] = Object.clone(current);
	        break;
	        case 'array': source[key] = current.clone(); break;
	        default: source[key] = current;
	    }
	    return source;
	};
	
	Object.extend({
	
	    merge: function(source, k, v){
	        if (typeOf(k) == 'string') return mergeOne(source, k, v);
	        for (var i = 1, l = arguments.length; i < l; i++){
	            var object = arguments[i];
	            for (var key in object) mergeOne(source, key, object[key]);
	        }
	        return source;
	    },
	
	    clone: function(object){
	        var clone = {};
	        for (var key in object) clone[key] = cloneOf(object[key]);
	        return clone;
	    },
	
	    append: function(original){
	        for (var i = 1, l = arguments.length; i < l; i++){
	            var extended = arguments[i] || {};
	            for (var key in extended) original[key] = extended[key];
	        }
	        return original;
	    }
	
	});
	
	// Object-less types
	
	['Object', 'WhiteSpace', 'TextNode', 'Collection', 'Arguments'].each(function(name){
	    new Type(name);
	});
	
	// Unique ID
	
	var UID = Date.now();
	
	String.extend('uniqueID', function(){
	    return (UID++).toString(36);
	});
	
	
	
	})();
	
	
	/*
	---
	
	name: Array
	
	description: Contains Array Prototypes like each, contains, and erase.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Array
	
	...
	*/
	
	Array.implement({
	
	    /*<!ES5>*/
	    every: function(fn, bind){
	        for (var i = 0, l = this.length >>> 0; i < l; i++){
	            if ((i in this) && !fn.call(bind, this[i], i, this)) return false;
	        }
	        return true;
	    },
	
	    filter: function(fn, bind){
	        var results = [];
	        for (var value, i = 0, l = this.length >>> 0; i < l; i++) if (i in this){
	            value = this[i];
	            if (fn.call(bind, value, i, this)) results.push(value);
	        }
	        return results;
	    },
	
	    indexOf: function(item, from){
	        var length = this.length >>> 0;
	        for (var i = (from < 0) ? Math.max(0, length + from) : from || 0; i < length; i++){
	            if (this[i] === item) return i;
	        }
	        return -1;
	    },
	
	    map: function(fn, bind){
	        var length = this.length >>> 0, results = Array(length);
	        for (var i = 0; i < length; i++){
	            if (i in this) results[i] = fn.call(bind, this[i], i, this);
	        }
	        return results;
	    },
	
	    some: function(fn, bind){
	        for (var i = 0, l = this.length >>> 0; i < l; i++){
	            if ((i in this) && fn.call(bind, this[i], i, this)) return true;
	        }
	        return false;
	    },
	    /*</!ES5>*/
	
	    clean: function(){
	        return this.filter(function(item){
	            return item != null;
	        });
	    },
	
	    invoke: function(methodName){
	        var args = Array.slice(arguments, 1);
	        return this.map(function(item){
	            return item[methodName].apply(item, args);
	        });
	    },
	
	    associate: function(keys){
	        var obj = {}, length = Math.min(this.length, keys.length);
	        for (var i = 0; i < length; i++) obj[keys[i]] = this[i];
	        return obj;
	    },
	
	    link: function(object){
	        var result = {};
	        for (var i = 0, l = this.length; i < l; i++){
	            for (var key in object){
	                if (object[key](this[i])){
	                    result[key] = this[i];
	                    delete object[key];
	                    break;
	                }
	            }
	        }
	        return result;
	    },
	
	    contains: function(item, from){
	        return this.indexOf(item, from) != -1;
	    },
	
	    append: function(array){
	        this.push.apply(this, array);
	        return this;
	    },
	
	    getLast: function(){
	        return (this.length) ? this[this.length - 1] : null;
	    },
	
	    getRandom: function(){
	        return (this.length) ? this[Number.random(0, this.length - 1)] : null;
	    },
	
	    include: function(item){
	        if (!this.contains(item)) this.push(item);
	        return this;
	    },
	
	    combine: function(array){
	        for (var i = 0, l = array.length; i < l; i++) this.include(array[i]);
	        return this;
	    },
	
	    erase: function(item){
	        for (var i = this.length; i--;){
	            if (this[i] === item) this.splice(i, 1);
	        }
	        return this;
	    },
	
	    empty: function(){
	        this.length = 0;
	        return this;
	    },
	
	    flatten: function(){
	        var array = [];
	        for (var i = 0, l = this.length; i < l; i++){
	            var type = typeOf(this[i]);
	            if (type == 'null') continue;
	            array = array.concat((type == 'array' || type == 'collection' || type == 'arguments' || instanceOf(this[i], Array)) ? Array.flatten(this[i]) : this[i]);
	        }
	        return array;
	    },
	
	    pick: function(){
	        for (var i = 0, l = this.length; i < l; i++){
	            if (this[i] != null) return this[i];
	        }
	        return null;
	    },
	
	    hexToRgb: function(array){
	        if (this.length != 3) return null;
	        var rgb = this.map(function(value){
	            if (value.length == 1) value += value;
	            return value.toInt(16);
	        });
	        return (array) ? rgb : 'rgb(' + rgb + ')';
	    },
	
	    rgbToHex: function(array){
	        if (this.length < 3) return null;
	        if (this.length == 4 && this[3] == 0 && !array) return 'transparent';
	        var hex = [];
	        for (var i = 0; i < 3; i++){
	            var bit = (this[i] - 0).toString(16);
	            hex.push((bit.length == 1) ? '0' + bit : bit);
	        }
	        return (array) ? hex : '#' + hex.join('');
	    }
	
	});
	
	
	
	
	/*
	---
	
	name: String
	
	description: Contains String Prototypes like camelCase, capitalize, test, and toInt.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: String
	
	...
	*/
	
	String.implement({
	
	    test: function(regex, params){
	        return ((typeOf(regex) == 'regexp') ? regex : new RegExp('' + regex, params)).test(this);
	    },
	
	    contains: function(string, separator){
	        return (separator) ? (separator + this + separator).indexOf(separator + string + separator) > -1 : String(this).indexOf(string) > -1;
	    },
	
	    trim: function(){
	        return String(this).replace(/^\s+|\s+$/g, '');
	    },
	
	    clean: function(){
	        return String(this).replace(/\s+/g, ' ').trim();
	    },
	
	    camelCase: function(){
	        return String(this).replace(/-\D/g, function(match){
	            return match.charAt(1).toUpperCase();
	        });
	    },
	
	    hyphenate: function(){
	        return String(this).replace(/[A-Z]/g, function(match){
	            return ('-' + match.charAt(0).toLowerCase());
	        });
	    },
	
	    capitalize: function(){
	        return String(this).replace(/\b[a-z]/g, function(match){
	            return match.toUpperCase();
	        });
	    },
	
	    escapeRegExp: function(){
	        return String(this).replace(/([-.*+?^{$}()|[\]\/\\])/g, '\\$1');
	    },
	
	    toInt: function(base){
	        return parseInt(this, base || 10);
	    },
	
	    toFloat: function(){
	        return parseFloat(this);
	    },
	
	    hexToRgb: function(array){
	        var hex = String(this).match(/^#?(\w{1,2})(\w{1,2})(\w{1,2})$/);
	        return (hex) ? hex.slice(1).hexToRgb(array) : null;
	    },
	
	    rgbToHex: function(array){
	        var rgb = String(this).match(/\d{1,3}/g);
	        return (rgb) ? rgb.rgbToHex(array) : null;
	    },
	
	    substitute: function(object, regexp){
	        return String(this).replace(regexp || (/\\?\{([^{}]+)\}/g), function(match, name){
	            if (match.charAt(0) == '\\') return match.slice(1);
	            return (object[name] != null) ? object[name] : '';
	        });
	    }
	
	});
	
	
	/*
	---
	
	name: Number
	
	description: Contains Number Prototypes like limit, round, times, and ceil.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Number
	
	...
	*/
	
	Number.implement({
	
	    limit: function(min, max){
	        return Math.min(max, Math.max(min, this));
	    },
	
	    round: function(precision){
	        precision = Math.pow(10, precision || 0).toFixed(precision < 0 ? -precision : 0);
	        return Math.round(this * precision) / precision;
	    },
	
	    times: function(fn, bind){
	        for (var i = 0; i < this; i++) fn.call(bind, i, this);
	    },
	
	    toFloat: function(){
	        return parseFloat(this);
	    },
	
	    toInt: function(base){
	        return parseInt(this, base || 10);
	    }
	
	});
	
	Number.alias('each', 'times');
	
	(function(math){
	    var methods = {};
	    math.each(function(name){
	        if (!Number[name]) methods[name] = function(){
	            return Math[name].apply(null, [this].concat(Array.from(arguments)));
	        };
	    });
	    Number.implement(methods);
	})(['abs', 'acos', 'asin', 'atan', 'atan2', 'ceil', 'cos', 'exp', 'floor', 'log', 'max', 'min', 'pow', 'sin', 'sqrt', 'tan']);
	
	
	/*
	---
	
	name: Function
	
	description: Contains Function Prototypes like create, bind, pass, and delay.
	
	license: MIT-style license.
	
	requires: Type
	
	provides: Function
	
	...
	*/
	
	Function.extend({
	
	    attempt: function(){
	        for (var i = 0, l = arguments.length; i < l; i++){
	            try {
	                return arguments[i]();
	            } catch (e){}
	        }
	        return null;
	    }
	
	});
	
	Function.implement({
	
	    attempt: function(args, bind){
	        try {
	            return this.apply(bind, Array.from(args));
	        } catch (e){}
	
	        return null;
	    },
	
	    /*<!ES5-bind>*/
	    bind: function(that){
	        var self = this,
	            args = arguments.length > 1 ? Array.slice(arguments, 1) : null,
	            F = function(){};
	
	        var bound = function(){
	            var context = that, length = arguments.length;
	            if (this instanceof bound){
	                F.prototype = self.prototype;
	                context = new F;
	            }
	            var result = (!args && !length)
	                ? self.call(context)
	                : self.apply(context, args && length ? args.concat(Array.slice(arguments)) : args || arguments);
	            return context == that ? result : context;
	        };
	        return bound;
	    },
	    /*</!ES5-bind>*/
	
	    pass: function(args, bind){
	        var self = this;
	        if (args != null) args = Array.from(args);
	        return function(){
	            return self.apply(bind, args || arguments);
	        };
	    },
	
	    delay: function(delay, bind, args){
	        return setTimeout(this.pass((args == null ? [] : args), bind), delay);
	    },
	
	    periodical: function(periodical, bind, args){
	        return setInterval(this.pass((args == null ? [] : args), bind), periodical);
	    }
	
	});
	
	
	
	
	/*
	---
	
	name: Browser
	
	description: The Browser Object. Contains Browser initialization, Window and Document, and the Browser Hash.
	
	license: MIT-style license.
	
	requires: [Array, Function, Number, String]
	
	provides: [Browser, Window, Document]
	
	...
	*/
	
	(function(){
	
	var document = this.document;
	var window = document.window = this;
	
	var ua = navigator.userAgent.toLowerCase(),
	    platform = navigator.platform.toLowerCase(),
	    UA = ua.match(/(opera|ie|firefox|chrome|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/) || [null, 'unknown', 0],
	    mode = UA[1] == 'ie' && document.documentMode;
	
	var Browser = this.Browser = {
	
	    extend: Function.prototype.extend,
	
	    name: (UA[1] == 'version') ? UA[3] : UA[1],
	
	    version: mode || parseFloat((UA[1] == 'opera' && UA[4]) ? UA[4] : UA[2]),
	
	    Platform: {
	        name: ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
	    },
	
	    Features: {
	        xpath: !!(document.evaluate),
	        air: !!(window.runtime),
	        query: !!(document.querySelector),
	        json: !!(window.JSON)
	    },
	
	    Plugins: {}
	
	};
	
	Browser[Browser.name] = true;
	Browser[Browser.name + parseInt(Browser.version, 10)] = true;
	Browser.Platform[Browser.Platform.name] = true;
	
	// Request
	
	Browser.Request = (function(){
	
	    var XMLHTTP = function(){
	        return new XMLHttpRequest();
	    };
	
	    var MSXML2 = function(){
	        return new ActiveXObject('MSXML2.XMLHTTP');
	    };
	
	    var MSXML = function(){
	        return new ActiveXObject('Microsoft.XMLHTTP');
	    };
	
	    return Function.attempt(function(){
	        XMLHTTP();
	        return XMLHTTP;
	    }, function(){
	        MSXML2();
	        return MSXML2;
	    }, function(){
	        MSXML();
	        return MSXML;
	    });
	
	})();
	
	Browser.Features.xhr = !!(Browser.Request);
	
	// Flash detection
	
	var version = (Function.attempt(function(){
	    return navigator.plugins['Shockwave Flash'].description;
	}, function(){
	    return new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version');
	}) || '0 r0').match(/\d+/g);
	
	Browser.Plugins.Flash = {
	    version: Number(version[0] || '0.' + version[1]) || 0,
	    build: Number(version[2]) || 0
	};
	
	// String scripts
	
	Browser.exec = function(text){
	    if (!text) return text;
	    if (window.execScript){
	        window.execScript(text);
	    } else {
	        var script = document.createElement('script');
	        script.setAttribute('type', 'text/javascript');
	        script.text = text;
	        document.head.appendChild(script);
	        document.head.removeChild(script);
	    }
	    return text;
	};
	
	String.implement('stripScripts', function(exec){
	    var scripts = '';
	    var text = this.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, function(all, code){
	        scripts += code + '\n';
	        return '';
	    });
	    if (exec === true) Browser.exec(scripts);
	    else if (typeOf(exec) == 'function') exec(scripts, text);
	    return text;
	});
	
	// Window, Document
	
	Browser.extend({
	    Document: this.Document,
	    Window: this.Window,
	    Element: this.Element,
	    Event: this.Event
	});
	
	this.Window = this.$constructor = new Type('Window', function(){});
	
	this.$family = Function.from('window').hide();
	
	Window.mirror(function(name, method){
	    window[name] = method;
	});
	
	this.Document = document.$constructor = new Type('Document', function(){});
	
	document.$family = Function.from('document').hide();
	
	Document.mirror(function(name, method){
	    document[name] = method;
	});
	
	document.html = document.documentElement;
	if (!document.head) document.head = document.getElementsByTagName('head')[0];
	
	if (document.execCommand) try {
	    document.execCommand("BackgroundImageCache", false, true);
	} catch (e){}
	
	/*<ltIE9>*/
	if (this.attachEvent && !this.addEventListener){
	    var unloadEvent = function(){
	        this.detachEvent('onunload', unloadEvent);
	        document.head = document.html = document.window = null;
	    };
	    this.attachEvent('onunload', unloadEvent);
	}
	
	// IE fails on collections and <select>.options (refers to <select>)
	var arrayFrom = Array.from;
	try {
	    arrayFrom(document.html.childNodes);
	} catch(e){
	    Array.from = function(item){
	        if (typeof item != 'string' && Type.isEnumerable(item) && typeOf(item) != 'array'){
	            var i = item.length, array = new Array(i);
	            while (i--) array[i] = item[i];
	            return array;
	        }
	        return arrayFrom(item);
	    };
	
	    var prototype = Array.prototype,
	        slice = prototype.slice;
	    ['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift', 'concat', 'join', 'slice'].each(function(name){
	        var method = prototype[name];
	        Array[name] = function(item){
	            return method.apply(Array.from(item), slice.call(arguments, 1));
	        };
	    });
	}
	/*</ltIE9>*/
	
	
	
	})();
	
	
	/*
	---
	
	name: Object
	
	description: Object generic methods
	
	license: MIT-style license.
	
	requires: Type
	
	provides: [Object, Hash]
	
	...
	*/
	
	(function(){
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	Object.extend({
	
	    subset: function(object, keys){
	        var results = {};
	        for (var i = 0, l = keys.length; i < l; i++){
	            var k = keys[i];
	            if (k in object) results[k] = object[k];
	        }
	        return results;
	    },
	
	    map: function(object, fn, bind){
	        var results = {};
	        for (var key in object){
	            if (hasOwnProperty.call(object, key)) results[key] = fn.call(bind, object[key], key, object);
	        }
	        return results;
	    },
	
	    filter: function(object, fn, bind){
	        var results = {};
	        for (var key in object){
	            var value = object[key];
	            if (hasOwnProperty.call(object, key) && fn.call(bind, value, key, object)) results[key] = value;
	        }
	        return results;
	    },
	
	    every: function(object, fn, bind){
	        for (var key in object){
	            if (hasOwnProperty.call(object, key) && !fn.call(bind, object[key], key)) return false;
	        }
	        return true;
	    },
	
	    some: function(object, fn, bind){
	        for (var key in object){
	            if (hasOwnProperty.call(object, key) && fn.call(bind, object[key], key)) return true;
	        }
	        return false;
	    },
	
	    keys: function(object){
	        var keys = [];
	        for (var key in object){
	            if (hasOwnProperty.call(object, key)) keys.push(key);
	        }
	        return keys;
	    },
	
	    values: function(object){
	        var values = [];
	        for (var key in object){
	            if (hasOwnProperty.call(object, key)) values.push(object[key]);
	        }
	        return values;
	    },
	
	    getLength: function(object){
	        return Object.keys(object).length;
	    },
	
	    keyOf: function(object, value){
	        for (var key in object){
	            if (hasOwnProperty.call(object, key) && object[key] === value) return key;
	        }
	        return null;
	    },
	
	    contains: function(object, value){
	        return Object.keyOf(object, value) != null;
	    },
	
	    toQueryString: function(object, base){
	        var queryString = [];
	
	        Object.each(object, function(value, key){
	            if (base) key = base + '[' + key + ']';
	            var result;
	            switch (typeOf(value)){
	                case 'object': result = Object.toQueryString(value, key); break;
	                case 'array':
	                    var qs = {};
	                    value.each(function(val, i){
	                        qs[i] = val;
	                    });
	                    result = Object.toQueryString(qs, key);
	                break;
	                default: result = key + '=' + encodeURIComponent(value);
	            }
	            if (value != null) queryString.push(result);
	        });
	
	        return queryString.join('&');
	    }
	
	});
	
	})();
	
	
	
	
	/*
	---
	
	name: Event
	
	description: Contains the Event Type, to make the event object cross-browser.
	
	license: MIT-style license.
	
	requires: [Window, Document, Array, Function, String, Object]
	
	provides: Event
	
	...
	*/
	
	(function() {
	
	var _keys = {};
	
	var DOMEvent = this.DOMEvent = new Type('DOMEvent', function(event, win){
	    if (!win) win = window;
	    event = event || win.event;
	    if (event.$extended) return event;
	    this.event = event;
	    this.$extended = true;
	    this.shift = event.shiftKey;
	    this.control = event.ctrlKey;
	    this.alt = event.altKey;
	    this.meta = event.metaKey;
	    var type = this.type = event.type;
	    var target = event.target || event.srcElement;
	    while (target && target.nodeType == 3) target = target.parentNode;
	    this.target = document.id(target);
	
	    if (type.indexOf('key') == 0){
	        var code = this.code = (event.which || event.keyCode);
	        this.key = _keys[code];
	        if (type == 'keydown'){
	            if (code > 111 && code < 124) this.key = 'f' + (code - 111);
	            else if (code > 95 && code < 106) this.key = code - 96;
	        }
	        if (this.key == null) this.key = String.fromCharCode(code).toLowerCase();
	    } else if (type == 'click' || type == 'dblclick' || type == 'contextmenu' || type == 'DOMMouseScroll' || type.indexOf('mouse') == 0){
	        var doc = win.document;
	        doc = (!doc.compatMode || doc.compatMode == 'CSS1Compat') ? doc.html : doc.body;
	        this.page = {
	            x: (event.pageX != null) ? event.pageX : event.clientX + doc.scrollLeft,
	            y: (event.pageY != null) ? event.pageY : event.clientY + doc.scrollTop
	        };
	        this.client = {
	            x: (event.pageX != null) ? event.pageX - win.pageXOffset : event.clientX,
	            y: (event.pageY != null) ? event.pageY - win.pageYOffset : event.clientY
	        };
	        if (type == 'DOMMouseScroll' || type == 'mousewheel')
	            this.wheel = (event.wheelDelta) ? event.wheelDelta / 120 : -(event.detail || 0) / 3;
	
	        this.rightClick = (event.which == 3 || event.button == 2);
	        if (type == 'mouseover' || type == 'mouseout'){
	            var related = event.relatedTarget || event[(type == 'mouseover' ? 'from' : 'to') + 'Element'];
	            while (related && related.nodeType == 3) related = related.parentNode;
	            this.relatedTarget = document.id(related);
	        }
	    } else if (type.indexOf('touch') == 0 || type.indexOf('gesture') == 0){
	        this.rotation = event.rotation;
	        this.scale = event.scale;
	        this.targetTouches = event.targetTouches;
	        this.changedTouches = event.changedTouches;
	        var touches = this.touches = event.touches;
	        if (touches && touches[0]){
	            var touch = touches[0];
	            this.page = {x: touch.pageX, y: touch.pageY};
	            this.client = {x: touch.clientX, y: touch.clientY};
	        }
	    }
	
	    if (!this.client) this.client = {};
	    if (!this.page) this.page = {};
	});
	
	DOMEvent.implement({
	
	    stop: function(){
	        return this.preventDefault().stopPropagation();
	    },
	
	    stopPropagation: function(){
	        if (this.event.stopPropagation) this.event.stopPropagation();
	        else this.event.cancelBubble = true;
	        return this;
	    },
	
	    preventDefault: function(){
	        if (this.event.preventDefault) this.event.preventDefault();
	        else this.event.returnValue = false;
	        return this;
	    }
	
	});
	
	DOMEvent.defineKey = function(code, key){
	    _keys[code] = key;
	    return this;
	};
	
	DOMEvent.defineKeys = DOMEvent.defineKey.overloadSetter(true);
	
	DOMEvent.defineKeys({
	    '38': 'up', '40': 'down', '37': 'left', '39': 'right',
	    '27': 'esc', '32': 'space', '8': 'backspace', '9': 'tab',
	    '46': 'delete', '13': 'enter'
	});
	
	})();
	
	
	
	
	
	
	/*
	---
	
	name: Class
	
	description: Contains the Class Function for easily creating, extending, and implementing reusable Classes.
	
	license: MIT-style license.
	
	requires: [Array, String, Function, Number]
	
	provides: Class
	
	...
	*/
	
	(function(){
	
	var Class = this.Class = new Type('Class', function(params){
	    if (instanceOf(params, Function)) params = {initialize: params};
	
	    var newClass = function(){
	        reset(this);
	        if (newClass.$prototyping) return this;
	        this.$caller = null;
	        var value = (this.initialize) ? this.initialize.apply(this, arguments) : this;
	        this.$caller = this.caller = null;
	        return value;
	    }.extend(this).implement(params);
	
	    newClass.$constructor = Class;
	    newClass.prototype.$constructor = newClass;
	    newClass.prototype.parent = parent;
	
	    return newClass;
	});
	
	var parent = function(){
	    if (!this.$caller) throw new Error('The method "parent" cannot be called.');
	    var name = this.$caller.$name,
	        parent = this.$caller.$owner.parent,
	        previous = (parent) ? parent.prototype[name] : null;
	    if (!previous) throw new Error('The method "' + name + '" has no parent.');
	    return previous.apply(this, arguments);
	};
	
	var reset = function(object){
	    for (var key in object){
	        var value = object[key];
	        switch (typeOf(value)){
	            case 'object':
	                var F = function(){};
	                F.prototype = value;
	                object[key] = reset(new F);
	            break;
	            case 'array': object[key] = value.clone(); break;
	        }
	    }
	    return object;
	};
	
	var wrap = function(self, key, method){
	    if (method.$origin) method = method.$origin;
	    var wrapper = function(){
	        if (method.$protected && this.$caller == null) throw new Error('The method "' + key + '" cannot be called.');
	        var caller = this.caller, current = this.$caller;
	        this.caller = current; this.$caller = wrapper;
	        var result = method.apply(this, arguments);
	        this.$caller = current; this.caller = caller;
	        return result;
	    }.extend({$owner: self, $origin: method, $name: key});
	    return wrapper;
	};
	
	var implement = function(key, value, retain){
	    if (Class.Mutators.hasOwnProperty(key)){
	        value = Class.Mutators[key].call(this, value);
	        if (value == null) return this;
	    }
	
	    if (typeOf(value) == 'function'){
	        if (value.$hidden) return this;
	        this.prototype[key] = (retain) ? value : wrap(this, key, value);
	    } else {
	        Object.merge(this.prototype, key, value);
	    }
	
	    return this;
	};
	
	var getInstance = function(klass){
	    klass.$prototyping = true;
	    var proto = new klass;
	    delete klass.$prototyping;
	    return proto;
	};
	
	Class.implement('implement', implement.overloadSetter());
	
	Class.Mutators = {
	
	    Extends: function(parent){
	        this.parent = parent;
	        this.prototype = getInstance(parent);
	    },
	
	    Implements: function(items){
	        Array.from(items).each(function(item){
	            var instance = new item;
	            for (var key in instance) implement.call(this, key, instance[key], true);
	        }, this);
	    }
	};
	
	})();
	
	
	/*
	---
	
	name: Class.Extras
	
	description: Contains Utility Classes that can be implemented into your own Classes to ease the execution of many common tasks.
	
	license: MIT-style license.
	
	requires: Class
	
	provides: [Class.Extras, Chain, Events, Options]
	
	...
	*/
	
	(function(){
	
	this.Chain = new Class({
	
	    $chain: [],
	
	    chain: function(){
	        this.$chain.append(Array.flatten(arguments));
	        return this;
	    },
	
	    callChain: function(){
	        return (this.$chain.length) ? this.$chain.shift().apply(this, arguments) : false;
	    },
	
	    clearChain: function(){
	        this.$chain.empty();
	        return this;
	    }
	
	});
	
	var removeOn = function(string){
	    return string.replace(/^on([A-Z])/, function(full, first){
	        return first.toLowerCase();
	    });
	};
	
	this.Events = new Class({
	
	    $events: {},
	
	    addEvent: function(type, fn, internal){
	        type = removeOn(type);
	
	        
	
	        this.$events[type] = (this.$events[type] || []).include(fn);
	        if (internal) fn.internal = true;
	        return this;
	    },
	
	    addEvents: function(events){
	        for (var type in events) this.addEvent(type, events[type]);
	        return this;
	    },
	
	    fireEvent: function(type, args, delay){
	        type = removeOn(type);
	        var events = this.$events[type];
	        if (!events) return this;
	        args = Array.from(args);
	        events.each(function(fn){
	            if (delay) fn.delay(delay, this, args);
	            else fn.apply(this, args);
	        }, this);
	        return this;
	    },
	
	    removeEvent: function(type, fn){
	        type = removeOn(type);
	        var events = this.$events[type];
	        if (events && !fn.internal){
	            var index =  events.indexOf(fn);
	            if (index != -1) delete events[index];
	        }
	        return this;
	    },
	
	    removeEvents: function(events){
	        var type;
	        if (typeOf(events) == 'object'){
	            for (type in events) this.removeEvent(type, events[type]);
	            return this;
	        }
	        if (events) events = removeOn(events);
	        for (type in this.$events){
	            if (events && events != type) continue;
	            var fns = this.$events[type];
	            for (var i = fns.length; i--;) if (i in fns){
	                this.removeEvent(type, fns[i]);
	            }
	        }
	        return this;
	    }
	
	});
	
	this.Options = new Class({
	
	    setOptions: function(){
	        var options = this.options = Object.merge.apply(null, [{}, this.options].append(arguments));
	        if (this.addEvent) for (var option in options){
	            if (typeOf(options[option]) != 'function' || !(/^on[A-Z]/).test(option)) continue;
	            this.addEvent(option, options[option]);
	            delete options[option];
	        }
	        return this;
	    }
	
	});
	
	})();
	
	
	/*
	---
	
	name: JSON
	
	description: JSON encoder and decoder.
	
	license: MIT-style license.
	
	SeeAlso: <http://www.json.org/>
	
	requires: [Array, String, Number, Function]
	
	provides: JSON
	
	...
	*/
	
	if (typeof JSON == 'undefined') this.JSON = {};
	
	
	
	(function(){
	
	var special = {'\b': '\\b', '\t': '\\t', '\n': '\\n', '\f': '\\f', '\r': '\\r', '"' : '\\"', '\\': '\\\\'};
	
	var escape = function(chr){
	    return special[chr] || '\\u' + ('0000' + chr.charCodeAt(0).toString(16)).slice(-4);
	};
	
	JSON.validate = function(string){
	    string = string.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@').
	                    replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
	                    replace(/(?:^|:|,)(?:\s*\[)+/g, '');
	
	    return (/^[\],:{}\s]*$/).test(string);
	};
	
	JSON.encode = JSON.stringify ? function(obj){
	    return JSON.stringify(obj);
	} : function(obj){
	    if (obj && obj.toJSON) obj = obj.toJSON();
	
	    switch (typeOf(obj)){
	        case 'string':
	            return '"' + obj.replace(/[\x00-\x1f\\"]/g, escape) + '"';
	        case 'array':
	            return '[' + obj.map(JSON.encode).clean() + ']';
	        case 'object': case 'hash':
	            var string = [];
	            Object.each(obj, function(value, key){
	                var json = JSON.encode(value);
	                if (json) string.push(JSON.encode(key) + ':' + json);
	            });
	            return '{' + string + '}';
	        case 'number': case 'boolean': return '' + obj;
	        case 'null': return 'null';
	    }
	
	    return null;
	};
	
	JSON.decode = function(string, secure){
	    if (!string || typeOf(string) != 'string') return null;
	
	    if (secure || JSON.secure){
	        if (JSON.parse) return JSON.parse(string);
	        if (!JSON.validate(string)) throw new Error('JSON could not decode the input; security is enabled and the value is not secure.');
	    }
	
	    return eval('(' + string + ')');
	};
	
	})();
	
	
	define("mootools", function(){});
	
	define('galileo/prototype/function',['require','mootools'],function(require) {
	
	    require("mootools");
	
	    Function.extend({
	        id: function (x) {
	            return x;
	        },
	
	        takeKey: function() {
	            var args = Array.from(arguments);
	            return function(o) {
	                var myArgs = args.slice(0);
	                while(myArgs.length) o = o[ myArgs.shift() ];
	                return o;
	            }
	        },
	
	        join: function() {
	            var fns = Array.from(arguments),
	                k = fns.pop(),
	                results = [],
	                ctxt = this,
	                taken = 0;
	            fns.map(function(fn, ii) { 
	                fn(function(result) {
	                    if(!(ii in results)) taken++; 
	                    results[ii] = result; 
	                    if(taken == fns.length) k.apply(ctxt, results);
	                }); 
	            });
	        }
	    });
	});
	
	
	define('galileo/prototype/array',['require','mootools'],function(require) {
	    require('mootools')
	
	    Array.implement({
	        reindex: function(indices) {
	            var ret = [];
	            for(var ii = 0; ii < indices.length; ii++) {
	                ret[ii] = this[indices[ii]];
	            }
	            return ret;
	        },
	
	        sortBy: function(picker) {
	            this.sort(function(x,y) {
	                var px = picker(x), py = picker(y);
	                return px < py ? -1 : (px > py ? 1 : 0);
	            });
	            return this;
	        },
	
	        group: function(n) {
	            if(this.length < n) return [];
	            var ret = this.slice(1).group(n);
	            ret.unshift(this.slice(0,n));
	            return ret;
	        },
	
	        zipWith: function(that, fn) {
	            var len = Math.min(this.length, that.length), ret = [];
	            for(var ii = 0; ii < len; ii++) {
	                ret.push(fn(this[ii], that[ii], ii));
	            }
	            return ret;
	        },
	
	        shuffle: function() {
	            for (var i = this.length - 1; i > 0; i--) {
	                var j = Math.floor(Math.random() * (i + 1));
	                var tmp = this[i];
	                this[i] = this[j];
	                this[j] = tmp;
	            }
	            return this;
	        },
	
	        find: function(testFunction) {
	            for (var i = 0; i < this.length; i++) {
	                if(testFunction(this[i]) === true) {
	                    return this[i];
	                }
	            }
	            return null;
	        }
	
	    });
	});
	
	define('galileo/prototype/number',['require','mootools'],function(require) {
	    require("mootools");
	
	    Number.withDigits = function(x, n) {
	        return Math.round(x * Math.pow(10, n)) / Math.pow(10,n);
	    };
	
	    Number.implement({
	        //Javascript modulo operator does not work
	        //correctly with negative numbers
	        mod:function(n) {
	           return ((this%n)+n)%n;
	        }
	    });
	});
	
	define('galileo/prototype/all',['require','./function','./array','./number'],function(require) {
	    require("./function");
	    require("./array");
	    require("./number");
	});
	
	/**
	 * Copyright 2010 Tim Down.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Hashtable=(function(){var p="function";var n=(typeof Array.prototype.splice==p)?function(s,r){s.splice(r,1)}:function(u,t){var s,v,r;if(t===u.length-1){u.length=t}else{s=u.slice(t+1);u.length=t;for(v=0,r=s.length;v<r;++v){u[t+v]=s[v]}}};function a(t){var r;if(typeof t=="string"){return t}else{if(typeof t.hashCode==p){r=t.hashCode();return(typeof r=="string")?r:a(r)}else{if(typeof t.toString==p){return t.toString()}else{try{return String(t)}catch(s){return Object.prototype.toString.call(t)}}}}}function g(r,s){return r.equals(s)}function e(r,s){return(typeof s.equals==p)?s.equals(r):(r===s)}function c(r){return function(s){if(s===null){throw new Error("null is not a valid "+r)}else{if(typeof s=="undefined"){throw new Error(r+" must not be undefined")}}}}var q=c("key"),l=c("value");function d(u,s,t,r){this[0]=u;this.entries=[];this.addEntry(s,t);if(r!==null){this.getEqualityFunction=function(){return r}}}var h=0,j=1,f=2;function o(r){return function(t){var s=this.entries.length,v,u=this.getEqualityFunction(t);while(s--){v=this.entries[s];if(u(t,v[0])){switch(r){case h:return true;case j:return v;case f:return[s,v[1]]}}}return false}}function k(r){return function(u){var v=u.length;for(var t=0,s=this.entries.length;t<s;++t){u[v+t]=this.entries[t][r]}}}d.prototype={getEqualityFunction:function(r){return(typeof r.equals==p)?g:e},getEntryForKey:o(j),getEntryAndIndexForKey:o(f),removeEntryForKey:function(s){var r=this.getEntryAndIndexForKey(s);if(r){n(this.entries,r[0]);return r[1]}return null},addEntry:function(r,s){this.entries[this.entries.length]=[r,s]},keys:k(0),values:k(1),getEntries:function(s){var u=s.length;for(var t=0,r=this.entries.length;t<r;++t){s[u+t]=this.entries[t].slice(0)}},containsKey:o(h),containsValue:function(s){var r=this.entries.length;while(r--){if(s===this.entries[r][1]){return true}}return false}};function m(s,t){var r=s.length,u;while(r--){u=s[r];if(t===u[0]){return r}}return null}function i(r,s){var t=r[s];return(t&&(t instanceof d))?t:null}function b(t,r){var w=this;var v=[];var u={};var x=(typeof t==p)?t:a;var s=(typeof r==p)?r:null;this.put=function(B,C){q(B);l(C);var D=x(B),E,A,z=null;E=i(u,D);if(E){A=E.getEntryForKey(B);if(A){z=A[1];A[1]=C}else{E.addEntry(B,C)}}else{E=new d(D,B,C,s);v[v.length]=E;u[D]=E}return z};this.get=function(A){q(A);var B=x(A);var C=i(u,B);if(C){var z=C.getEntryForKey(A);if(z){return z[1]}}return null};this.containsKey=function(A){q(A);var z=x(A);var B=i(u,z);return B?B.containsKey(A):false};this.containsValue=function(A){l(A);var z=v.length;while(z--){if(v[z].containsValue(A)){return true}}return false};this.clear=function(){v.length=0;u={}};this.isEmpty=function(){return !v.length};var y=function(z){return function(){var A=[],B=v.length;while(B--){v[B][z](A)}return A}};this.keys=y("keys");this.values=y("values");this.entries=y("getEntries");this.remove=function(B){q(B);var C=x(B),z,A=null;var D=i(u,C);if(D){A=D.removeEntryForKey(B);if(A!==null){if(!D.entries.length){z=m(v,C);n(v,z);delete u[C]}}}return A};this.size=function(){var A=0,z=v.length;while(z--){A+=v[z].entries.length}return A};this.each=function(C){var z=w.entries(),A=z.length,B;while(A--){B=z[A];C(B[0],B[1])}};this.putAll=function(H,C){var B=H.entries();var E,F,D,z,A=B.length;var G=(typeof C==p);while(A--){E=B[A];F=E[0];D=E[1];if(G&&(z=w.get(F))){D=C(F,z,D)}w.put(F,D)}};this.clone=function(){var z=new b(t,r);z.putAll(w);return z}}return b})();
	define("jshashtable", (function (global) {
	    return function () {
	        var ret, fn;
	        return ret || global.Hashtable;
	    };
	}(this)));
	
	/**
	 * Note: Alex Zh - I have modified this file as we need to have access to used number formats
	 * and also add support for a new locales.
	 */
	/**
	 * jquery.numberformatter - Formatting/Parsing Numbers in jQuery
	 * 
	 * Written by
	 * Michael Abernethy (mike@abernethysoft.com),
	 * Andrew Parry (aparry0@gmail.com)
	 *
	 * Dual licensed under the MIT (MIT-LICENSE.txt)
	 * and GPL (GPL-LICENSE.txt) licenses.
	 *
	 * @author Michael Abernethy, Andrew Parry
	 * @version 1.2.3-SNAPSHOT ($Id$)
	 * 
	 * Dependencies
	 * 
	 * jQuery (http://jquery.com)
	 * jshashtable (http://www.timdown.co.uk/jshashtable)
	 * 
	 * Notes & Thanks
	 * 
	 * many thanks to advweb.nanasi.jp for his bug fixes
	 * jsHashtable is now used also, so thanks to the author for that excellent little class.
	 *
	 * This plugin can be used to format numbers as text and parse text as Numbers
	 * Because we live in an international world, we cannot assume that everyone
	 * uses "," to divide thousands, and "." as a decimal point.
	 *
	 * As of 1.2 the way this plugin works has changed slightly, parsing text to a number
	 * has 1 set of functions, formatting a number to text has it's own. Before things
	 * were a little confusing, so I wanted to separate the 2 out more.
	 *
	 *
	 * jQuery extension functions:
	 *
	 * formatNumber(options, writeBack, giveReturnValue) - Reads the value from the subject, parses to
	 * a Javascript Number object, then formats back to text using the passed options and write back to
	 * the subject.
	 * 
	 * parseNumber(options) - Parses the value in the subject to a Number object using the passed options
	 * to decipher the actual number from the text, then writes the value as text back to the subject.
	 * 
	 * 
	 * Generic functions:
	 * 
	 * formatNumber(numberString, options) - Takes a plain number as a string (e.g. '1002.0123') and returns
	 * a string of the given format options.
	 * 
	 * parseNumber(numberString, options) - Takes a number as text that is formatted the same as the given
	 * options then and returns it as a plain Number object.
	 * 
	 * To achieve the old way of combining parsing and formatting to keep say a input field always formatted
	 * to a given format after it has lost focus you'd simply use a combination of the functions.
	 * 
	 * e.g.
	 * $("#salary").blur(function(){
	 * 		$(this).parseNumber({format:"#,###.00", locale:"us"});
	 * 		$(this).formatNumber({format:"#,###.00", locale:"us"});
	 * });
	 *
	 * The syntax for the formatting is:
	 * 0 = Digit
	 * # = Digit, zero shows as absent
	 * . = Decimal separator
	 * - = Negative sign
	 * , = Grouping Separator
	 * % = Percent (multiplies the number by 100)
	 * 
	 * For example, a format of "#,###.00" and text of 4500.20 will
	 * display as "4.500,20" with a locale of "de", and "4,500.20" with a locale of "us"
	 *
	 *
	 * As of now, the only acceptable locales are 
	 * Australia -> "au"
	 * Canada -> "ca"
	 * China -> "cn"
	 * France  -> "fr"
	 * Germany -> "de"
	 * Great Britain -> "gb"
	 * Hong Kong -> "hk"
	 * Israel -> "il"
	 * Japan -> "jp"
	 * Russia -> "ru"
	 * South Korea -> "kr"
	 * Spain -> "es"
	 * United States -> "us"
	 **/
	
	(function(jQuery) {
	
		var nfLocales = new Hashtable();
	
		var nfLocalesLikeUS = ['ae', 'au', 'nz', 'ca', 'cn', 'eg', 'gb', 'hk', 'il', 'in', 'sg', 'jp', 'sk', 'ko', 'us', 'mx', 'pa', 'pr', 'gt', 'cr', 'tw', 'th', 'my', 'ph', 'id', 'ie'];
		var nfLocalesLikeDE = ['br', 'de', 'dk', 'es', 'gr', 'it', 'nl', 'co', 'pt', 'vn', 'tr', 'cl', 'ec', 've', 'ar', 'py', 'pe', 'be'];
		var nfLocalesLikeFR = ['fr_ca', 'at', 'cz', 'fi', 'fr', 'ru',  'se', 'za', 'pl'];
		var nfLocalesLikeCH = ['ch'];
		
		var nfLocaleSpecificLang = ['fr_ca'];
	
		var nfLocaleFormatting = [ [".", ","], [",", "."], [",", " "], [".", "'"] ]; 
		var nfAllLocales = [ nfLocalesLikeUS, nfLocalesLikeDE, nfLocalesLikeFR, nfLocalesLikeCH ]
	
		function FormatData(dec, group, neg) {
			this.dec = dec;
			this.group = group;
			this.neg = neg;
		};
	
		function init() {
			// write the arrays into the hashtable
			for (var localeGroupIdx = 0; localeGroupIdx < nfAllLocales.length; localeGroupIdx++) {
				localeGroup = nfAllLocales[localeGroupIdx];
				for (var i = 0; i < localeGroup.length; i++) {
					nfLocales.put(localeGroup[i], localeGroupIdx);
				}
			}
		};
	
		function formatCodes(locale, isFullLocale) {
			if (nfLocales.size() == 0) init();
			// default values
			var dec = ".";
			var group = ",";
			var neg = "-";
			locale = locale.toLowerCase();
			if (isFullLocale === false){
				if (nfLocaleSpecificLang.indexOf(locale) === -1 && /[_-]/.test(locale)){
					locale = locale.split(/[_-]/)[1];
				}
			}
	
			 // hashtable lookup to match locale with codes
			 var codesIndex = nfLocales.get(locale);
			 if (codesIndex) {
			 	var codes = nfLocaleFormatting[codesIndex];
				if (codes) {
					dec = codes[0];
					group = codes[1];
				}
			 }
			 return new FormatData(dec, group, neg);
	    };
		
		
		/*	Formatting Methods	*/
		
		
		/**
		 * Formats anything containing a number in standard js number notation.
		 * 
		 * @param {Object}	options			The formatting options to use
		 * @param {Boolean}	writeBack		(true) If the output value should be written back to the subject
		 * @param {Boolean} giveReturnValue	(true) If the function should return the output string
		 */
		jQuery.fn.formatNumber = function(options, writeBack, giveReturnValue) {
		
			return this.each(function() {
				// enforce defaults
				if (writeBack == null)
					writeBack = true;
				if (giveReturnValue == null)
					giveReturnValue = true;
				
				// get text
				var text;
				if (jQuery(this).is(":input"))
					text = new String(jQuery(this).val());
				else
					text = new String(jQuery(this).text());
	
				// format
				var returnString = jQuery.formatNumber(text, options);
			
				// set formatted string back, only if a success
	//			if (returnString) {
					if (writeBack) {
						if (jQuery(this).is(":input"))
							jQuery(this).val(returnString);
						else
							jQuery(this).text(returnString);
					}
					if (giveReturnValue)
						return returnString;
	//			}
	//			return '';
			});
		};
		
		/**
		 * First parses a string and reformats it with the given options.
		 * 
		 * @param {Object} numberString
		 * @param {Object} options
		 */
		jQuery.formatNumber = function(numberString, options){
			var options = jQuery.extend({}, jQuery.fn.formatNumber.defaults, options);
			var formatData = formatCodes(options.locale.toLowerCase(), options.isFullLocale);
			
			var dec = formatData.dec;
			var group = formatData.group;
			var neg = formatData.neg;
			
			var validFormat = "0#-,.";
			
			// strip all the invalid characters at the beginning and the end
			// of the format, and we'll stick them back on at the end
			// make a special case for the negative sign "-" though, so 
			// we can have formats like -$23.32
			var prefix = "";
			var negativeInFront = false;
			for (var i = 0; i < options.format.length; i++) {
				if (validFormat.indexOf(options.format.charAt(i)) == -1) 
					prefix = prefix + options.format.charAt(i);
				else 
					if (i == 0 && options.format.charAt(i) == '-') {
						negativeInFront = true;
						continue;
					}
					else 
						break;
			}
			var suffix = "";
			for (var i = options.format.length - 1; i >= 0; i--) {
				if (validFormat.indexOf(options.format.charAt(i)) == -1) 
					suffix = options.format.charAt(i) + suffix;
				else 
					break;
			}
			
			options.format = options.format.substring(prefix.length);
			options.format = options.format.substring(0, options.format.length - suffix.length);
			
			// now we need to convert it into a number
			//while (numberString.indexOf(group) > -1) 
			//	numberString = numberString.replace(group, '');
			//var number = new Number(numberString.replace(dec, ".").replace(neg, "-"));
			var number = new Number(numberString);
			
			return jQuery._formatNumber(number, options, suffix, prefix, negativeInFront);
		};
		
		/**
		 * Formats a Number object into a string, using the given formatting options
		 * 
		 * @param {Object} numberString
		 * @param {Object} options
		 */
		jQuery._formatNumber = function(number, options, suffix, prefix, negativeInFront) {
			var options = jQuery.extend({}, jQuery.fn.formatNumber.defaults, options);
			var formatData = formatCodes(options.locale.toLowerCase(), options.isFullLocale);
			
			var dec = formatData.dec;
			var group = formatData.group;
			var neg = formatData.neg;
			
			var forcedToZero = false;
			if (isNaN(number)) {
				if (options.nanForceZero == true) {
					number = 0;
					forcedToZero = true;
				} else 
					return null;
			}
	
			// special case for percentages
	        if (suffix == "%")
	        	number = number * 100;
	
			var returnString = "";
			if (options.format.indexOf(".") > -1) {
				var decimalPortion = dec;
				var decimalFormat = options.format.substring(options.format.lastIndexOf(".") + 1);
				
				// round or truncate number as needed
				if (options.round == true)
					number = new Number(number.toFixed(decimalFormat.length));
				else {
					var numStr = number.toString();
					numStr = numStr.substring(0, numStr.lastIndexOf('.') + decimalFormat.length + 1);
					number = new Number(numStr);
				}
				
				var decimalValue = number % 1;
				var decimalString = new String(decimalValue.toFixed(decimalFormat.length));
				decimalString = decimalString.substring(decimalString.lastIndexOf(".") + 1);
				
				for (var i = 0; i < decimalFormat.length; i++) {
					if (decimalFormat.charAt(i) == '#' && decimalString.charAt(i) != '0') {
	                	decimalPortion += decimalString.charAt(i);
						continue;
					} else if (decimalFormat.charAt(i) == '#' && decimalString.charAt(i) == '0') {
						var notParsed = decimalString.substring(i);
						if (notParsed.match('[1-9]')) {
							decimalPortion += decimalString.charAt(i);
							continue;
						} else
							break;
					} else if (decimalFormat.charAt(i) == "0")
						decimalPortion += decimalString.charAt(i);
				}
				returnString += decimalPortion
	         } else
				number = Math.round(number);
	
			var ones = Math.floor(number);
			if (number < 0)
				ones = Math.ceil(number);
	
			var onesFormat = "";
			if (options.format.indexOf(".") == -1)
				onesFormat = options.format;
			else
				onesFormat = options.format.substring(0, options.format.indexOf("."));
	
			var onePortion = "";
			if (!(ones == 0 && onesFormat.substr(onesFormat.length - 1) == '#') || forcedToZero) {
				// find how many digits are in the group
				var oneText = new String(Math.abs(ones));
				var groupLength = 9999;
				if (onesFormat.lastIndexOf(",") != -1)
					groupLength = onesFormat.length - onesFormat.lastIndexOf(",") - 1;
				var groupCount = 0;
				for (var i = oneText.length - 1; i > -1; i--) {
					onePortion = oneText.charAt(i) + onePortion;
					groupCount++;
					if (groupCount == groupLength && i != 0) {
						onePortion = group + onePortion;
						groupCount = 0;
					}
				}
				
				// account for any pre-data padding
				if (onesFormat.length > onePortion.length) {
					var padStart = onesFormat.indexOf('0');
					if (padStart != -1) {
						var padLen = onesFormat.length - padStart;
						
						// pad to left with 0's or group char
						var pos = onesFormat.length - onePortion.length - 1;
						while (onePortion.length < padLen) {
							var padChar = onesFormat.charAt(pos);
							// replace with real group char if needed
							if (padChar == ',')
								padChar = group;
							onePortion = padChar + onePortion;
							pos--;
						}
					}
				}
			}
			
			if (!onePortion && onesFormat.indexOf('0', onesFormat.length - 1) !== -1)
	   			onePortion = '0';
	
			returnString = onePortion + returnString;
	
			// handle special case where negative is in front of the invalid characters
			if (number < 0 && negativeInFront && prefix.length > 0)
				prefix = neg + prefix;
			else if (number < 0)
				returnString = neg + returnString;
			
			if (!options.decimalSeparatorAlwaysShown) {
				if (returnString.lastIndexOf(dec) == returnString.length - 1) {
					returnString = returnString.substring(0, returnString.length - 1);
				}
			}
			returnString = prefix + returnString + suffix;
			return returnString;
		};
	
	
		/*	Parsing Methods	*/
	
	
		/**
		 * Parses a number of given format from the element and returns a Number object.
		 * @param {Object} options
		 */
		jQuery.fn.parseNumber = function(options, writeBack, giveReturnValue) {
			// enforce defaults
			if (writeBack == null)
				writeBack = true;
			if (giveReturnValue == null)
				giveReturnValue = true;
			
			// get text
			var text;
			if (jQuery(this).is(":input"))
				text = new String(jQuery(this).val());
			else
				text = new String(jQuery(this).text());
		
			// parse text
			var number = jQuery.parseNumber(text, options);
			
			if (number) {
				if (writeBack) {
					if (jQuery(this).is(":input"))
						jQuery(this).val(number.toString());
					else
						jQuery(this).text(number.toString());
				}
				if (giveReturnValue)
					return number;
			}
		};
		
		/**
		 * Parses a string of given format into a Number object.
		 * 
		 * @param {Object} string
		 * @param {Object} options
		 */
		jQuery.parseNumber = function(numberString, options) {
			var options = jQuery.extend({}, jQuery.fn.parseNumber.defaults, options);
			var formatData = formatCodes(options.locale.toLowerCase(), options.isFullLocale);
	
			var dec = formatData.dec;
			var group = formatData.group;
			var neg = formatData.neg;
	
			var valid = "1234567890.-";
			
			// now we need to convert it into a number
			while (numberString.indexOf(group)>-1)
				numberString = numberString.replace(group,'');
			numberString = numberString.replace(dec,".").replace(neg,"-");
			var validText = "";
			var hasPercent = false;
			if (numberString.charAt(numberString.length - 1) == "%" || options.isPercentage == true)
				hasPercent = true;
			for (var i=0; i<numberString.length; i++) {
				if (valid.indexOf(numberString.charAt(i))>-1)
					validText = validText + numberString.charAt(i);
			}
			var number = new Number(validText);
			if (hasPercent) {
				number = number / 100;
				var decimalPos = validText.indexOf('.');
				if (decimalPos != -1) {
					var decimalPoints = validText.length - decimalPos - 1;
					number = number.toFixed(decimalPoints + 2);
				} else {
					number = number.toFixed(validText.length - 1);
				}
			}
	
			return number;
		};
	
	    jQuery.parseNumber.formatCodes = formatCodes;
	
		jQuery.fn.parseNumber.defaults = {
			locale: "us",
			decimalSeparatorAlwaysShown: false,
			isPercentage: false,
			isFullLocale: false
		};
	
		jQuery.fn.formatNumber.defaults = {
			format: "#,###.00",
			locale: "us",
			decimalSeparatorAlwaysShown: false,
			nanForceZero: true,
			round: true,
			isFullLocale: false
		};
		
		Number.prototype.toFixed = function(precision) {
	    	return jQuery._roundNumber(this, precision);
		};
		
		jQuery._roundNumber = function(number, decimalPlaces) {
			var power = Math.pow(10, decimalPlaces || 0);
	    	var value = String(Math.round(number * power) / power);
	    	
	    	// ensure the decimal places are there
	    	if (decimalPlaces > 0) {
	    		var dp = value.indexOf(".");
	    		if (dp == -1) {
	    			value += '.';
	    			dp = 0;
	    		} else {
	    			dp = value.length - (dp + 1);
	    		}
	    		
	    		while (dp < decimalPlaces) {
	    			value += '0';
	    			dp++;
	    		}
	    	}
	    	return value;
		};
	
	 })(jQuery);
	
	define("jquery.numberformatter", function(){});
	
	/**
	 * messageformat.js
	 *
	 * ICU PluralFormat + SelectFormat for JavaScript
	 *
	 * @author Alex Sexton - @SlexAxton
	 * @version 0.1.1
	 * @license WTFPL
	 * @contributor_license Dojo CLA
	*/
	(function ( root ) {
	
	  if(root['MessageFormat']) {
	    return;
	  }
	
	  // Create the contructor function
	  function MessageFormat ( locale, pluralFunc ) {
	
	    if ( locale && pluralFunc ) {
	      MessageFormat.locale[ locale ] = pluralFunc;
	    }
	
	    // Defaults
	    locale = locale || "en";
	    pluralFunc = pluralFunc || MessageFormat.locale[ locale ];
	
	    // Let's just be friends.
	    if ( ! pluralFunc ) {
	      throw new Error( "Plural Function not found for locale: " + locale );
	    }
	
	
	    // Own Properties
	    this.pluralFunc = pluralFunc;
	    this.locale = locale;
	  }
	
	  // Set up the locales object. Add in english by default
	  MessageFormat.locale = {
	    "en" : function ( n ) {
	      if ( n === 1 ) {
	        return "one";
	      }
	      return "other";
	    },
	    "en_us" : function () {
	      return this.en.apply( this, arguments );
	    }
	  };
	
	  // Build out our basic SafeString type
	  // more or less stolen from Handlebars by @wycats
	  MessageFormat.SafeString = function( string ) {
	    this.string = string;
	  };
	
	  MessageFormat.SafeString.prototype.toString = function () {
	    return this.string.toString();
	  };
	
	  MessageFormat.Utils = {
	    numSub : function ( string, key, depth ) {
	      // make sure that it's not an escaped octothorpe
	      return string.replace( /^#|[^\\]#/g, function (m) {
	        var prefix = m && m.length === 2 ? m.charAt(0) : '';
	        return prefix + '" + (function(){ var x = ' +
	        key+';\nif( isNaN(x) ){\nthrow new Error("MessageFormat: `"+lastkey_'+depth+'+"` isnt a number.");\n}\nreturn x;\n})() + "'
	      });
	    },
	    escapeExpression : function (string) {
	      var escape = {
	            "\n": "\\n"
	          },
	          badChars = /(\n)|[\n]/g,
	          possible = /[\n]/,
	          escapeChar = function(chr) {
	            return escape[chr] || "&amp;";
	          };
	
	      // Don't escape SafeStrings, since they're already safe
	      if ( string instanceof MessageFormat.SafeString ) {
	        return string.toString();
	      }
	      else if ( string === null || string === false ) {
	        return "";
	      }
	
	      if ( ! possible.test( string ) ) {
	        return string;
	      }
	      return string.replace( badChars, escapeChar );
	    }
	  };
	
	  // This is generated and pulled in for browsers.
	  var mparser = (function(){
	    /* Generated by PEG.js 0.6.2 (http://pegjs.majda.cz/). */
	
	    var result = {
	      /*
	      * Parses the input with a generated parser. If the parsing is successfull,
	      * returns a value explicitly or implicitly specified by the grammar from
	      * which the parser was generated (see |PEG.buildParser|). If the parsing is
	      * unsuccessful, throws |PEG.parser.SyntaxError| describing the error.
	      */
	      parse: function(input, startRule) {
	        var parseFunctions = {
	          "_": parse__,
	          "char": parse_char,
	          "chars": parse_chars,
	          "digits": parse_digits,
	          "elementFormat": parse_elementFormat,
	          "hexDigit": parse_hexDigit,
	          "id": parse_id,
	          "messageFormatElement": parse_messageFormatElement,
	          "messageFormatPattern": parse_messageFormatPattern,
	          "messageFormatPatternRight": parse_messageFormatPatternRight,
	          "offsetPattern": parse_offsetPattern,
	          "pluralFormatPattern": parse_pluralFormatPattern,
	          "pluralForms": parse_pluralForms,
	          "pluralStyle": parse_pluralStyle,
	          "selectFormatPattern": parse_selectFormatPattern,
	          "selectStyle": parse_selectStyle,
	          "start": parse_start,
	          "string": parse_string,
	          "stringKey": parse_stringKey,
	          "whitespace": parse_whitespace
	        };
	
	        if (startRule !== undefined) {
	          if (parseFunctions[startRule] === undefined) {
	            throw new Error("Invalid rule name: " + quote(startRule) + ".");
	          }
	        } else {
	          startRule = "start";
	        }
	
	        var pos = 0;
	        var reportMatchFailures = true;
	        var rightmostMatchFailuresPos = 0;
	        var rightmostMatchFailuresExpected = [];
	        var cache = {};
	
	        function padLeft(input, padding, length) {
	          var result = input;
	
	          var padLength = length - input.length;
	          for (var i = 0; i < padLength; i++) {
	            result = padding + result;
	          }
	
	          return result;
	        }
	
	        function escape(ch) {
	          var charCode = ch.charCodeAt(0);
	
	          if (charCode <= 0xFF) {
	            var escapeChar = 'x';
	            var length = 2;
	          } else {
	            var escapeChar = 'u';
	            var length = 4;
	          }
	
	          return '\\' + escapeChar + padLeft(charCode.toString(16).toUpperCase(), '0', length);
	        }
	
	        function quote(s) {
	          /*
	          * ECMA-262, 5th ed., 7.8.4: All characters may appear literally in a
	          * string literal except for the closing quote character, backslash,
	          * carriage return, line separator, paragraph separator, and line feed.
	          * Any character may appear in the form of an escape sequence.
	          */
	          return '"' + s
	          .replace(/\\/g, '\\\\')            // backslash
	          .replace(/"/g, '\\"')              // closing quote character
	          .replace(/\r/g, '\\r')             // carriage return
	          .replace(/\n/g, '\\n')             // line feed
	          .replace(/[\x80-\uFFFF]/g, escape) // non-ASCII characters
	          + '"';
	        }
	
	        function matchFailed(failure) {
	          if (pos < rightmostMatchFailuresPos) {
	            return;
	          }
	
	          if (pos > rightmostMatchFailuresPos) {
	            rightmostMatchFailuresPos = pos;
	            rightmostMatchFailuresExpected = [];
	          }
	
	          rightmostMatchFailuresExpected.push(failure);
	        }
	
	        function parse_start() {
	          var cacheKey = 'start@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = parse_messageFormatPattern();
	          var result2 = result1 !== null
	          ? (function(messageFormatPattern) { return { type: "program", program: messageFormatPattern }; })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_messageFormatPattern() {
	          var cacheKey = 'messageFormatPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse_string();
	          if (result3 !== null) {
	            var result4 = [];
	            var result5 = parse_messageFormatPatternRight();
	            while (result5 !== null) {
	              result4.push(result5);
	              var result5 = parse_messageFormatPatternRight();
	            }
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(s1, inner) {
	            var st = [];
	            if ( s1 && s1.val ) {
	              st.push( s1 );
	            }
	            for( var i in inner ){
	              if ( inner.hasOwnProperty( i ) ) {
	                st.push( inner[ i ] );
	              }
	            }
	            return { type: 'messageFormatPattern', statements: st };
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_messageFormatPatternRight() {
	          var cacheKey = 'messageFormatPatternRight@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          if (input.substr(pos, 1) === "{") {
	            var result3 = "{";
	              pos += 1;
	            } else {
	              var result3 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"{\"");
	                }
	              }
	              if (result3 !== null) {
	                var result4 = parse__();
	                if (result4 !== null) {
	                  var result5 = parse_messageFormatElement();
	                  if (result5 !== null) {
	                    var result6 = parse__();
	                    if (result6 !== null) {
	                      if (input.substr(pos, 1) === "}") {
	                        var result7 = "}";
	                        pos += 1;
	                  } else {
	                    var result7 = null;
	                    if (reportMatchFailures) {
	                      matchFailed("\"}\"");
	                  }
	                }
	                if (result7 !== null) {
	                  var result8 = parse_string();
	                  if (result8 !== null) {
	                    var result1 = [result3, result4, result5, result6, result7, result8];
	                  } else {
	                    var result1 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(mfe, s1) {
	            var res = [];
	            if ( mfe ) {
	              res.push(mfe);
	            }
	            if ( s1 && s1.val ) {
	              res.push( s1 );
	            }
	            return { type: "messageFormatPatternRight", statements : res };
	          })(result1[2], result1[5])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_messageFormatElement() {
	          var cacheKey = 'messageFormatElement@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse_id();
	          if (result3 !== null) {
	            var savedPos2 = pos;
	            if (input.substr(pos, 1) === ",") {
	              var result6 = ",";
	              pos += 1;
	            } else {
	              var result6 = null;
	              if (reportMatchFailures) {
	                matchFailed("\",\"");
	              }
	            }
	            if (result6 !== null) {
	              var result7 = parse_elementFormat();
	              if (result7 !== null) {
	                var result5 = [result6, result7];
	              } else {
	                var result5 = null;
	                pos = savedPos2;
	              }
	            } else {
	              var result5 = null;
	              pos = savedPos2;
	            }
	            var result4 = result5 !== null ? result5 : '';
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(argIdx, efmt) {
	            var res = {
	              type: "messageFormatElement",
	              argumentIndex: argIdx
	            };
	            if ( efmt && efmt.length ) {
	              res.elementFormat = efmt[1];
	            }
	            else {
	              res.output = true;
	            }
	            return res;
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_elementFormat() {
	          var cacheKey = 'elementFormat@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos2 = pos;
	          var savedPos3 = pos;
	          var result14 = parse__();
	          if (result14 !== null) {
	            if (input.substr(pos, 6) === "plural") {
	              var result15 = "plural";
	              pos += 6;
	            } else {
	              var result15 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"plural\"");
	              }
	            }
	            if (result15 !== null) {
	              var result16 = parse__();
	              if (result16 !== null) {
	                if (input.substr(pos, 1) === ",") {
	                  var result17 = ",";
	                  pos += 1;
	                } else {
	                  var result17 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\",\"");
	                  }
	                }
	                if (result17 !== null) {
	                  var result18 = parse__();
	                  if (result18 !== null) {
	                    var result19 = parse_pluralStyle();
	                    if (result19 !== null) {
	                      var result20 = parse__();
	                      if (result20 !== null) {
	                        var result12 = [result14, result15, result16, result17, result18, result19, result20];
	                      } else {
	                        var result12 = null;
	                        pos = savedPos3;
	                      }
	                    } else {
	                      var result12 = null;
	                      pos = savedPos3;
	                    }
	                  } else {
	                    var result12 = null;
	                    pos = savedPos3;
	                  }
	                } else {
	                  var result12 = null;
	                  pos = savedPos3;
	                }
	              } else {
	                var result12 = null;
	                pos = savedPos3;
	              }
	            } else {
	              var result12 = null;
	              pos = savedPos3;
	            }
	          } else {
	            var result12 = null;
	            pos = savedPos3;
	          }
	          var result13 = result12 !== null
	          ? (function(t, s) {
	            return {
	              type : "elementFormat",
	              key  : t,
	              val  : s.val
	            };
	          })(result12[1], result12[5])
	          : null;
	          if (result13 !== null) {
	            var result11 = result13;
	          } else {
	            var result11 = null;
	            pos = savedPos2;
	          }
	          if (result11 !== null) {
	            var result0 = result11;
	          } else {
	            var savedPos0 = pos;
	            var savedPos1 = pos;
	            var result4 = parse__();
	            if (result4 !== null) {
	              if (input.substr(pos, 6) === "select") {
	                var result5 = "select";
	                pos += 6;
	              } else {
	                var result5 = null;
	                if (reportMatchFailures) {
	                  matchFailed("\"select\"");
	                }
	              }
	              if (result5 !== null) {
	                var result6 = parse__();
	                if (result6 !== null) {
	                  if (input.substr(pos, 1) === ",") {
	                    var result7 = ",";
	                    pos += 1;
	                  } else {
	                    var result7 = null;
	                    if (reportMatchFailures) {
	                      matchFailed("\",\"");
	                    }
	                  }
	                  if (result7 !== null) {
	                    var result8 = parse__();
	                    if (result8 !== null) {
	                      var result9 = parse_selectStyle();
	                      if (result9 !== null) {
	                        var result10 = parse__();
	                        if (result10 !== null) {
	                          var result2 = [result4, result5, result6, result7, result8, result9, result10];
	                        } else {
	                          var result2 = null;
	                          pos = savedPos1;
	                        }
	                      } else {
	                        var result2 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result2 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result2 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result2 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result2 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result2 = null;
	              pos = savedPos1;
	            }
	            var result3 = result2 !== null
	            ? (function(t, s) {
	              return {
	                type : "elementFormat",
	                key  : t,
	                val  : s.val
	              };
	            })(result2[1], result2[5])
	            : null;
	            if (result3 !== null) {
	              var result1 = result3;
	            } else {
	              var result1 = null;
	              pos = savedPos0;
	            }
	            if (result1 !== null) {
	              var result0 = result1;
	            } else {
	              var result0 = null;;
	            };
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_pluralStyle() {
	          var cacheKey = 'pluralStyle@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = parse_pluralFormatPattern();
	          var result2 = result1 !== null
	          ? (function(pfp) {
	            return { type: "pluralStyle", val: pfp };
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_selectStyle() {
	          var cacheKey = 'selectStyle@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = parse_selectFormatPattern();
	          var result2 = result1 !== null
	          ? (function(sfp) {
	            return { type: "selectStyle", val: sfp };
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_pluralFormatPattern() {
	          var cacheKey = 'pluralFormatPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result6 = parse_offsetPattern();
	          var result3 = result6 !== null ? result6 : '';
	          if (result3 !== null) {
	            var result4 = [];
	            var result5 = parse_pluralForms();
	            while (result5 !== null) {
	              result4.push(result5);
	              var result5 = parse_pluralForms();
	            }
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(op, pf) {
	            var res = {
	              type: "pluralFormatPattern",
	              pluralForms: pf
	            };
	            if ( op ) {
	              res.offset = op;
	            }
	            else {
	              res.offset = 0;
	            }
	            return res;
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_offsetPattern() {
	          var cacheKey = 'offsetPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            if (input.substr(pos, 6) === "offset") {
	              var result4 = "offset";
	              pos += 6;
	            } else {
	              var result4 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"offset\"");
	              }
	            }
	            if (result4 !== null) {
	              var result5 = parse__();
	              if (result5 !== null) {
	                if (input.substr(pos, 1) === ":") {
	                  var result6 = ":";
	                  pos += 1;
	                } else {
	                  var result6 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\":\"");
	                  }
	                }
	                if (result6 !== null) {
	                  var result7 = parse__();
	                  if (result7 !== null) {
	                    var result8 = parse_digits();
	                    if (result8 !== null) {
	                      var result9 = parse__();
	                      if (result9 !== null) {
	                        var result1 = [result3, result4, result5, result6, result7, result8, result9];
	                      } else {
	                        var result1 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result1 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result1 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(d) {
	            return d;
	          })(result1[5])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_selectFormatPattern() {
	          var cacheKey = 'selectFormatPattern@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result1 = [];
	          var result3 = parse_pluralForms();
	          while (result3 !== null) {
	            result1.push(result3);
	            var result3 = parse_pluralForms();
	          }
	          var result2 = result1 !== null
	          ? (function(pf) {
	            return {
	              type: "selectFormatPattern",
	              pluralForms: pf
	            };
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_pluralForms() {
	          var cacheKey = 'pluralForms@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            var result4 = parse_stringKey();
	            if (result4 !== null) {
	              var result5 = parse__();
	              if (result5 !== null) {
	                if (input.substr(pos, 1) === "{") {
	                  var result6 = "{";
	                    pos += 1;
	                  } else {
	                    var result6 = null;
	                    if (reportMatchFailures) {
	                      matchFailed("\"{\"");
	                      }
	                    }
	                    if (result6 !== null) {
	                      var result7 = parse__();
	                      if (result7 !== null) {
	                        var result8 = parse_messageFormatPattern();
	                        if (result8 !== null) {
	                          var result9 = parse__();
	                          if (result9 !== null) {
	                            if (input.substr(pos, 1) === "}") {
	                              var result10 = "}";
	                              pos += 1;
	                        } else {
	                          var result10 = null;
	                          if (reportMatchFailures) {
	                            matchFailed("\"}\"");
	                        }
	                      }
	                      if (result10 !== null) {
	                        var result1 = [result3, result4, result5, result6, result7, result8, result9, result10];
	                      } else {
	                        var result1 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result1 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result1 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(k, mfp) {
	            return {
	              type: "pluralForms",
	              key: k,
	              val: mfp
	            };
	          })(result1[1], result1[5])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_stringKey() {
	          var cacheKey = 'stringKey@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos2 = pos;
	          var result7 = parse_id();
	          var result8 = result7 !== null
	          ? (function(i) {
	            return i;
	          })(result7)
	          : null;
	          if (result8 !== null) {
	            var result6 = result8;
	          } else {
	            var result6 = null;
	            pos = savedPos2;
	          }
	          if (result6 !== null) {
	            var result0 = result6;
	          } else {
	            var savedPos0 = pos;
	            var savedPos1 = pos;
	            if (input.substr(pos, 1) === "=") {
	              var result4 = "=";
	              pos += 1;
	            } else {
	              var result4 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"=\"");
	              }
	            }
	            if (result4 !== null) {
	              var result5 = parse_digits();
	              if (result5 !== null) {
	                var result2 = [result4, result5];
	              } else {
	                var result2 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result2 = null;
	              pos = savedPos1;
	            }
	            var result3 = result2 !== null
	            ? (function(d) {
	              return d;
	            })(result2[1])
	            : null;
	            if (result3 !== null) {
	              var result1 = result3;
	            } else {
	              var result1 = null;
	              pos = savedPos0;
	            }
	            if (result1 !== null) {
	              var result0 = result1;
	            } else {
	              var result0 = null;;
	            };
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_string() {
	          var cacheKey = 'string@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            var result4 = [];
	            var savedPos2 = pos;
	            var result6 = parse__();
	            if (result6 !== null) {
	              var result7 = parse_chars();
	              if (result7 !== null) {
	                var result8 = parse__();
	                if (result8 !== null) {
	                  var result5 = [result6, result7, result8];
	                } else {
	                  var result5 = null;
	                  pos = savedPos2;
	                }
	              } else {
	                var result5 = null;
	                pos = savedPos2;
	              }
	            } else {
	              var result5 = null;
	              pos = savedPos2;
	            }
	            while (result5 !== null) {
	              result4.push(result5);
	              var savedPos2 = pos;
	              var result6 = parse__();
	              if (result6 !== null) {
	                var result7 = parse_chars();
	                if (result7 !== null) {
	                  var result8 = parse__();
	                  if (result8 !== null) {
	                    var result5 = [result6, result7, result8];
	                  } else {
	                    var result5 = null;
	                    pos = savedPos2;
	                  }
	                } else {
	                  var result5 = null;
	                  pos = savedPos2;
	                }
	              } else {
	                var result5 = null;
	                pos = savedPos2;
	              }
	            }
	            if (result4 !== null) {
	              var result1 = [result3, result4];
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(ws, s) {
	            var tmp = [];
	            for( var i = 0; i < s.length; ++i ) {
	              for( var j = 0; j < s[ i ].length; ++j ) {
	                tmp.push(s[i][j]);
	              }
	            }
	            return {
	              type: "string",
	              val: ws + tmp.join('')
	            };
	          })(result1[0], result1[1])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_id() {
	          var cacheKey = 'id@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var savedPos1 = pos;
	          var result3 = parse__();
	          if (result3 !== null) {
	            if (input.substr(pos).match(/^[a-zA-Z$_]/) !== null) {
	              var result4 = input.charAt(pos);
	              pos++;
	            } else {
	              var result4 = null;
	              if (reportMatchFailures) {
	                matchFailed("[a-zA-Z$_]");
	              }
	            }
	            if (result4 !== null) {
	              var result5 = [];
	              if (input.substr(pos).match(/^[^ 	\n\r,.+={}]/) !== null) {
	                var result7 = input.charAt(pos);
	                pos++;
	              } else {
	                var result7 = null;
	                if (reportMatchFailures) {
	                  matchFailed("[^ 	\\n\\r,.+={}]");
	                }
	              }
	              while (result7 !== null) {
	                result5.push(result7);
	                if (input.substr(pos).match(/^[^ 	\n\r,.+={}]/) !== null) {
	                  var result7 = input.charAt(pos);
	                  pos++;
	                } else {
	                  var result7 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("[^ 	\\n\\r,.+={}]");
	                  }
	                }
	              }
	              if (result5 !== null) {
	                var result6 = parse__();
	                if (result6 !== null) {
	                  var result1 = [result3, result4, result5, result6];
	                } else {
	                  var result1 = null;
	                  pos = savedPos1;
	                }
	              } else {
	                var result1 = null;
	                pos = savedPos1;
	              }
	            } else {
	              var result1 = null;
	              pos = savedPos1;
	            }
	          } else {
	            var result1 = null;
	            pos = savedPos1;
	          }
	          var result2 = result1 !== null
	          ? (function(s1, s2) {
	            return s1 + (s2 ? s2.join('') : '');
	          })(result1[1], result1[2])
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_chars() {
	          var cacheKey = 'chars@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          var result3 = parse_char();
	          if (result3 !== null) {
	            var result1 = [];
	            while (result3 !== null) {
	              result1.push(result3);
	              var result3 = parse_char();
	            }
	          } else {
	            var result1 = null;
	          }
	          var result2 = result1 !== null
	          ? (function(chars) { return chars.join(''); })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_char() {
	          var cacheKey = 'char@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos5 = pos;
	          if (input.substr(pos).match(/^[^{}\\\0- 	\n\r]/) !== null) {
	            var result19 = input.charAt(pos);
	            pos++;
	          } else {
	            var result19 = null;
	            if (reportMatchFailures) {
	              matchFailed("[^{}\\\\\\0- 	\\n\\r]");
	            }
	          }
	          var result20 = result19 !== null
	          ? (function(x) {
	            return x;
	          })(result19)
	          : null;
	          if (result20 !== null) {
	            var result18 = result20;
	          } else {
	            var result18 = null;
	            pos = savedPos5;
	          }
	          if (result18 !== null) {
	            var result0 = result18;
	          } else {
	            var savedPos4 = pos;
	            if (input.substr(pos, 2) === "\\#") {
	              var result16 = "\\#";
	              pos += 2;
	            } else {
	              var result16 = null;
	              if (reportMatchFailures) {
	                matchFailed("\"\\\\#\"");
	              }
	            }
	            var result17 = result16 !== null
	            ? (function() {
	              return "\\#";
	            })()
	            : null;
	            if (result17 !== null) {
	              var result15 = result17;
	            } else {
	              var result15 = null;
	              pos = savedPos4;
	            }
	            if (result15 !== null) {
	              var result0 = result15;
	            } else {
	              var savedPos3 = pos;
	              if (input.substr(pos, 2) === "\\{") {
	                var result13 = "\\{";
	                  pos += 2;
	                } else {
	                  var result13 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\"\\\\{\"");
	                    }
	                  }
	                  var result14 = result13 !== null
	                  ? (function() {
	                    return "\u007B";
	                  })()
	                  : null;
	                  if (result14 !== null) {
	                    var result12 = result14;
	                  } else {
	                    var result12 = null;
	                    pos = savedPos3;
	                  }
	                  if (result12 !== null) {
	                    var result0 = result12;
	                  } else {
	                    var savedPos2 = pos;
	                    if (input.substr(pos, 2) === "\\}") {
	                      var result10 = "\\}";
	                      pos += 2;
	                } else {
	                  var result10 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\"\\\\}\"");
	                }
	              }
	              var result11 = result10 !== null
	              ? (function() {
	                return "\u007D";
	              })()
	              : null;
	              if (result11 !== null) {
	                var result9 = result11;
	              } else {
	                var result9 = null;
	                pos = savedPos2;
	              }
	              if (result9 !== null) {
	                var result0 = result9;
	              } else {
	                var savedPos0 = pos;
	                var savedPos1 = pos;
	                if (input.substr(pos, 2) === "\\u") {
	                  var result4 = "\\u";
	                  pos += 2;
	                } else {
	                  var result4 = null;
	                  if (reportMatchFailures) {
	                    matchFailed("\"\\\\u\"");
	                  }
	                }
	                if (result4 !== null) {
	                  var result5 = parse_hexDigit();
	                  if (result5 !== null) {
	                    var result6 = parse_hexDigit();
	                    if (result6 !== null) {
	                      var result7 = parse_hexDigit();
	                      if (result7 !== null) {
	                        var result8 = parse_hexDigit();
	                        if (result8 !== null) {
	                          var result2 = [result4, result5, result6, result7, result8];
	                        } else {
	                          var result2 = null;
	                          pos = savedPos1;
	                        }
	                      } else {
	                        var result2 = null;
	                        pos = savedPos1;
	                      }
	                    } else {
	                      var result2 = null;
	                      pos = savedPos1;
	                    }
	                  } else {
	                    var result2 = null;
	                    pos = savedPos1;
	                  }
	                } else {
	                  var result2 = null;
	                  pos = savedPos1;
	                }
	                var result3 = result2 !== null
	                ? (function(h1, h2, h3, h4) {
	                  return String.fromCharCode(parseInt("0x" + h1 + h2 + h3 + h4));
	                })(result2[1], result2[2], result2[3], result2[4])
	                : null;
	                if (result3 !== null) {
	                  var result1 = result3;
	                } else {
	                  var result1 = null;
	                  pos = savedPos0;
	                }
	                if (result1 !== null) {
	                  var result0 = result1;
	                } else {
	                  var result0 = null;;
	                };
	              };
	              };
	            };
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_digits() {
	          var cacheKey = 'digits@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          var savedPos0 = pos;
	          if (input.substr(pos).match(/^[0-9]/) !== null) {
	            var result3 = input.charAt(pos);
	            pos++;
	          } else {
	            var result3 = null;
	            if (reportMatchFailures) {
	              matchFailed("[0-9]");
	            }
	          }
	          if (result3 !== null) {
	            var result1 = [];
	            while (result3 !== null) {
	              result1.push(result3);
	              if (input.substr(pos).match(/^[0-9]/) !== null) {
	                var result3 = input.charAt(pos);
	                pos++;
	              } else {
	                var result3 = null;
	                if (reportMatchFailures) {
	                  matchFailed("[0-9]");
	                }
	              }
	            }
	          } else {
	            var result1 = null;
	          }
	          var result2 = result1 !== null
	          ? (function(ds) {
	            return parseInt((ds.join('')), 10);
	          })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_hexDigit() {
	          var cacheKey = 'hexDigit@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          if (input.substr(pos).match(/^[0-9a-fA-F]/) !== null) {
	            var result0 = input.charAt(pos);
	            pos++;
	          } else {
	            var result0 = null;
	            if (reportMatchFailures) {
	              matchFailed("[0-9a-fA-F]");
	            }
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse__() {
	          var cacheKey = '_@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	          var savedReportMatchFailures = reportMatchFailures;
	          reportMatchFailures = false;
	          var savedPos0 = pos;
	          var result1 = [];
	          var result3 = parse_whitespace();
	          while (result3 !== null) {
	            result1.push(result3);
	            var result3 = parse_whitespace();
	          }
	          var result2 = result1 !== null
	          ? (function(w) { return w.join(''); })(result1)
	          : null;
	          if (result2 !== null) {
	            var result0 = result2;
	          } else {
	            var result0 = null;
	            pos = savedPos0;
	          }
	          reportMatchFailures = savedReportMatchFailures;
	          if (reportMatchFailures && result0 === null) {
	            matchFailed("whitespace");
	          }
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function parse_whitespace() {
	          var cacheKey = 'whitespace@' + pos;
	          var cachedResult = cache[cacheKey];
	          if (cachedResult) {
	            pos = cachedResult.nextPos;
	            return cachedResult.result;
	          }
	
	
	          if (input.substr(pos).match(/^[ 	\n\r]/) !== null) {
	            var result0 = input.charAt(pos);
	            pos++;
	          } else {
	            var result0 = null;
	            if (reportMatchFailures) {
	              matchFailed("[ 	\\n\\r]");
	            }
	          }
	
	
	
	          cache[cacheKey] = {
	            nextPos: pos,
	            result:  result0
	          };
	          return result0;
	        }
	
	        function buildErrorMessage() {
	          function buildExpected(failuresExpected) {
	            failuresExpected.sort();
	
	            var lastFailure = null;
	            var failuresExpectedUnique = [];
	            for (var i = 0; i < failuresExpected.length; i++) {
	              if (failuresExpected[i] !== lastFailure) {
	                failuresExpectedUnique.push(failuresExpected[i]);
	                lastFailure = failuresExpected[i];
	              }
	            }
	
	            switch (failuresExpectedUnique.length) {
	              case 0:
	                return 'end of input';
	              case 1:
	                return failuresExpectedUnique[0];
	              default:
	                return failuresExpectedUnique.slice(0, failuresExpectedUnique.length - 1).join(', ')
	              + ' or '
	              + failuresExpectedUnique[failuresExpectedUnique.length - 1];
	            }
	          }
	
	          var expected = buildExpected(rightmostMatchFailuresExpected);
	          var actualPos = Math.max(pos, rightmostMatchFailuresPos);
	          var actual = actualPos < input.length
	          ? quote(input.charAt(actualPos))
	          : 'end of input';
	
	          return 'Expected ' + expected + ' but ' + actual + ' found.';
	        }
	
	        function computeErrorPosition() {
	          /*
	          * The first idea was to use |String.split| to break the input up to the
	          * error position along newlines and derive the line and column from
	          * there. However IE's |split| implementation is so broken that it was
	          * enough to prevent it.
	          */
	
	          var line = 1;
	          var column = 1;
	          var seenCR = false;
	
	          for (var i = 0; i <  rightmostMatchFailuresPos; i++) {
	            var ch = input.charAt(i);
	            if (ch === '\n') {
	              if (!seenCR) { line++; }
	              column = 1;
	              seenCR = false;
	            } else if (ch === '\r' | ch === '\u2028' || ch === '\u2029') {
	              line++;
	              column = 1;
	              seenCR = true;
	            } else {
	              column++;
	              seenCR = false;
	            }
	          }
	
	          return { line: line, column: column };
	        }
	
	
	
	        var result = parseFunctions[startRule]();
	
	        /*
	        * The parser is now in one of the following three states:
	        *
	        * 1. The parser successfully parsed the whole input.
	        *
	        *    - |result !== null|
	        *    - |pos === input.length|
	        *    - |rightmostMatchFailuresExpected| may or may not contain something
	        *
	        * 2. The parser successfully parsed only a part of the input.
	        *
	        *    - |result !== null|
	        *    - |pos < input.length|
	        *    - |rightmostMatchFailuresExpected| may or may not contain something
	        *
	        * 3. The parser did not successfully parse any part of the input.
	        *
	        *   - |result === null|
	        *   - |pos === 0|
	        *   - |rightmostMatchFailuresExpected| contains at least one failure
	        *
	        * All code following this comment (including called functions) must
	        * handle these states.
	        */
	        if (result === null || pos !== input.length) {
	          var errorPosition = computeErrorPosition();
	          throw new this.SyntaxError(
	            buildErrorMessage(),
	            errorPosition.line,
	            errorPosition.column
	          );
	        }
	
	        return result;
	      },
	
	      /* Returns the parser source code. */
	      toSource: function() { return this._source; }
	    };
	
	    /* Thrown when a parser encounters a syntax error. */
	
	    result.SyntaxError = function(message, line, column) {
	      this.name = 'SyntaxError';
	      this.message = message;
	      this.line = line;
	      this.column = column;
	    };
	
	    result.SyntaxError.prototype = Error.prototype;
	
	    return result;
	  })();
	
	  MessageFormat.prototype.parse = function () {
	    // Bind to itself so error handling works
	    return mparser.parse.apply( mparser, arguments );
	  };
	
	  MessageFormat.prototype.precompile = function ( ast ) {
	    var self = this,
	        needOther = false,
	        fp = {
	      begin: 'function(d){\nvar r = "";\n',
	      end  : "return r;\n}"
	    };
	
	    function interpMFP ( ast, data ) {
	      // Set some default data
	      data = data || {};
	      var s = '', i, tmp, lastkeyname;
	
	      switch ( ast.type ) {
	        case 'program':
	          return interpMFP( ast.program );
	        case 'messageFormatPattern':
	          for ( i = 0; i < ast.statements.length; ++i ) {
	            s += interpMFP( ast.statements[i], data );
	          }
	          return fp.begin + s + fp.end;
	        case 'messageFormatPatternRight':
	          for ( i = 0; i < ast.statements.length; ++i ) {
	            s += interpMFP( ast.statements[i], data );
	          }
	          return s;
	        case 'messageFormatElement':
	          data.pf_count = data.pf_count || 0;
	          s += 'if(!d){\nthrow new Error("MessageFormat: No data passed to function.");\n}\n';
	          if ( ast.output ) {
	            s += 'r += d["' + ast.argumentIndex + '"];\n';
	          }
	          else {
	            lastkeyname = 'lastkey_'+(data.pf_count+1);
	            s += 'var '+lastkeyname+' = "'+ast.argumentIndex+'";\n';
	            s += 'var k_'+(data.pf_count+1)+'=d['+lastkeyname+'];\n';
	            s += interpMFP( ast.elementFormat, data );
	          }
	          return s;
	        case 'elementFormat':
	          if ( ast.key === 'select' ) {
	            s += interpMFP( ast.val, data );
	            s += 'r += (pf_' +
	                 data.pf_count +
	                 '[ k_' + (data.pf_count+1) + ' ] || pf_'+data.pf_count+'[ "other" ])( d );\n';
	          }
	          else if ( ast.key === 'plural' ) {
	            s += interpMFP( ast.val, data );
	            s += 'if ( pf_'+(data.pf_count)+'[ k_'+(data.pf_count+1)+' + "" ] ) {\n';
	            s += 'r += pf_'+data.pf_count+'[ k_'+(data.pf_count+1)+' + "" ]( d ); \n';
	            s += '}\nelse {\n';
	            s += 'r += (pf_' +
	                 data.pf_count +
	                 '[ MessageFormat.locale["' +
	                 self.locale +
	                 '"]( k_'+(data.pf_count+1)+' - off_'+(data.pf_count)+' ) ] || pf_'+data.pf_count+'[ "other" ] )( d );\n';
	            s += '}\n';
	          }
	          return s;
	        /* // Unreachable cases.
	        case 'pluralStyle':
	        case 'selectStyle':*/
	        case 'pluralFormatPattern':
	          data.pf_count = data.pf_count || 0;
	          s += 'var off_'+data.pf_count+' = '+ast.offset+';\n';
	          s += 'var pf_' + data.pf_count + ' = { \n';
	          needOther = true;
	          // We're going to simultaneously check to make sure we hit the required 'other' option.
	
	          for ( i = 0; i < ast.pluralForms.length; ++i ) {
	            if ( ast.pluralForms[ i ].key === 'other' ) {
	              needOther = false;
	            }
	            if ( tmp ) {
	              s += ',\n';
	            }
	            else{
	              tmp = 1;
	            }
	            s += '"' + ast.pluralForms[ i ].key + '" : ' + interpMFP( ast.pluralForms[ i ].val,
	          (function(){ var res = JSON.parse(JSON.stringify(data)); res.pf_count++; return res; })() );
	          }
	          s += '\n};\n';
	          if ( needOther ) {
	            throw new Error("No 'other' form found in pluralFormatPattern " + data.pf_count);
	          }
	          return s;
	        case 'selectFormatPattern':
	
	          data.pf_count = data.pf_count || 0;
	          s += 'var off_'+data.pf_count+' = 0;\n';
	          s += 'var pf_' + data.pf_count + ' = { \n';
	          needOther = true;
	
	          for ( i = 0; i < ast.pluralForms.length; ++i ) {
	            if ( ast.pluralForms[ i ].key === 'other' ) {
	              needOther = false;
	            }
	            if ( tmp ) {
	              s += ',\n';
	            }
	            else{
	              tmp = 1;
	            }
	            s += '"' + ast.pluralForms[ i ].key + '" : ' + interpMFP( ast.pluralForms[ i ].val,
	              (function(){
	                var res = JSON.parse( JSON.stringify( data ) );
	                res.pf_count++;
	                return res;
	              })()
	            );
	          }
	          s += '\n};\n';
	          if ( needOther ) {
	            throw new Error("No 'other' form found in selectFormatPattern " + data.pf_count);
	          }
	          return s;
	        /* // Unreachable
	        case 'pluralForms':
	        */
	        case 'string':
	          return 'r += "' + MessageFormat.Utils.numSub(
	            MessageFormat.Utils.escapeExpression( ast.val ),
	            'k_' + data.pf_count + ' - off_' + ( data.pf_count - 1 ),
	            data.pf_count
	          ) + '";\n';
	        default:
	          throw new Error( 'Bad AST type: ' + ast.type );
	      }
	    }
	    return interpMFP( ast );
	  };
	
	  MessageFormat.prototype.compile = function ( message ) {
	    return (new Function( 'MessageFormat',
	      'return ' +
	        this.precompile(
	          this.parse( message )
	        )
	    ))(MessageFormat);
	  };
	
	   root['MessageFormat'] = MessageFormat;
	}(this));
	
	define("messageformat/messageformat", (function (global) {
	    return function () {
	        var ret, fn;
	        return ret || global.MessageFormat;
	    };
	}(this)));
	
	MessageFormat.locale.en = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/en", function(){});
	
	MessageFormat.locale.ja = function ( n ) {
	    if ( n === 1 ) {
	        return "one";
	    }
	    return "other";
	};
	
	define("messageformat/locale/ja", function(){});
	
	MessageFormat.locale.zh = function ( n ) {
	  return "other";
	};
	
	define("messageformat/locale/zh", function(){});
	
	MessageFormat.locale.ko = function ( n ) {
	  return "other";
	};
	
	define("messageformat/locale/ko", function(){});
	
	MessageFormat.locale.fr = function (n) {
	  if (n >= 0 && n < 2) {
	    return 'one';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/fr", function(){});
	
	MessageFormat.locale.de = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/de", function(){});
	
	MessageFormat.locale.es = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/es", function(){});
	
	MessageFormat.locale.it = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/it", function(){});
	
	MessageFormat.locale.tr = function(n) {
	  return 'other';
	};
	
	define("messageformat/locale/tr", function(){});
	
	MessageFormat.locale.ru = function (n) {
	  if ((n % 10) == 1 && (n % 100) != 11) {
	    return 'one';
	  }
	  if ((n % 10) >= 2 && (n % 10) <= 4 &&
	      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
	    return 'few';
	  }
	  if ((n % 10) === 0 || ((n % 10) >= 5 && (n % 10) <= 9) ||
	      ((n % 100) >= 11 && (n % 100) <= 14) && n == Math.floor(n)) {
	    return 'many';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/ru", function(){});
	
	MessageFormat.locale.pt = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/pt", function(){});
	
	MessageFormat.locale.no = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/no", function(){});
	
	MessageFormat.locale.sv = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/sv", function(){});
	
	MessageFormat.locale.nl = function ( n ) {
	  if ( n === 1 ) {
	    return "one";
	  }
	  return "other";
	};
	
	define("messageformat/locale/nl", function(){});
	
	MessageFormat.locale.pl = function (n) {
	  if (n == 1) {
	    return 'one';
	  }
	  if ((n % 10) >= 2 && (n % 10) <= 4 &&
	      ((n % 100) < 12 || (n % 100) > 14) && n == Math.floor(n)) {
	    return 'few';
	  }
	  if ((n % 10) === 0 || n != 1 && (n % 10) == 1 ||
	      ((n % 10) >= 5 && (n % 10) <= 9 || (n % 100) >= 12 && (n % 100) <= 14) &&
	      n == Math.floor(n)) {
	    return 'many';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/pl", function(){});
	
	MessageFormat.locale.cs = function (n) {
	  if (n == 1) {
	    return 'one';
	  }
	  if (n == 2 || n == 3 || n == 4) {
	    return 'few';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/cs", function(){});
	
	MessageFormat.locale.ro = function (n) {
	  if (n == 1) {
	    return 'one';
	  }
	  if (n === 0 || n != 1 && (n % 100) >= 1 &&
	      (n % 100) <= 19 && n == Math.floor(n)) {
	    return 'few';
	  }
	  return 'other';
	};
	
	define("messageformat/locale/ro", function(){});
	
	MessageFormat.locale["in"] = function(n) {
	  return 'other';
	};
	
	define("messageformat/locale/in", function(){});
	
	define('i18n/locale',['require'],function(require) {
	    if(typeof global_page_viewer === 'object' && global_page_viewer.locale) {
	        return global_page_viewer.locale;
	    } else if(typeof fitbit === 'object' && typeof fitbit.i18n === 'object' && fitbit.i18n.locale) {
	        return fitbit.i18n.locale;
	    } else {
	        var body = document.getElementsByTagName("body");
	        if(body && body[0]) {
	            var res = /locale-([a-z]{2}_[A-Z]{2})/.exec(body[0].className);
	            if(res && res[1]) {
	                return res[1];
	            }
	        }
	        return 'en_US';
	    }
	});
	
	define('i18n/i18n',['require','exports','module','underscore','messageformat/messageformat','messageformat/locale/en','messageformat/locale/ja','messageformat/locale/zh','messageformat/locale/ko','messageformat/locale/fr','messageformat/locale/de','messageformat/locale/es','messageformat/locale/it','messageformat/locale/tr','messageformat/locale/ru','messageformat/locale/pt','messageformat/locale/no','messageformat/locale/sv','messageformat/locale/nl','messageformat/locale/pl','messageformat/locale/cs','messageformat/locale/ro','messageformat/locale/in','i18n/locale'],function(require, exports, module) {
	    var _ = require('underscore');
	    var Messageformat = require('messageformat/messageformat');
	
	    // todo: don't do this, load the correct message format in a way that is more fundamentally connected to what locale is loaded
	    require('messageformat/locale/en');
	    require('messageformat/locale/ja');
	    require('messageformat/locale/zh');
	    require('messageformat/locale/ko');
	    require('messageformat/locale/fr');
	    require('messageformat/locale/de');
	    require('messageformat/locale/es');
	    require('messageformat/locale/it');
	    require('messageformat/locale/tr');
	    require('messageformat/locale/ru');
	    require('messageformat/locale/pt');
	    require('messageformat/locale/no');
	    require('messageformat/locale/sv');
	    require('messageformat/locale/nl');
	    require('messageformat/locale/pl');
	    require('messageformat/locale/cs');
	    require('messageformat/locale/ro');
	    require('messageformat/locale/in');
	
	    Messageformat.locale.nb = MessageFormat.locale.no;
	
	    var format = new Messageformat(require('i18n/locale').slice(0,2));
	    var masterConfig = (module.config && module.config()) || {};
	
	    // bootstrap is an array of our i18n hashes
	    // the i18n hashes generally look like:
	    // {
	    //   namespace: "com.fitbit.blah.blah",
	    //   translations: {
	    //      'somekey': 'some translation of some key',
	    //      ...
	    //   }
	    // }
	    return function i18nConstructor(bootstrap) {
	        var namespaces = [];
	
	        function i18n(key) {
	            var args = _.toArray(arguments).slice(1);
	
	            var namespace = i18n._getNamespace(key);
	
	            if (!namespace) {
	                return i18n._handleError(key);
	            }
	
	            var value;
	
	            if (args.length) {
	                value = i18n._ensureMessageFormat(namespace, key).apply(i18n, args);
	            } else {
	                value = namespace.translations[key];
	            }
	
	            return value;
	        }
	
	        i18n._ensureMessageFormat = function _ensureMessageFormat(namespaceObject, key, overrideValue) {
	            var formatted = namespaceObject.formatted[key];
	
	            if(!formatted) {
	                var value = overrideValue || namespaceObject.translations[key];
	                formatted = namespaceObject.formatted[key] = format.compile(value);
	            }
	
	            return formatted;
	        };
	
	        i18n._getNamespace = function _getNamespace(key) {
	            return _.find(namespaces, function (namespace) {
	                return namespace.translations[key];
	            });
	        };
	
	        i18n._handleError = function _handleError(key) {
	            if (masterConfig.strict) {
	                var namespaceNames = _.pluck(i18n.getNamespaces(), 'namespace');
	                throw new Error('missing translation for: "' + key + '" with loaded namespaces: ' + JSON.stringify(namespaceNames));
	            }
	            return key;
	        };
	
	        i18n._handleReserveError = function _handleReserveError(namespace) {
	            if (masterConfig.strict) {
	                var namespaceNames = _.pluck(i18n.getNamespaces(), 'namespace');
	                throw new Error('missing namespace for: "' + namespace + '" with loaded namespaces: ' + JSON.stringify(namespaceNames));
	            }
	        };
	
	        // deprecated: just use normal message formatting
	        i18n.plural = function plural(key) {
	            var namespace = i18n._getNamespace(key);
	
	            if (!namespace) {
	                var errorFallback = i18n._handleError(key);
	                return function() {
	                    return errorFallback;
	                };
	            }
	
	            return function(results) {
	                return i18n._ensureMessageFormat(namespace, key, '{NUM_RESULTS, plural, ' + namespace.translations[key] + '}')({
	                    NUM_RESULTS: results
	                });
	            };
	        };
	
	        // takes an arbitrary amount of objects of the type
	        // {
	        //   namespace: "com.fitbit.blah.blah",
	        //   translations: {
	        //      'somekey': 'some translation of some key',
	        //      ...
	        //   }
	        // }
	        i18n.namespace = function namespace() {
	            _.each(arguments, function(namespaceObject) {
	                if (!namespaceObject) {
	                    return;
	                }
	                // would leak, do we care?
	                namespaceObject.formatted = namespaceObject.formatted || {};
	                namespaces.unshift(namespaceObject);
	            });
	
	            return this;
	        };
	
	        i18n.getNamespaces = function getNamespaces() {
	            return namespaces;
	        };
	
	        i18n.inNamespace = function inNamespace(namespace) {
	            var found = _.find(i18n.getNamespaces(), function (namespaceObject) {
	                return namespaceObject.namespace === namespace;
	            });
	            if(!found) {
	                i18n._handleReserveError(namespace);
	
	                return i18n;
	            }
	            return new i18nConstructor([found]);
	        };
	
	        if(bootstrap) {
	            i18n.namespace.apply(i18n, bootstrap);
	        }
	
	        return i18n;
	    };
	});
	
	/*
	 * 	Vanilla implementation of message variable replacement.
	 * 	e.g. "My message is {0} and {1}." -> "My message is A and B."
	 */
	define('substitute',['require'],function(require) {
	    return function (str) {
	        if (typeof str !== "string") return "";
	        if (arguments.length > 1) {
	            for (var i=0, len = arguments.length; i < len; i++) {
	                str = str.replace("{" + i + "}", arguments[i+1] + "");
	            }
	        }
		    return str;
		};
	});
	
	define('i18n/locales',[],function() {
	    return [
	        'en_US', 'en_CA', 'en_AU', 'en_GB', 'en_IE', 'en_NL', 'en_NO', 'en_SE', 'en_BE', 'en_DK', 'en_FI', 'en_PL', 'en_NZ', 'en_HK', 'en_SG', 'en_ZA', 'en_IL', 'en_TH', 'en_MY', 'en_PH', 'en_ID', 'en_VN', 'en_IN',
	        'ja_JP',
	        'zh_CN', 'zh_TW',
	        'ko_KR',
	        'fr_FR', 'fr_CH', 'fr_CA', 'fr_BE',
	        'de_DE', 'de_AT', 'de_CH',
	        'es_ES', 'es_MX', 'es_CO', 'es_CL', 'es_EC', 'es_VE', 'es_AR', 'es_PE', 'es_PY', 'es_CR', 'es_PA', 'es_PR', 'es_GT',
	        'it_IT', 'it_CH',
	        'nl_NL',
	        'no_NO',
	        'sv_SE',
	        'tr_TR',
	        'ru',
	        'pt_BR',
	        'en_EU'
	    ];
	});
	
	define('i18n/properties/parse',['require','exports','module'],function (require, exports, module) {
	
	var hex = function (c){
	  switch (c){
	    case "0": return 0;
	    case "1": return 1;
	    case "2": return 2;
	    case "3": return 3;
	    case "4": return 4;
	    case "5": return 5;
	    case "6": return 6;
	    case "7": return 7;
	    case "8": return 8;
	    case "9": return 9;
	    case "a": case "A": return 10;
	    case "b": case "B": return 11;
	    case "c": case "C": return 12;
	    case "d": case "D": return 13;
	    case "e": case "E": return 14;
	    case "f": case "F": return 15;
	  }
	};
	
	module.exports = function (data, options, handlers, control){
	  var c;
	  var code;
	  var escape;
	  var skipSpace = true;
	  var isCommentLine;
	  var isSectionLine;
	  var newLine = true;
	  var multiLine;
	  var isKey = true;
	  var key = "";
	  var value = "";
	  var section;
	  var unicode;
	  var unicodeRemaining;
	  var escapingUnicode;
	  var keySpace;
	  var sep;
	  var ignoreLine;
	  
	  var line = function (){
	    if (key || value || sep){
	      handlers.line (key, value);
	      key = "";
	      value = "";
	      sep = false;
	    }
	  };
	  
	  var escapeString = function (key, c, code){
	    if (escapingUnicode && unicodeRemaining){
	      unicode = (unicode << 4) + hex (c);
	      if (--unicodeRemaining) return key;
	      escape = false;
	      escapingUnicode = false;
	      return key + String.fromCharCode (unicode);
	    }
	    
	    //code 117: u
	    if (code === 117){
	      unicode = 0;
	      escapingUnicode = true;
	      unicodeRemaining = 4;
	      return key;
	    }
	    
	    escape = false;
	    
	    //code 116: t
	    //code 114: r
	    //code 110: n
	    //code 102: f
	    if (code === 116) return key + "\t";
	    else if (code === 114) return key + "\r";
	    else if (code === 110) return key + "\n";
	    else if (code === 102) return key + "\f";
	    
	    return key + c;
	  };
	  
	  var isComment;
	  var isSeparator;
	  
	  if (options._strict){
	    isComment = function (c, code, options){
	      return options._comments[c];
	    };
	
	    isSeparator = function (c, code, options){
	      return options._separators[c];
	    };
	  }else{
	    isComment = function (c, code, options){
	      //code 35: #
	      //code 33: !
	      return code === 35 || code === 33 || options._comments[c];
	    };
	
	    isSeparator = function (c, code, options){
	      //code 61: =
	      //code 58: :
	      return code === 61 || code === 58 || options._separators[c];
	    };
	  }
	  
	  for (var i=~~control.resume; i<data.length; i++){
	    if (control.abort) return;
	    if (control.pause){
	      //The next index is always the start of a new line, it's a like a fresh
	      //start, there's no need to save the current state
	      control.resume = i;
	      return;
	    }
	    
	    c = data[i];
	    code = data.charCodeAt (i);
	    
	    //code 13: \r
	    if (code === 13) continue;
	    
	    if (isCommentLine){
	      //code 10: \n
	      if (code === 10){
	        isCommentLine = false;
	        newLine = true;
	        skipSpace = true;
	      }
	      continue;
	    }
	    
	    //code 93: ]
	    if (isSectionLine && code === 93){
	      handlers.section (section);
	      //Ignore chars after the section in the same line
	      ignoreLine = true;
	      continue;
	    }
	    
	    if (skipSpace){
	      //code 32: " " (space)
	      //code 9: \t
	      //code 12: \f
	      if (code === 32 || code === 9 || code === 12){
	        continue;
	      }
	      //code 10: \n
	      if (!multiLine && code === 10){
	        //Empty line or key w/ separator and w/o value
	        isKey = true;
	        keySpace = false;
	        newLine = true;
	        line ();
	        continue;
	      }
	      skipSpace = false;
	      multiLine = false;
	    }
	    
	    if (newLine){
	      newLine = false;
	      if (isComment (c, code, options)){
	        isCommentLine = true;
	        continue;
	      }
	      //code 91: [
	      if (options.sections && code === 91){
	        section = "";
	        isSectionLine = true;
	        control.skipSection = false;
	        continue;
	      }
	    }
	    
	    //code 10: \n
	    if (code !== 10){
	      if (control.skipSection || ignoreLine) continue;
	      
	      if (!isSectionLine){
	        if (!escape && isKey && isSeparator (c, code, options)){
	          //sep is needed to detect empty key and empty value with a
	          //non-whitespace separator
	          sep = true;
	          isKey = false;
	          keySpace = false;
	          //Skip whitespace between separator and value
	          skipSpace = true;
	          continue;
	        }
	      }
	      
	      //code 92: "\" (backslash)
	      if (code === 92){
	        if (escape){
	          if (escapingUnicode) continue;
	          
	          if (keySpace){
	            //Line with whitespace separator
	            keySpace = false;
	            isKey = false;
	          }
	        
	          if (isSectionLine) section += "\\";
	          else if (isKey) key += "\\";
	          else value += "\\";
	        }
	        escape = !escape;
	      }else{
	        if (keySpace){
	          //Line with whitespace separator
	          keySpace = false;
	          isKey = false;
	        }
	        
	        if (isSectionLine){
	          if (escape) section = escapeString (section, c, code);
	          else section += c;
	        }else if (isKey){
	          if (escape){
	            key = escapeString (key, c, code);
	          }else{
	            //code 32: " " (space)
	            //code 9: \t
	            //code 12: \f
	            if (code === 32 || code === 9 || code === 12){
	              keySpace = true;
	              //Skip whitespace between key and separator
	              skipSpace = true;
	              continue;
	            }
	            key += c;
	          }
	        }else{
	          if (escape) value = escapeString (value, c, code);
	          else value += c;
	        }
	      }
	    }else{
	      if (escape){
	        if (!escapingUnicode){
	          escape = false;
	        }
	        skipSpace = true;
	        multiLine = true;
	      }else{
	        if (isSectionLine){
	          isSectionLine = false;
	          if (!ignoreLine){
	            //The section doesn't end with ], it's a key
	            control.error = new Error ("The section line \"" + section +
	                "\" must end with \"]\"");
	            return;
	          }
	          ignoreLine = false;
	        }
	        newLine = true;
	        skipSpace = true;
	        isKey = true;
	        
	        line ();
	      }
	    }
	  }
	  
	  control.parsed = true;
	  
	  if (isSectionLine && !ignoreLine){
	    //The section doesn't end with ], it's a key
	    control.error = new Error ("The section line \"" + section + "\" must end" +
	        "with \"]\"");
	    return;
	  }
	  line ();
	};
	});
	
	define('properties',['require','exports','module','i18n/properties/parse'],function (require, exports, module) {
	
	var parse = require('i18n/properties/parse');
	
	var cast = function (value){
	    if (value === null || value === "null") return null;
	    if (value === "undefined") return undefined;
	    if (value === "true") return true;
	    if (value === "false") return false;
	    var v = Number (value);
	    return isNaN (v) ? value : v;
	};
	
	var searchValue = function (o, chain, section){
	    var n = chain.split (".");
	    var str;
	
	    for (var i=0; i<n.length-1; i++){
	        str = n[i];
	        if (o[str] === undefined) return;
	        o = o[str];
	    }
	
	    var v = o[n[n.length - 1]];
	    if (section){
	        if (typeof v !== "object") return;
	        return v;
	    }else{
	        if (typeof v === "object") return;
	        return v;
	    }
	};
	
	var namespaceKey = function (o, key, value){
	    var n = key.split (".");
	    var str;
	
	    for (var i=0; i<n.length-1; i++){
	        str = n[i];
	        if (o[str] === undefined){
	            o[str] = {};
	        }else if (typeof o[str] !== "object"){
	            throw new Error ("Invalid namespace chain in the property name '" +
	                             key + "' ('" + str + "' has already a value)");
	        }
	        o = o[str];
	    }
	
	    o[n[n.length - 1]] = value;
	};
	
	var namespaceSection = function (o, section){
	    var n = section.split (".");
	    var str;
	
	    for (var i=0; i<n.length; i++){
	        str = n[i];
	        if (o[str] === undefined){
	            o[str] = {};
	        }else if (typeof o[str] !== "object"){
	            throw new Error ("Invalid namespace chain in the section name '" +
	                             section + "' ('" + str + "' has already a value)");
	        }
	        o = o[str];
	    }
	
	    return o;
	};
	
	var merge = function (o1, o2){
	    for (var p in o2){
	        try{
	            if (o1[p].constructor === Object){
	                o1[p] = merge (o1[p], o2[p]);
	            }else{
	                o1[p] = o2[p];
	            }
	        }catch (e){
	            o1[p] = o2[p];
	        }
	    }
	    return o1;
	};
	
	var expand = function  (o, str, options, cb){
	    if (!options.variables || !str) return cb (null, str);
	
	    var stack = [];
	    var c;
	    var cp;
	    var key = "";
	    var section = null;
	    var v;
	    var holder;
	    var t;
	    var n;
	
	    for (var i=0; i<str.length; i++){
	        c = str[i];
	
	        if (cp === "$" && c === "{"){
	            key = key.substring (0, key.length - 1);
	            stack.push ({
	                key: key,
	                section: section
	            });
	            key = "";
	            section = null;
	            continue;
	        }else if (stack.length){
	            if (options.sections && c === "|"){
	                section = key;
	                key = "";
	                continue;
	            }else if (c === "}"){
	                holder = section !== null ? searchValue (o, section, true) : o;
	                if (!holder){
	                    return cb (new Error ("The section \"" + section + "\" does not " +
	                                          "exist"));
	                }
	
	                v = options.namespaces ? searchValue (holder, key) : holder[key];
	                if (v === undefined){
	                    //Read the external vars
	                    v = options.namespaces ? searchValue (options._vars, key) : options._vars[key];
	
	                        if (v === undefined){
	                            return cb (new Error ("The property \"" + key + "\" does not " +
	                                                  "exist"));
	                        }
	                }
	
	                t = stack.pop ();
	                section = t.section;
	                key = t.key + (v === null ? "" : v);
	                continue;
	            }
	        }
	
	        cp = c;
	        key += c;
	    }
	
	    if (stack.length !== 0){
	        return cb (new Error ("Malformed variable: " + str));
	    }
	
	    cb (null, key);
	};
	
	var build = function (data, options, dirname, cb){
	    var o = {};
	    var n;
	
	    if (options.namespaces){
	        n = {};
	    }
	
	    var control = {
	        abort: false,
	        skipSection: false
	    };
	
	    if (!data){
	        if (cb) return cb (null, o);
	        return o;
	    }
	
	    var currentSection = null;
	    var currentSectionStr = null;
	
	    var abort = function (error){
	        control.abort = true;
	        if (cb) return cb (error);
	        throw error;
	    };
	
	    var handlers = {};
	    var reviver = {
	        assert: function (){
	            return this.isProperty ? reviverLine.value : true;
	        }
	    };
	    var reviverLine = {};
	
	    //Line handler
	    //For speed reasons, if "namespaces" is enabled, the old object is still
	    //populated, e.g.: ${a.b} reads the "a.b" property from { "a.b": 1 }, instead
	    //of having a unique object { a: { b: 1 } } which is slower to search for
	    //the "a.b" value
	    //If "a.b" is not found, then the external vars are read. If "namespaces" is
	    //enabled, the var "a.b" is split and it searches the a.b value. If it is not
	    //enabled, then the var "a.b" searches the "a.b" value
	
	    var line;
	    var error;
	
	    if (options.reviver){
	        if (options.sections){
	            line = function (key, value){
	                reviverLine.value = value;
	                reviver.isProperty = true;
	                reviver.isSection = false;
	
	                value = options.reviver.call (reviver, key, value, currentSectionStr);
	                if (value !== undefined){
	                    if (options.namespaces){
	                        try{
	                            namespaceKey (currentSection === null ? n : currentSection,
	                                          key, value);
	                        }catch (error){
	                            abort (error);
	                        }
	                    }else{
	                        if (currentSection === null) o[key] = value;
	                        else currentSection[key] = value;
	                    }
	                }
	            };
	        }else{
	            line = function (key, value){
	
	                reviverLine.value = value;
	                reviver.isProperty = true;
	                reviver.isSection = false;
	
	                value = options.reviver.call (reviver, key, value);
	                if (value !== undefined){
	                    if (options.namespaces){
	                        try{
	                            namespaceKey (n, key, value);
	                        }catch (error){
	                            abort (error);
	                        }
	                    }else{
	                        o[key] = value;
	                    }
	                }
	            };
	        }
	    }else{
	        if (options.sections){
	            line = function (key, value){
	                if (options.namespaces){
	                    try{
	                        namespaceKey (currentSection === null ? n : currentSection, key,
	                                      value);
	                    }catch (error){
	                        abort (error);
	                    }
	                }else{
	                    if (currentSection === null) o[key] = value;
	                    else currentSection[key] = value;
	                }
	            };
	        }else{
	            line = function (key, value){
	                if (options.namespaces){
	                    try{
	                        namespaceKey (n, key, value);
	                    }catch (error){
	                        abort (error);
	                    }
	                }else{
	                    o[key] = value;
	                }
	            };
	        }
	    }
	
	    //Section handler
	    var section;
	    if (options.sections){
	        if (options.reviver){
	            section = function (section){
	                currentSectionStr = section;
	                reviverLine.section = section;
	                reviver.isProperty = false;
	                reviver.isSection = true;
	
	                var add = options.reviver.call (reviver, null, null, section);
	                if (add){
	                    if (options.namespaces){
	                        try{
	                            currentSection = namespaceSection (n, section);
	                        }catch (error){
	                            abort (error);
	                        }
	                    }else{
	                        currentSection = o[section] = {};
	                    }
	                }else{
	                    control.skipSection = true;
	                }
	            };
	        }else{
	            section = function (section){
	                currentSectionStr = section;
	                if (options.namespaces){
	                    try{
	                        currentSection = namespaceSection (n, section);
	                    }catch (error){
	                        abort (error);
	                    }
	                }else{
	                    currentSection = o[section] = {};
	                }
	            };
	        }
	    }
	
	    //Variables
	    if (options.variables){
	        handlers.line = function (key, value){
	            expand(options.namespaces ? n : o, key, options, function (error, key){
	                if (error) return abort (error);
	
	                expand(options.namespaces ? n : o, value, options,
	                        function (error, value){
	                            if (error) return abort (error);
	
	                            line (key, cast (value || null));
	                        });
	            });
	        };
	
	        if (options.sections){
	            handlers.section = function (s){
	                expand(options.namespaces ? n : o, s, options, function (error, s){
	                    if (error) return abort (error);
	
	                    section (s);
	                });
	            };
	        }
	    }else{
	        handlers.line = function (key, value){
	            line (key, cast (value || null));
	        };
	
	        if (options.sections){
	            handlers.section = section;
	        }
	    }
	
	    parse (data, options, handlers, control);
	    if (control.error) return abort (control.error);
	
	    if (control.abort || control.pause) return;
	
	    if (cb) return cb (null, options.namespaces ? n : o);
	    return options.namespaces ? n : o;
	
	};
	
	var preParse = function (data, options, cb) {
	    if (typeof options === "function"){
	        cb = options;
	        options = {};
	    }
	
	    var code;
	
	    options = options || {};
	    options._strict = options.strict && (options.comments || options.separators);
	    options._vars = options.vars || {};
	
	    var comments = options.comments || [];
	    if (!Array.isArray (comments)) comments = [comments];
	    var c = {};
	    comments.forEach (function (comment){
	        code = comment.charCodeAt (0);
	        if (comment.length > 1 || code < 33 || code > 126){
	            throw new Error ("The comment token must be a single printable ASCII " +
	                             "character");
	        }
	        c[comment] = true;
	    });
	    options._comments = c;
	
	    var separators = options.separators || [];
	    if (!Array.isArray (separators)) separators = [separators];
	    var s = {};
	    separators.forEach (function (separator){
	        code = separator.charCodeAt (0);
	        if (separator.length > 1 || code < 33 || code > 126){
	            throw new Error ("The separator token must be a single printable ASCII " +
	                             "character");
	        }
	        s[separator] = true;
	    });
	    options._separators = s;
	
	    return build(data, options, ".", cb);
	};
	
	module.exports = {
	  parse: preParse
	};
	});
	
	/**
	 * @license RequireJS text 2.0.14 Copyright (c) 2010-2014, The Dojo Foundation All Rights Reserved.
	 * Available via the MIT or new BSD license.
	 * see: http://github.com/requirejs/text for details
	 */
	/*jslint regexp: true */
	/*global require, XMLHttpRequest, ActiveXObject,
	 define, window, process, Packages,
	 java, location, Components, FileUtils */
	
	define('text',['module'], function (module) {
	    
	
	    var text, fs, Cc, Ci, xpcIsWindows,
	        progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'],
	        xmlRegExp = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im,
	        bodyRegExp = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
	        hasLocation = typeof location !== 'undefined' && location.href,
	        defaultProtocol = hasLocation && location.protocol && location.protocol.replace(/\:/, ''),
	        defaultHostName = hasLocation && location.hostname,
	        defaultPort = hasLocation && (location.port || undefined),
	        buildMap = {},
	        masterConfig = (module.config && module.config()) || {};
	
	    text = {
	        version: '2.0.14',
	
	        strip: function (content) {
	            //Strips <?xml ...?> declarations so that external SVG and XML
	            //documents can be added to a document without worry. Also, if the string
	            //is an HTML document, only the part inside the body tag is returned.
	            if (content) {
	                content = content.replace(xmlRegExp, "");
	                var matches = content.match(bodyRegExp);
	                if (matches) {
	                    content = matches[1];
	                }
	            } else {
	                content = "";
	            }
	            return content;
	        },
	
	        jsEscape: function (content) {
	            return content.replace(/(['\\])/g, '\\$1')
	                .replace(/[\f]/g, "\\f")
	                .replace(/[\b]/g, "\\b")
	                .replace(/[\n]/g, "\\n")
	                .replace(/[\t]/g, "\\t")
	                .replace(/[\r]/g, "\\r")
	                .replace(/[\u2028]/g, "\\u2028")
	                .replace(/[\u2029]/g, "\\u2029");
	        },
	
	        createXhr: masterConfig.createXhr || function () {
	            //Would love to dump the ActiveX crap in here. Need IE 6 to die first.
	            var xhr, i, progId;
	            if (typeof XMLHttpRequest !== "undefined") {
	                return new XMLHttpRequest();
	            } else if (typeof ActiveXObject !== "undefined") {
	                for (i = 0; i < 3; i += 1) {
	                    progId = progIds[i];
	                    try {
	                        xhr = new ActiveXObject(progId);
	                    } catch (e) {}
	
	                    if (xhr) {
	                        progIds = [progId];  // so faster next time
	                        break;
	                    }
	                }
	            }
	
	            return xhr;
	        },
	
	        /**
	         * Parses a resource name into its component parts. Resource names
	         * look like: module/name.ext!strip, where the !strip part is
	         * optional.
	         * @param {String} name the resource name
	         * @returns {Object} with properties "moduleName", "ext" and "strip"
	         * where strip is a boolean.
	         */
	        parseName: function (name) {
	            var modName, ext, temp,
	                strip = false,
	                index = name.lastIndexOf("."),
	                isRelative = name.indexOf('./') === 0 ||
	                    name.indexOf('../') === 0;
	
	            if (index !== -1 && (!isRelative || index > 1)) {
	                modName = name.substring(0, index);
	                ext = name.substring(index + 1);
	            } else {
	                modName = name;
	            }
	
	            temp = ext || modName;
	            index = temp.indexOf("!");
	            if (index !== -1) {
	                //Pull off the strip arg.
	                strip = temp.substring(index + 1) === "strip";
	                temp = temp.substring(0, index);
	                if (ext) {
	                    ext = temp;
	                } else {
	                    modName = temp;
	                }
	            }
	
	            return {
	                moduleName: modName,
	                ext: ext,
	                strip: strip
	            };
	        },
	
	        xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/,
	
	        /**
	         * Is an URL on another domain. Only works for browser use, returns
	         * false in non-browser environments. Only used to know if an
	         * optimized .js version of a text resource should be loaded
	         * instead.
	         * @param {String} url
	         * @returns Boolean
	         */
	        useXhr: function (url, protocol, hostname, port) {
	            var uProtocol, uHostName, uPort,
	                match = text.xdRegExp.exec(url);
	            if (!match) {
	                return true;
	            }
	            uProtocol = match[2];
	            uHostName = match[3];
	
	            uHostName = uHostName.split(':');
	            uPort = uHostName[1];
	            uHostName = uHostName[0];
	
	            return (!uProtocol || uProtocol === protocol) &&
	                (!uHostName || uHostName.toLowerCase() === hostname.toLowerCase()) &&
	                ((!uPort && !uHostName) || uPort === port);
	        },
	
	        finishLoad: function (name, strip, content, onLoad) {
	            content = strip ? text.strip(content) : content;
	            if (masterConfig.isBuild) {
	                buildMap[name] = content;
	            }
	            onLoad(content);
	        },
	
	        load: function (name, req, onLoad, config) {
	            //Name has format: some.module.filext!strip
	            //The strip part is optional.
	            //if strip is present, then that means only get the string contents
	            //inside a body tag in an HTML string. For XML/SVG content it means
	            //removing the <?xml ...?> declarations so the content can be inserted
	            //into the current doc without problems.
	
	            // Do not bother with the work if a build and text will
	            // not be inlined.
	            if (config && config.isBuild && !config.inlineText) {
	                onLoad();
	                return;
	            }
	
	            masterConfig.isBuild = config && config.isBuild;
	
	            var parsed = text.parseName(name),
	                nonStripName = parsed.moduleName +
	                    (parsed.ext ? '.' + parsed.ext : ''),
	                url = req.toUrl(nonStripName),
	                useXhr = (masterConfig.useXhr) ||
	                    text.useXhr;
	
	            // Do not load if it is an empty: url
	            if (url.indexOf('empty:') === 0) {
	                onLoad();
	                return;
	            }
	
	            //Load the text. Use XHR if possible and in a browser.
	            if (!hasLocation || useXhr(url, defaultProtocol, defaultHostName, defaultPort)) {
	                text.get(url, function (content) {
	                    text.finishLoad(name, parsed.strip, content, onLoad);
	                }, function (err) {
	                    if (onLoad.error) {
	                        onLoad.error(err);
	                    }
	                });
	            } else {
	                //Need to fetch the resource across domains. Assume
	                //the resource has been optimized into a JS module. Fetch
	                //by the module name + extension, but do not include the
	                //!strip part to avoid file system issues.
	                req([nonStripName], function (content) {
	                    text.finishLoad(parsed.moduleName + '.' + parsed.ext,
	                        parsed.strip, content, onLoad);
	                });
	            }
	        },
	
	        write: function (pluginName, moduleName, write, config) {
	            if (buildMap.hasOwnProperty(moduleName)) {
	                var content = text.jsEscape(buildMap[moduleName]);
	                write.asModule(pluginName + "!" + moduleName,
	                    "define(function () { return '" +
	                    content +
	                    "';});\n");
	            }
	        },
	
	        writeFile: function (pluginName, moduleName, req, write, config) {
	            var parsed = text.parseName(moduleName),
	                extPart = parsed.ext ? '.' + parsed.ext : '',
	                nonStripName = parsed.moduleName + extPart,
	            //Use a '.js' file name so that it indicates it is a
	            //script that can be loaded across domains.
	                fileName = req.toUrl(parsed.moduleName + extPart) + '.js';
	
	            //Leverage own load() method to load plugin value, but only
	            //write out values that do not have the strip argument,
	            //to avoid any potential issues with ! in file names.
	            text.load(nonStripName, req, function (value) {
	                //Use own write() method to construct full module value.
	                //But need to create shell that translates writeFile's
	                //write() to the right interface.
	                var textWrite = function (contents) {
	                    return write(fileName, contents);
	                };
	                textWrite.asModule = function (moduleName, contents) {
	                    return write.asModule(moduleName, fileName, contents);
	                };
	
	                text.write(pluginName, nonStripName, textWrite, config);
	            }, config);
	        }
	    };
	
	    if (masterConfig.env === 'node' || (!masterConfig.env &&
	        typeof process !== "undefined" &&
	        process.versions &&
	        !!process.versions.node &&
	        !process.versions['node-webkit'] &&
	        !process.versions['atom-shell'])) {
	        //Using special require.nodeRequire, something added by r.js.
	        fs = require.nodeRequire('fs');
	
	        text.get = function (url, callback, errback) {
	            try {
	                var file = fs.readFileSync(url, 'utf8');
	                //Remove BOM (Byte Mark Order) from utf8 files if it is there.
	                if (file[0] === '\uFEFF') {
	                    file = file.substring(1);
	                }
	                callback(file);
	            } catch (e) {
	                if (errback) {
	                    errback(e);
	                }
	            }
	        };
	    } else if (masterConfig.env === 'xhr' || (!masterConfig.env &&
	        text.createXhr())) {
	        text.get = function (url, callback, errback, headers) {
	            var xhr = text.createXhr(), header;
	            xhr.open('GET', url, true);
	
	            //Allow plugins direct access to xhr headers
	            if (headers) {
	                for (header in headers) {
	                    if (headers.hasOwnProperty(header)) {
	                        xhr.setRequestHeader(header.toLowerCase(), headers[header]);
	                    }
	                }
	            }
	
	            //Allow overrides specified in config
	            if (masterConfig.onXhr) {
	                masterConfig.onXhr(xhr, url);
	            }
	
	            xhr.onreadystatechange = function (evt) {
	                var status, err;
	                //Do not explicitly handle errors, those should be
	                //visible via console output in the browser.
	                if (xhr.readyState === 4) {
	                    status = xhr.status || 0;
	                    if (status > 399 && status < 600) {
	                        //An http 4xx or 5xx error. Signal an error.
	                        err = new Error(url + ' HTTP status: ' + status);
	                        err.xhr = xhr;
	                        if (errback) {
	                            errback(err);
	                        }
	                    } else {
	                        callback(xhr.responseText);
	                    }
	
	                    if (masterConfig.onXhrComplete) {
	                        masterConfig.onXhrComplete(xhr, url);
	                    }
	                }
	            };
	            xhr.send(null);
	        };
	    } else if (masterConfig.env === 'rhino' || (!masterConfig.env &&
	        typeof Packages !== 'undefined' && typeof java !== 'undefined')) {
	        //Why Java, why is this so awkward?
	        text.get = function (url, callback) {
	            var stringBuffer, line,
	                encoding = "utf-8",
	                file = new java.io.File(url),
	                lineSeparator = java.lang.System.getProperty("line.separator"),
	                input = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(file), encoding)),
	                content = '';
	            try {
	                stringBuffer = new java.lang.StringBuffer();
	                line = input.readLine();
	
	                // Byte Order Mark (BOM) - The Unicode Standard, version 3.0, page 324
	                // http://www.unicode.org/faq/utf_bom.html
	
	                // Note that when we use utf-8, the BOM should appear as "EF BB BF", but it doesn't due to this bug in the JDK:
	                // http://bugs.sun.com/bugdatabase/view_bug.do?bug_id=4508058
	                if (line && line.length() && line.charAt(0) === 0xfeff) {
	                    // Eat the BOM, since we've already found the encoding on this file,
	                    // and we plan to concatenating this buffer with others; the BOM should
	                    // only appear at the top of a file.
	                    line = line.substring(1);
	                }
	
	                if (line !== null) {
	                    stringBuffer.append(line);
	                }
	
	                while ((line = input.readLine()) !== null) {
	                    stringBuffer.append(lineSeparator);
	                    stringBuffer.append(line);
	                }
	                //Make sure we return a JavaScript string and not a Java string.
	                content = String(stringBuffer.toString()); //String
	            } finally {
	                input.close();
	            }
	            callback(content);
	        };
	    } else if (masterConfig.env === 'xpconnect' || (!masterConfig.env &&
	        typeof Components !== 'undefined' && Components.classes &&
	        Components.interfaces)) {
	        //Avert your gaze!
	        Cc = Components.classes;
	        Ci = Components.interfaces;
	        Components.utils['import']('resource://gre/modules/FileUtils.jsm');
	        xpcIsWindows = ('@mozilla.org/windows-registry-key;1' in Cc);
	
	        text.get = function (url, callback) {
	            var inStream, convertStream, fileObj,
	                readData = {};
	
	            if (xpcIsWindows) {
	                url = url.replace(/\//g, '\\');
	            }
	
	            fileObj = new FileUtils.File(url);
	
	            //XPCOM, you so crazy
	            try {
	                inStream = Cc['@mozilla.org/network/file-input-stream;1']
	                    .createInstance(Ci.nsIFileInputStream);
	                inStream.init(fileObj, 1, 0, false);
	
	                convertStream = Cc['@mozilla.org/intl/converter-input-stream;1']
	                    .createInstance(Ci.nsIConverterInputStream);
	                convertStream.init(inStream, "utf-8", inStream.available(),
	                    Ci.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER);
	
	                convertStream.readString(inStream.available(), readData);
	                convertStream.close();
	                inStream.close();
	                callback(readData.value);
	            } catch (e) {
	                throw new Error((fileObj && fileObj.path || '') + ': ' + e);
	            }
	        };
	    }
	    return text;
	});
	define('props',['module', 'properties', 'text'], function(module, properties, text) {
	    var buildMap = {};
	
	    function writeOutput(moduleName, content) {
	        return 'define(\'' + moduleName + '\', ' +
	            JSON.stringify(content) +
	            ');'
	    }
	
	    return {
	        load: function load(name, req, onload) {
	            if(buildMap[name]) {
	                onload(buildMap[name]);
	            } else {
	                this.get(req.toUrl(name), function (result) {
	                    buildMap[name] = result;
	                    onload(result);
	                }, function (err) {
	                    if (onload.error) {
	                        onload.error(err);
	                    }
	                });
	            }
	        },
	        write: function write(pluginName, moduleName, write) {
	            write(writeOutput(pluginName, moduleName, buildMap[moduleName]));
	        },
	        get: function get(url, callback, errback) {
	            text.get(url, function (result) {
	                return callback(properties.parse(result));
	            }, errback);
	        },
	        writeOutput: writeOutput
	    }
	});
	
	define('i18n-load',['module', 'i18n/locales', 'underscore'
	        ], function(module, locales, _
	        ) {
	
	    var masterConfig = (module.config && module.config()) || {};
	
	    function findFallbacks(locale) {
	        // base en_US version is always a fallback
	        var output = ['en_US'];
	
	        _.each(masterConfig.fallbacks, function(fallback) {
	            if(fallback.test.test(locale) && output.indexOf(fallback.fallback) === -1) {
	                output.push(fallback.fallback);
	            }
	        });
	
	        if(locales.indexOf(locale) !== -1 && output.indexOf(locale) === -1) {
	            output.push(locale);
	        }
	
	        return output;
	    }
	
	    
	    function localizeName(name, locale) {
	        return name + '.' + _.last(findFallbacks(locale));
	    }
	
	    return {
	        load: function load(name, parentRequire, onload, config) {
	            if (!config.isBuild) {
	                parentRequire(['i18n/locale'], function(locale) {
	                    var built = true;
	                                        if(built) {
	                        var localizedName = localizeName(name, locale);
	                        parentRequire([localizedName], function(result) {
	                            onload(result);
	                        });
	                    }
	                });
	            }
	                    }
	    }
	});
	
	define('galileo/util/dateUtil',['require','i18n/i18n','substitute','jquery','galileo/prototype/array','galileo/prototype/function','i18n-load!com/fitbit/util/relativedateutil','i18n-load!core/com/fitbit/util/dateformat'],function(require) {
	    
	
	    var i18n = require('i18n/i18n')(),
	        substituteUtil = require('substitute'),
	        $ = require('jquery');
	
	    require('galileo/prototype/array');
	    require('galileo/prototype/function');
	
	    i18n.namespace(require('i18n-load!com/fitbit/util/relativedateutil'));
	    i18n.namespace(require('i18n-load!core/com/fitbit/util/dateformat'));
	
	    var dateFormatI18n = i18n.inNamespace('com.fitbit.util.dateformat');
	
	    // Private helper to get localized strings, or English defaults for development.
	    function _getStrings(str, defaultList) {
	        var ret = str.split(',').map(function(x) {
	            return x.trim();
	        });
	
	        return ret.length <= 1 ? defaultList : ret;
	    }
	
	    var relativeDateMessageBundle = {
	            'just_now': i18n('just_now'),
	            'seconds': i18n('seconds'),
	            'minute': i18n('minute'),
	            'minutes': i18n('minutes'),
	            'hour': i18n('hour'),
	            'hours': i18n('hours'),
	            'day': i18n('day'),
	            'days': i18n('days'),
	            'week': i18n('week'),
	            'weeks': i18n('weeks'),
	            'months': i18n.inNamespace('com.fitbit.util.relativedateutil')('months'),
	            'years': i18n('years')
	        },
	        localeFormats = {
	            // Conveniently support our commonly used date formats, without explicitly using i18n keys.
	            'EEE, MMM d': i18n('weekday_month_date_medium'), // Tue, Feb 14
	            'EEE, M/d': i18n('weekday_month_date_short'), // Mon, 2/14
	            'M/dd/yyyy': i18n('month_date_year_short'), // 2/27/12
	            'MMMM dd, yyyy': i18n('month_date_year_long'), // February 14, 2012
	            'MMM dd, yyyy': i18n('month_date_year_medium'), // Feb 14, 2012
	            'MMM': dateFormatI18n('month'), // Feb
	            'MMM dd': i18n('month_date'), // Feb 14
	            'MMMM dd': i18n('month_date_long'), // February 04
	            'MMMM d': i18n('month_long_date_short'), // February 4
	            'MMM yyyy': i18n('month_year_medium'), // Feb 2012
	            'MMMM yyyy': i18n('month_year'), // February 2012
	            'EEE': i18n('weekday'), // Mon Tue Wed Thu Fri Sat Sun
	            'EEEE, MMMM dd': i18n('weekday_month_date_long'), // Monday, February 06
	            'EEE, MMM d, yyyy': i18n('weekday_month_date_year'), // Mon, Feb 3, 2012
	            'MMM d, hh:mm a': i18n('month_date_time'), // Feb 6 10:22 AM
	            'MMM d, HH:mm': i18n('month_date_time_24'), // Feb 6 20:22
	
	            // This seems to be universal?
	            'hh:mm a': i18n('dash_time_12'),
	            'hh:mm:ss': 'hh:mm:ss',
	            'HH:mm': i18n('dash_time_24'),
	            'HH:mm:ss': 'HH:mm:ss',
	            'hh:mm': 'hh:mm',
	            'hha': 'hha'
	        },
	        amPm = _getStrings(dateFormatI18n('am_pm'), ['AM','PM']),
	        weekdays = _getStrings(dateFormatI18n('weekdays'), ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']),
	        shortWeekdays = _getStrings(dateFormatI18n('short_weekdays'), ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']),
	        extraminWeekdays = _getStrings(dateFormatI18n('extramin_weekdays'), ['S', 'M', 'T', 'W', 'T', 'F', 'S']),
	        months = _getStrings(dateFormatI18n('months'),
	                                 ['January', 'February', 'March', 'April', 'May',
	                                  'June', 'July', 'August', 'September', 'October', 'November', 'December']),
	        shortMonths = _getStrings(dateFormatI18n('short_months'),
	                                      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']),
	        subRE;
	
	    /**
	     *  Formats a date object into a readable format.
	     *  @method _localeFormat
	     *  @param {Date} A JavaScript date object.
	     *  @param {String} The desired output format.
	     *  @param {Object} A custom localization bundle. (Optional)
	     *  @returns {String} A formatted, localized string like 'Mon, Nov 17'.
	     */
	    function _localeFormat(date, fmt, formatMapping) {
	        var yy = date.getFullYear() % 100,
	            substitutions = {
	                'yyyy': date.getFullYear(),
	                'yy': yy > 9 ? '' + yy : '0' + yy,
	                'MMMM': months[date.getMonth()],
	                'MMM': shortMonths[date.getMonth()],
	                'MM': date.getMonth() >= 9 ? '' + (date.getMonth() + 1) : '0' + (date.getMonth() + 1),
	                'M': '' + (date.getMonth() + 1),
	                'dd': date.getDate() > 9 ? '' + date.getDate() : '0' + date.getDate(),
	                'd': '' + date.getDate(),
	                'EEEE': weekdays[date.getDay()],
	                'EEE': shortWeekdays[date.getDay()],
	                'E': extraminWeekdays[date.getDay()],
	                'HH': date.getHours() > 9 ? '' + date.getHours() : '0' + date.getHours(),
	                'hh': '' + (date.getHours() % 12 || 12),
	                'mm': date.getMinutes() > 9 ? '' + date.getMinutes() : '0' + date.getMinutes(),
	                'ss': date.getSeconds() > 9 ? '' + date.getSeconds() : '0' + date.getSeconds(),
	                'H': '' + date.getHours(),
	                'h': '' + (date.getHours() % 12 || 12),
	                'm': '' + date.getMinutes(),
	                's': '' + date.getSeconds(),
	                'a': date.getHours() >= 12 ? amPm[1] : amPm[0]
	            };
	
	        formatMapping = formatMapping ? formatMapping : localeFormats;
	
	        if (!formatMapping[fmt] && !substitutions[fmt]) {
	            throw 'Unsupported localized date format: ' + fmt;
	        }
	
	        if (substitutions[fmt]) {
	            return substitutions[fmt];
	        }
	
	        // Just construct the regex once - (yyyy|yy|MMMM|MMM|...)
	        subRE = subRE || new RegExp('(' + Object.keys(substitutions).sortBy(Function.takeKey('length')).reverse().join('|') + ')', 'g');
	        return formatMapping[fmt].replace(subRE, function(match) { return substitutions[match]; });
	    }
	
	    /**
	     *  A function for deriving relative date strings.
	     *  @method _getRelativeDate
	     *  @param {String} Any string that can be parsed by Date().
	     *  @param {Boolean} Assume the date string is in ISO8601 format and convert it.
	     *  @param {Object} A custom localization bundle. (Optional)
	     *  @returns {String} A relative date string like '1 hour ago', '2 weeks ago'. These messages are pulled from localized message bundles.
	     */
	    function _getRelativeDate(dateTime, isDateFormatISO, formatMapping) {
	        var delta,
	            relativeDate = '',
	            minute = 60,
	            hour = minute * 60,
	            day = hour * 24,
	            week = day * 7,
	            month = week * 4,
	            year = month * 12,
	            getMessage = function(key, num) {
	                // Returns a localized relative date based on the partial message key supplied.
	                return formatMapping[key] ? substituteUtil(formatMapping[key], num) : '';
	            };
	
	            formatMapping = formatMapping ? formatMapping : relativeDateMessageBundle;
	
	        // Attempt to parse an ISO8601 date string.
	        if (isDateFormatISO) {
	            try {
	                dateTime = _getDateFromISO8601(dateTime, (dateTime.charAt(dateTime.length - 1) === 'Z')); // If the last character is a 'Z', the date string is already UTC.
	            } catch (e) {
	                if (console) {
	                    console.log('_getRelativeDate: improperly formatted ISO8601 date string');
	                }
	                return '';
	            }
	        }
	
	        // Compute delta between right now and the specified date, in seconds.
	        delta = Math.floor((new Date().getTime() - new Date(dateTime).getTime()) / 1000);
	
	        // Derive a relative date string based on the delta between right now and the time specified.
	        if ($.isNumeric(delta)) {
	            if (delta < 30) {
	                relativeDate = getMessage('just_now', delta);
	            } else if (delta < minute) {
	                relativeDate = getMessage('seconds', delta);
	            } else if (delta < minute * 2) {
	                relativeDate = getMessage('minute', '1');
	            } else if (delta < hour) {
	                relativeDate = getMessage('minutes', Math.floor(delta / minute));
	            } else if (delta < hour * 2) {
	                relativeDate = getMessage('hour', '1');
	            } else if (delta < day) {
	                relativeDate = getMessage('hours', Math.floor(delta / hour));
	            } else if (delta < day * 2) {
	                relativeDate = getMessage('day', '1');
	            } else if (delta < week) {
	                relativeDate = getMessage('days', Math.floor(delta / day));
	            } else if (delta < week * 2) {
	                relativeDate = getMessage('week', '1');
	            } else if (delta < month * 3) {
	                relativeDate = getMessage('weeks', Math.floor(delta / week));
	            } else if (delta < year * 2) {
	                relativeDate = getMessage('months', Math.floor(delta / month));
	            } else {
	                relativeDate = getMessage('years', Math.floor(delta / year));
	            }
	        }
	
	        return relativeDate;
	    }
	
	    /**
	     *  Given an ISO8601 date string (e.g. '2012-11-12T18:17:00.000Z'), return a proper Date instance.
	     *  @method _getDateFromISO8601
	     *  @param {String} The ISO8601 date string to be parsed.
	     *  @param {Boolean} Convert the result to UTC.
	     *  @returns {Date} The converted date object.
	     */
	    function _getDateFromISO8601(dateString, doConversionToUTC) {
	        var dateParts = dateString.match(/([0-9]{4})(-([0-9]{2})(-([0-9]{2})(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?/),
	            offset = 0,
	            date = new Date(dateParts[1], 0, 1),
	            convertedDate;
	
	        if (dateParts[3]) { date.setMonth(dateParts[3] - 1); }
	        if (dateParts[5]) { date.setDate(dateParts[5]); }
	        if (dateParts[7]) { date.setHours(dateParts[7]); }
	        if (dateParts[8]) { date.setMinutes(dateParts[8]); }
	        if (dateParts[10]) { date.setSeconds(dateParts[10]); }
	        if (dateParts[12]) { date.setMilliseconds(Number('0.' + dateParts[12]) * 1000); }
	        if (dateParts[14]) {
	            offset = (Number(dateParts[16]) * 60) + Number(dateParts[17]);
	            offset *= ((dateParts[15] === '-') ? 1 : -1);
	        }
	
	        if (!doConversionToUTC) {
	            offset -= date.getTimezoneOffset();
	        }
	
	        convertedDate = new Date();
	        convertedDate.setTime(Number(Number(date) + (offset * 60 * 1000)));
	
	        return convertedDate;
	    }
	
	    /**
	     *  Given a Date object, return a string in the YY-mm-dd format commonly used for AJAX requests.
	     *  @method _ajaxEncode
	     *  @param {Date} A JavaScript Date object.
	     *  @returns {String} The date in the hyphen delimited format.
	     */
	    function _ajaxEncode(date) {
	        var pad = function(n) {
	            if (('' + n).length === 1) {
	                return '0' + n;
	            }
	
	            return '' + n;
	        };
	
	        return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
	    }
	
	    /**
	     *  Given a String the YY-mm-dd format commonly used for AJAX requests, return a Date object.
	     *  @method _ajaxDecode
	     *  @param {String} A String in the YY-mm-dd format commonly used for AJAX requests.
	     *  @returns {Date} The created Date object.
	     */
	    function _ajaxDecode(dateString) {
	        var parts     = dateString.split(' '),
	            dateParts = parts[0].split('-');
	
	        // Date and time
	        if (parts.length > 1) {
	            var timeParts = parts[1].split(':');
	            return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
	        }
	
	        // Just date
	        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
	    }
	
	    /**
	     *  Given a String in a time format hh:mm:ss, return a Date object. Seconds are ignored.
	     *  @method _forTime
	     *  @param {String} A String in the hh:mm:ss format.
	     *  @returns {Date} The created Date object.
	     */
	    function _forTime(time) {
	        var parts = time.split(':'),
	            ret = new Date();
	
	        ret.setHours(parts[0]);
	        ret.setMinutes(parts[1]);
	        ret.setSeconds(0);
	        ret.setMilliseconds(0);
	
	        return ret;
	    }
	
	    // Private helper for date computations.
	    function _compute(type, fn) {
	        return function(date, n) {
	            var copy = new Date(date.getTime());
	
	            copy['set' + type](copy['get' + type]() + fn(n));
	
	            return copy;
	        };
	    }
	
	    return {
	        getRelativeDate     : _getRelativeDate,
	        getDateFromISO8601  : _getDateFromISO8601,
	        ajaxEncode          : _ajaxEncode,
	        ajaxDecode          : _ajaxDecode,
	        forTime             : _forTime,
	
	        plusMinutes         : _compute('Time', function(n) { return n * 60 * 1000; }),
	        minusMinutes        : _compute('Time', function(n) { return -(n * 60 * 1000); }),
	        plusDays            : _compute('Date', function(n) { return n; }),
	        minusDays           : _compute('Date', function(n) { return -n; }),
	        plusWeeks           : _compute('Date', function(n) { return n * 7; }),
	        minusWeeks          : _compute('Date', function(n) { return -n * 7; }),
	        plusMonths          : _compute('Month', function(n) { return n; }),
	        minusMonths         : _compute('Month', function(n) { return -n; }),
	        plusYears           : _compute('FullYear', function(n) { return n; }),
	        minusYears          : _compute('FullYear', function(n) { return -n; }),
	
	        localeFormat        : _localeFormat,
	
	        diff: function(date1, date2) {
	            return date1.getTime() - date2.getTime();
	        },
	
	        diffInSeconds: function(date1, date2, doNotFloor) {
	            var diff = this.diff(date1, date2) / 1000;
	            return doNotFloor ? diff : (Math.abs(diff) !== diff ? Math.ceil(diff) : Math.floor(diff));
	        },
	
	        diffInMinutes: function(date1, date2, doNotFloor) {
	            var diff = this.diffInSeconds(date1, date2, true) / 60;
	            return doNotFloor ? diff : (Math.abs(diff) !== diff ? Math.ceil(diff) : Math.floor(diff));
	        },
	
	        diffInHours: function(date1, date2, doNotFloor) {
	            var diff = this.diffInMinutes(date1, date2, true) / 60;
	            return doNotFloor ? diff : (Math.abs(diff) !== diff ? Math.ceil(diff) : Math.floor(diff));
	        },
	
	        diffInDays: function(date1, date2) {
	            return this.diffInHours(new Date(date1.toDateString()), new Date(date2.toDateString())) / 24;
	        },
	
	        getMonthNames: function() {
	            return months;
	        },
	
	        getShortMonthNames: function() {
	            return shortMonths;
	        },
	
	        getWeekdayNames: function() {
	            return weekdays;
	        },
	
	        getShortWeekdayNames: function() {
	            return shortWeekdays;
	        },
	
	        isToday: function(date) {
	            if(!date) {
	                return false;
	            }
	            return this.diffInDays(new Date(), date) === 0;
	        },
	
	        isYesterday: function(date) {
	            if(!date) {
	                return false;
	            }
	            return this.diffInDays(new Date(), date) === 1;
	        },
	
	        isBefore: function(before, after) {
	            return this.diff(before, after) < 0;
	        }
	    };
	});
	
	
	define('galileo/util/channel',['require'],function(require) {
	
	    /**
	     * Implements a channel (a multicast listener), capable of optionally sending the last given arguments when a callback is added.
	     */
	    return function(sendLast) {
	        var fns = [], args;
	        return {
	            /**
	             * The collection of callbacks persisted for this channel.
	             */
	            fns: fns,
	            /**
	             * Calls each function in the channel with the given arguments passed in.
	             * @param arguments Calls each function with the given arguments and stores the arguments for use when take is called.
	             */
	            give: function() {
	                args = arguments;
	                for(var i=0; i<fns.length; i++) {
	                    fns[i].apply(this, args);
	                }
	            },
	            /**
	             * Adds the given function to the channel.
	             * If sendLast was true, it will call the fn with the last arguments give() was called with.
	             * @param fn A callback to add to the channel.
	             * @param ctxt An optional context for the callback.
	             * @returns {Function} A function that will remove the given function from the channel.
	             */
	            take: function(fn, ctxt) {
	                fn = ctxt ? function(fnBind){return function() { return fnBind.apply(ctxt,args) }}(fn) : fn;
	                fns.push(fn);
	                if(sendLast && args) 
	                    fn.apply(this, args);
	                return function() {
	                    for(var i=fns.length-1; i>=0; i--) {
	                        if(fns[i] === fn)
	                            fns.splice(i,1);
	                    }
	                }
	            }
	        };
	    };
	});
	
	define('galileo/ajax/ajax',['require','mootools','jquery','galileo/prototype/all','galileo/util/channel','underscore'],function(require) {
	    require('mootools');
	    require('jquery');
	    require('galileo/prototype/all');
	    var channel = require('galileo/util/channel');
	    var _ = require('underscore');
	
	    var preloading = true, queue = [], values = {}, channels = {};
	    window.channelThings = channels;
	    
	
	    function getKey(wrap, method, url, args) {
	        // sort the arguments by key, so that object iteration order doesn't change the memoization
	        var argsArray = Object.keys(args).map(function(k) { return [k, args[k]]; });
	        argsArray.sortBy(Function.takeKey(0));
	        return JSON.encode( [wrap, method, url, argsArray] );
	    }
	
	    /**
	     *
	     * @param post
	     * @param wrap
	     * @param owner
	     * @param method
	     *      Method is used as the HTTP verb if wrap is set to false, and is used as
	     *      the backend service method if wrap is set to true. This means it's only
	     *      used as the HTTP verb for the 'postRaw' and 'getRaw' methods.
	     * @param url
	     * @param args
	     * @param callback
	     * @returns {{update: update}}
	     */
	    function ajax(post, wrap, owner, method, url, args, callback) {
	        var key = getKey(wrap, method, url, args);
	
	        var fullRequest = !owner || typeof global_page_owner === 'undefined' ?  '/ajaxapi' : '/ajaxapi/user/' + global_page_owner.encodedId;
	        var argsWithCsrf = args;
	        // We're checking method here because even though we have a boolean
	        // argument which seems like it dictates whether the call is a POST,
	        // we still pass the supplied 'method' argument into $.ajax.
	        // The argsWithCsrf are only used when 'wrap' is set to false.
	        if (_.isString(method) && method.toLowerCase() === 'post' &&
	            _.isObject(args) && !_.isArray(args)) {
	            argsWithCsrf = _.extend({}, args, { csrfToken: window.fitbitCsrfToken });
	        }
	        var makeRequest = function(){
	            if(wrap) {
	                $.ajax({type: 'POST', url: fullRequest, data: $.param({
	                    request: JSON.stringify({
	                        template: '/ajaxTemplate.jsp', serviceCalls: [{
	                            name: url, args: args, method: method
	                        }]
	                    }),
	                    csrfToken: window.fitbitCsrfToken
	                }), success: function(res) { 
	                    load(wrap, method, url, args, JSON.parse(res));
	                }});
	            } else {
	                $.ajax({type: method, url: url, data: argsWithCsrf, success: load.bind(this, wrap, method, url, args)});
	            }
	        };
	
	        if(post === true) {
	            if(wrap) {
	                $.ajax({type: 'POST', url: fullRequest, data: $.param({
	                    request: JSON.stringify({
	                        template: '/ajaxTemplate.jsp', serviceCalls: [{
	                            name: url, args: args, method: method
	                        }]
	                    }),
	                    csrfToken: window.fitbitCsrfToken
	                }), success: callback
	                });
	            } else {
	                $.ajax({type: method, url: url, data: argsWithCsrf, success: callback});
	            }
	            return;
	        }
	
	        if(callback == undefined) {
	            return {
	                update: function() {
	                    delete values[key];
	                    makeRequest();
	                }
	            }
	        }
	        if(!channels[key]) {
	            channels[key] = channel();
	            
	            if(preloading) {
	                queue.push(function() {
	                    if(!values[key]) {
	                        makeRequest();
	                    }
	                });
	            } else {
	                makeRequest();
	            }
	        }
	
	        if(!channels[key].fns.contains(callback)) {
	            channels[key].take(callback);
	        }
	
	        if(values.hasOwnProperty(key)) { 
	            callback(values[key]);
	            return;
	        }
	    }
	
	    function load(wrap, method, url, args, value) {
	        var key = getKey(wrap, method, url, args);
	        values[key] = value;
	        channels[key] = channels[key] || channel();
	        channels[key].give(value);
	    }
	
	    function preloadFinished() {
	        preloading = false;
	        queue.map(function(fn) { fn(); });
	        delete queue;
	    }
	
	
	    return {
	        getRaw: ajax.bind(this, false, false, false, 'get'),
	        get: ajax.bind(this, false, true, false),
	        getOwner: ajax.bind(this, false, true, true),
	        post: ajax.bind(this, true, true, false),
	        postOwner: ajax.bind(this, true, true, true),
	        postRaw: ajax.bind(this, true, false, false, 'post'),
	        preload: load.bind(this, true),
	        preloadRaw: load.bind(this, false),
	        preloadFinished: preloadFinished
	    };
	});
	
	define('galileo/model/activities',['require','galileo/prototype/all','galileo/util/dateUtil','galileo/ajax/ajax'],function(require) {
	    require("galileo/prototype/all");
	    var dateUtil = require('galileo/util/dateUtil');
	    var ajax = require("galileo/ajax/ajax");
	    
	    var Activities = function(userId) {
	        this.userId = userId;
	    };
	
	    Activities.prototype = {
	        loadWeightSummary: function(date, callback) {
	            ajax.get("getWeightTileDataAt", "activityTileData", {date: dateUtil.ajaxEncode(date)}, function(result) {
	                callback(result)
	            });
	        },
	        loadSummary: function(seriesName, date, callback) {
	            ajax.get("getTileData", "activityTileData", {dataTypes: seriesName, date: dateUtil.ajaxEncode(date)}, function(result) {
	                callback(result[0])
	            });
	        },
	
	        /*
	         * TODO: Fix this function: The shuffling of parameters is weird - we should really be using a configuration object.
	         */
	        loadDays: function(series, startDate, endDate, granularity, hidePrecreationData, callback) {
	
	            // No granularity passed in; it's actually the callback
	            if (typeof granularity != 'string') {
	                callback = granularity;
	                granularity = '';
	            }
	
	            // No hidePrecreationData passed in; it's actually the callback
	            if(typeof hidePrecreationData =='function'){
	                callback=hidePrecreationData;
	                hidePrecreationData=false;
	            }
	
	            // We need to ajax encode the dates for the call to the server
	            if(startDate.getTime) {
	                startDate = dateUtil.ajaxEncode(startDate);
	                endDate = dateUtil.ajaxEncode(endDate);
	            }
	
	            ajax.getRaw(
	                '/graph/getNewGraphData',
	                {
	                    type: series,
	                    dateFrom: startDate,
	                    dateTo: endDate,
	                    granularity: granularity.toUpperCase(),
	                    hidePrecreationData:(!!hidePrecreationData)
	                },
	                function(response){
	                    // response from the graph data endpoint is returning a graph obj, so we'll use that.
	                    callback(response.graph);
	                }
	            );
	        },
	        loadIntraday: function(series, date, k) {
	            if(date.getTime) {
	                this.loadIntraday(series, dateUtil.ajaxEncode(date), k);
	            } else {
	                ajax.get(
	                    'getIntradayData',
	                    'activityTileData',
	                    {date: date, dataTypes: series},
	                    function(response) {
	                        k(response[0]);
	                    });
	            }
	        },
	        loadOwnerGraphDataPoints: function(series, endDate, startDate, granularity, k) {
	            var argObj = {
	                type: series,
	                dateFrom: endDate,
	                dateTo: startDate,
	                granularity: granularity
	            };
	            // nested objects have to be sent to the backend as a string *should be fixed
	            var args = {graphDataRequest: JSON.encode(argObj)};
	
	            ajax.postOwner(
	                'getDataPoints',
	                'graph',
	                args,
	                function(response) {
	
	                    k(response);
	                });
	        },
	        loadViewerGraphDataPoints: function(series, endDate, startDate, granularity, k) {
	            var argObj = {
	                type: series,
	                dateFrom: endDate,
	                dateTo: startDate,
	                granularity: granularity
	            };
	            // nested objects have to be sent to the backend as a string *should be fixed
	            var args = {graphDataRequest: JSON.encode(argObj)};
	
	            ajax.post(
	                'getDataPoints',
	                'graph',
	                args,
	                function(response) {
	
	                    k(response);
	                });
	        }
	
	    };
	        
	    return Activities;
	});
	
	define('galileo/model/subscription',['require','mootools','galileo/ajax/ajax'],function(require){
	    require('mootools');
	    var ajax = require("galileo/ajax/ajax");
	
	    var Subscription = new Class({
	        type: undefined,
	
	        properties: {},
	
	        initialize: function(type, data){
	            this.type = type;
	
	            Object.merge(this.properties, data);
	        },
	
	        isActive: function(){
	            return !!this.properties.active;
	        },
	
	        isPremium: function(){
	            return !!this.properties.premium;
	        },
	
	        isTrial: function(){
	            return !!this.properties.trial;
	        },
	
	        isExpired: function(){
	            return !this.properties.active;
	        },
	
	        getPlan: function(data, cb){
	            if (typeof data == 'function') {
	                cb = data;
	                data = {};
	            }
	            if(data === void(0)) {
	                data = {};
	            }
	
	            var type = this.type;
	            if (type) {
	                var method = 'get' + type.capitalize() + 'Plan';
	                var result = ajax.get(method, 'activityTileData', data, cb);
	            }
	
	            if (!cb) {
	                return result;
	            }
	        }
	    });
	
	    return Subscription;
	});
	
	define('galileo/model/goals',['require','galileo/prototype/all','galileo/ajax/ajax','galileo/util/dateUtil'],function(require) {
	
	    require("galileo/prototype/all");
	    var ajax = require("galileo/ajax/ajax");
	    var dateUtil = require('galileo/util/dateUtil');
	
	    return {
	        update: function(seriesName, newDailyGoal, date) {
	            if (!date) {
	                date = new Date;
	            }
	
	            ajax.post("updateDailyGoal", "activityTileData", {dataType: seriesName, goalValue: newDailyGoal}, function() {
	                ajax.get("getGoalData", "activityTileData", {dataTypes: seriesName}).update();
	                ajax.get("getTileData", "activityTileData", {date: dateUtil.ajaxEncode(date), dataTypes: seriesName}).update();
	            });
	        },
	        updateWeekly: function(seriesName, newWeekly, date) {
	            if (!date) {
	                date = new Date;
	            }
	
	            ajax.post("updateWeeklyGoal", "activityTileData", {dataType: seriesName, goalValue: newWeekly},function(){
	                ajax.get("getGoalData", "activityTileData", {dataTypes: seriesName}).update();
	                ajax.get("getTileData", "activityTileData", {date: dateUtil.ajaxEncode(date), dataTypes: seriesName}).update();
	            });
	        },
	        loadActivityType: function(activityType, k) {
	            ajax.get("getGoalData", "activityTileData", {dataTypes: activityType}, function(x) { k(x[0]); });
	        },
	        loadTileActivity: function(seriesName, date, k) {
	            ajax.getOwner("getTileData", "activityTileData", {date: date, dataTypes: seriesName},
	                function(response) {
	                    k(response);
	                });
	        },
	        load: function(k) {
	            ajax.getRaw("/lab/galileo/dash", {apiFormat: 'json', goals: 'on'}, function(response) { k(response.goals); });
	        }
	    };
	    
	});
	
	define('ajaxQueue',['require','jquery','underscore'],function(require) {
	
	    var $ = require('jquery');
	
	    var _ = require('underscore');
	
	    var service = {};
	
	    service.queue = [];
	
	    /*
	     * ajaxCall should look like this:
	     * {
	     *     method: 'post', // the method to use ('post', 'get', etc)
	     *     url: 'someUrl', // the url to make the request to
	     *     value: 'someValueOrValues', // the value to send
	     *     callback: someFunction, // optional: a callback for the ajax call
	     *     callbackContext: someObjectOrFunction // optional: a context for "this" in the callback
	     * }
	     */
	    service.push = function push(ajaxCall) {
	        service.queue.push(ajaxCall);
	
	        if(service.queue.length === 1)
	            makeCall(ajaxCall);
	    };
	
	    function makeCall(ajaxCall) {
	        $[ajaxCall.method](ajaxCall.url, ajaxCall.value, function() {
	            if (typeof ajaxCall.callback === 'function') {
	                ajaxCall.callback.apply(ajaxCall.callbackContext || window, arguments);
	            }
	
	            // Clean up the call we just made
	            service.queue = _.without(service.queue, ajaxCall);
	
	            // Start up the next call if available
	            if(service.queue.length)
	                makeCall(service.queue[0]);
	        });
	    }
	
	    return service;
	});
	//     Backbone.js 1.1.2
	
	//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(root, factory) {
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (typeof define === 'function' && define.amd) {
	    define('backbone',['underscore', 'jquery', 'exports'], function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    });
	
	  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore');
	    factory(root, exports, _);
	
	  // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	}(this, function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create local references to array methods we'll want to use later.
	  var array = [];
	  var push = array.push;
	  var slice = array.slice;
	  var splice = array.splice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.1.2';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // custom events. You may bind with `on` or remove with `off` callback
	  // functions to an event; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {
	
	    // Bind an event to a `callback` function. Passing `"all"` will bind
	    // the callback to all events fired.
	    on: function(name, callback, context) {
	      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
	      this._events || (this._events = {});
	      var events = this._events[name] || (this._events[name] = []);
	      events.push({callback: callback, context: context, ctx: context || this});
	      return this;
	    },
	
	    // Bind an event to only be triggered a single time. After the first time
	    // the callback is invoked, it will be removed.
	    once: function(name, callback, context) {
	      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
	      var self = this;
	      var once = _.once(function() {
	        self.off(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	      return this.on(name, once, context);
	    },
	
	    // Remove one or many callbacks. If `context` is null, removes all
	    // callbacks with that function. If `callback` is null, removes all
	    // callbacks for the event. If `name` is null, removes all bound
	    // callbacks for all events.
	    off: function(name, callback, context) {
	      var retain, ev, events, names, i, l, j, k;
	      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
	      if (!name && !callback && !context) {
	        this._events = void 0;
	        return this;
	      }
	      names = name ? [name] : _.keys(this._events);
	      for (i = 0, l = names.length; i < l; i++) {
	        name = names[i];
	        if (events = this._events[name]) {
	          this._events[name] = retain = [];
	          if (callback || context) {
	            for (j = 0, k = events.length; j < k; j++) {
	              ev = events[j];
	              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
	                  (context && context !== ev.context)) {
	                retain.push(ev);
	              }
	            }
	          }
	          if (!retain.length) delete this._events[name];
	        }
	      }
	
	      return this;
	    },
	
	    // Trigger one or many events, firing all bound callbacks. Callbacks are
	    // passed the same arguments as `trigger` is, apart from the event name
	    // (unless you're listening on `"all"`, which will cause your callback to
	    // receive the true name of the event as the first argument).
	    trigger: function(name) {
	      if (!this._events) return this;
	      var args = slice.call(arguments, 1);
	      if (!eventsApi(this, 'trigger', name, args)) return this;
	      var events = this._events[name];
	      var allEvents = this._events.all;
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, arguments);
	      return this;
	    },
	
	    // Tell this object to stop listening to either specific events ... or
	    // to every object it's currently listening to.
	    stopListening: function(obj, name, callback) {
	      var listeningTo = this._listeningTo;
	      if (!listeningTo) return this;
	      var remove = !name && !callback;
	      if (!callback && typeof name === 'object') callback = this;
	      if (obj) (listeningTo = {})[obj._listenId] = obj;
	      for (var id in listeningTo) {
	        obj = listeningTo[id];
	        obj.off(name, callback, this);
	        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
	      }
	      return this;
	    }
	
	  };
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Implement fancy features of the Events API such as multiple event
	  // names `"change blur"` and jQuery-style event maps `{change: action}`
	  // in terms of the existing API.
	  var eventsApi = function(obj, action, name, rest) {
	    if (!name) return true;
	
	    // Handle event maps.
	    if (typeof name === 'object') {
	      for (var key in name) {
	        obj[action].apply(obj, [key, name[key]].concat(rest));
	      }
	      return false;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return false;
	    }
	
	    return true;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	  };
	
	  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};
	
	  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
	  // listen to an event in another object ... keeping track of what it's
	  // listening to.
	  _.each(listenMethods, function(implementation, method) {
	    Events[method] = function(obj, name, callback) {
	      var listeningTo = this._listeningTo || (this._listeningTo = {});
	      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	      listeningTo[id] = obj;
	      if (!callback && typeof name === 'object') callback = this;
	      obj[implementation](name, callback, this);
	      return this;
	    };
	  });
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId('c');
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      var attr, attrs, unset, changes, silent, changing, prev, current;
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      unset           = options.unset;
	      silent          = options.silent;
	      changes         = [];
	      changing        = this._changing;
	      this._changing  = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	      current = this.attributes, prev = this._previousAttributes;
	
	      // Check for changes of `id`.
	      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];
	
	      // For each `set` attribute, update or delete the current value.
	      for (attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          this.changed[attr] = val;
	        } else {
	          delete this.changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0, l = changes.length; i < l; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var val, changed = false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      for (var attr in diff) {
	        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
	        (changed || (changed = {}))[attr] = val;
	      }
	      return changed;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server. If the server's representation of the
	    // model differs from its current attributes, they will be overridden,
	    // triggering a `"change"` event.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (!model.set(model.parse(resp, options), options)) return false;
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      var attrs, method, xhr, attributes = this.attributes;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true}, options);
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !options.wait) {
	        if (!this.set(attrs, options)) return false;
	      } else {
	        if (!this._validate(attrs, options)) return false;
	      }
	
	      // Set temporary attributes if `{wait: true}`.
	      if (attrs && options.wait) {
	        this.attributes = _.extend({}, attributes, attrs);
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = model.parse(resp, options);
	        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
	        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
	          return false;
	        }
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch') options.attrs = attrs;
	      xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      if (attrs && options.wait) this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	
	      var destroy = function() {
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (options.wait || model.isNew()) destroy();
	        if (success) success(model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      if (this.isNew()) {
	        options.success();
	        return false;
	      }
	      wrapError(this, options);
	
	      var xhr = this.sync('delete', this, options);
	      if (!options.wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base =
	        _.result(this, 'urlRoot') ||
	        _.result(this.collection, 'url') ||
	        urlError();
	      if (this.isNew()) return base;
	      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend(options || {}, { validate: true }));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model.
	  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  _.each(modelMethods, function(method) {
	    Model.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.attributes);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analagous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model){ return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      var singular = !_.isArray(models);
	      models = singular ? [models] : _.clone(models);
	      options || (options = {});
	      var i, l, index, model;
	      for (i = 0, l = models.length; i < l; i++) {
	        model = models[i] = this.get(models[i]);
	        if (!model) continue;
	        delete this._byId[model.id];
	        delete this._byId[model.cid];
	        index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	        this._removeReference(model, options);
	      }
	      return singular ? models[0] : models;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      options = _.defaults({}, options, setOptions);
	      if (options.parse) models = this.parse(models, options);
	      var singular = !_.isArray(models);
	      models = singular ? (models ? [models] : []) : _.clone(models);
	      var i, l, id, model, attrs, existing, sort;
	      var at = options.at;
	      var targetModel = this.model;
	      var sortable = this.comparator && (at == null) && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	      var toAdd = [], toRemove = [], modelMap = {};
	      var add = options.add, merge = options.merge, remove = options.remove;
	      var order = !sortable && add && remove ? [] : false;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      for (i = 0, l = models.length; i < l; i++) {
	        attrs = models[i] || {};
	        if (attrs instanceof Model) {
	          id = model = attrs;
	        } else {
	          id = attrs[targetModel.prototype.idAttribute || 'id'];
	        }
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        if (existing = this.get(id)) {
	          if (remove) modelMap[existing.cid] = true;
	          if (merge) {
	            attrs = attrs === model ? model.attributes : attrs;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(attrs, options);
	          if (!model) continue;
	          toAdd.push(model);
	          this._addReference(model, options);
	        }
	
	        // Do not add multiple models with the same `id`.
	        model = existing || model;
	        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
	        modelMap[model.id] = true;
	      }
	
	      // Remove nonexistent models if appropriate.
	      if (remove) {
	        for (i = 0, l = this.length; i < l; ++i) {
	          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this.remove(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      if (toAdd.length || (order && order.length)) {
	        if (sortable) sort = true;
	        this.length += toAdd.length;
	        if (at != null) {
	          for (i = 0, l = toAdd.length; i < l; i++) {
	            this.models.splice(at + i, 0, toAdd[i]);
	          }
	        } else {
	          if (order) this.models.length = 0;
	          var orderedModels = order || toAdd;
	          for (i = 0, l = orderedModels.length; i < l; i++) {
	            this.models.push(orderedModels[i]);
	          }
	        }
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort events.
	      if (!options.silent) {
	        for (i = 0, l = toAdd.length; i < l; i++) {
	          (model = toAdd[i]).trigger('add', model, this, options);
	        }
	        if (sort || (order && order.length)) this.trigger('sort', this, options);
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options || (options = {});
	      for (var i = 0, l = this.models.length; i < l; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      if (_.isEmpty(attrs)) return first ? void 0 : [];
	      return this[first ? 'find' : 'filter'](function(model) {
	        for (var key in attrs) {
	          if (attrs[key] !== model.get(key)) return false;
	        }
	        return true;
	      });
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      // Run sort based on type of `comparator`.
	      if (_.isString(this.comparator) || this.comparator.length === 1) {
	        this.models = this.sortBy(this.comparator, this);
	      } else {
	        this.models.sort(_.bind(this.comparator, this));
	      }
	
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return _.invoke(this.models, 'get', attr);
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success(collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      if (!(model = this._prepareModel(model, options))) return false;
	      if (!options.wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(model, resp) {
	        if (options.wait) collection.add(model, options);
	        if (success) success(model, resp, options);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models);
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (attrs instanceof Model) return attrs;
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function(model, options) {
	      this._byId[model.cid] = model;
	      if (model.id != null) this._byId[model.id] = model;
	      if (!model.collection) model.collection = this;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model, options) {
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if ((event === 'add' || event === 'remove') && collection !== this) return;
	      if (event === 'destroy') this.remove(model, options);
	      if (model && event === 'change:' + model.idAttribute) {
	        delete this._byId[model.previous(model.idAttribute)];
	        if (model.id != null) this._byId[model.id] = model;
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
	    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
	    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
	    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
	    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
	    'lastIndexOf', 'isEmpty', 'chain', 'sample'];
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  _.each(methods, function(method) {
	    Collection.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.models);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Underscore methods that take a property name as an argument.
	  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];
	
	  // Use attributes instead of properties.
	  _.each(attributeMethods, function(method) {
	    Collection.prototype[method] = function(value, context) {
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _[method](this.models, iterator, context);
	    };
	  });
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    options || (options = {});
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	    this.delegateEvents();
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be merged as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this.$el.remove();
	      this.stopListening();
	      return this;
	    },
	
	    // Change the view's element (`this.el` property), including event
	    // re-delegation.
	    setElement: function(element, delegate) {
	      if (this.$el) this.undelegateEvents();
	      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
	      this.el = this.$el[0];
	      if (delegate !== false) this.delegateEvents();
	      return this;
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    // This only works for delegate-able events: not `focus`, `blur`, and
	    // not `change`, `submit`, and `reset` in Internet Explorer.
	    delegateEvents: function(events) {
	      if (!(events || (events = _.result(this, 'events')))) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[events[key]];
	        if (!method) continue;
	
	        var match = key.match(delegateEventSplitter);
	        var eventName = match[1], selector = match[2];
	        method = _.bind(method, this);
	        eventName += '.delegateEvents' + this.cid;
	        if (selector === '') {
	          this.$el.on(eventName, method);
	        } else {
	          this.$el.on(eventName, selector, method);
	        }
	      }
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view with `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
	        this.setElement($el, false);
	      } else {
	        this.setElement(_.result(this, 'el'), false);
	      }
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
	    // that still has ActiveX enabled by default, override jQuery to use that
	    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
	    if (params.type === 'PATCH' && noXhrPatch) {
	      params.xhr = function() {
	        return new ActiveXObject("Microsoft.XMLHTTP");
	      };
	    }
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  var noXhrPatch =
	    typeof window !== 'undefined' && !!window.ActiveXObject &&
	      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch':  'PATCH',
	    'delete': 'DELETE',
	    'read':   'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        router.execute(callback, args);
	        router.trigger.apply(router, ['route:' + name].concat(args));
	        router.trigger('route', name, args);
	        Backbone.history.trigger('route', router, name, args);
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function(callback, args) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional) {
	                     return optional ? match : '([^/?]+)';
	                   })
	                   .replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    _.bindAll(this, 'checkUrl');
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for detecting MSIE.
	  var isExplorer = /msie [\w.]+/;
	
	  // Cached regex for removing a trailing slash.
	  var trailingSlash = /\/$/;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function() {
	      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the cross-browser normalized URL fragment, either from the URL,
	    // the hash, or the override.
	    getFragment: function(fragment, forcePushState) {
	      if (fragment == null) {
	        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
	          fragment = decodeURI(this.location.pathname + this.location.search);
	          var root = this.root.replace(trailingSlash, '');
	          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error("Backbone.history has already been started");
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
	      var fragment          = this.getFragment();
	      var docMode           = document.documentMode;
	      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      if (oldIE && this._wantsHashChange) {
	        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
	        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
	        this.navigate(fragment);
	      }
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._hasPushState) {
	        Backbone.$(window).on('popstate', this.checkUrl);
	      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
	        Backbone.$(window).on('hashchange', this.checkUrl);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      // Determine if we need to change the base url, for a pushState link
	      // opened by a non-pushState browser.
	      this.fragment = fragment;
	      var loc = this.location;
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          this.fragment = this.getFragment(null, true);
	          this.location.replace(this.root + '#' + this.fragment);
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	        // Or if we've started out with a hash-based route, but we're currently
	        // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot() && loc.hash) {
	          this.fragment = this.getHash().replace(routeStripper, '');
	          this.history.replaceState({}, document.title, this.root + this.fragment);
	        }
	
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	      if (current === this.fragment && this.iframe) {
	        current = this.getFragment(this.getHash(this.iframe));
	      }
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragment) {
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.any(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: !!options};
	
	      var url = this.root + (fragment = this.getFragment(fragment || ''));
	
	      // Strip the hash for matching.
	      fragment = fragment.replace(pathStripper, '');
	
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	
	      // Don't include a trailing slash on the root.
	      if (fragment === '' && url !== '/') url = url.slice(0, -1);
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._hasPushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if(!options.replace) this.iframe.document.open().close();
	          this._updateHash(this.iframe.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain, for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent's constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function.
	    var Surrogate = function(){ this.constructor = child; };
	    Surrogate.prototype = parent.prototype;
	    child.prototype = new Surrogate;
	
	    // Add prototype properties (instance properties) to the subclass,
	    // if supplied.
	    if (protoProps) _.extend(child.prototype, protoProps);
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function(model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error(model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	
	}));
	
	/*global Class:false */
	define('galileo/model/user',['require','galileo/prototype/all','jquery.numberformatter','galileo/model/activities','galileo/model/subscription','galileo/model/goals','galileo/ajax/ajax','i18n/i18n','galileo/util/dateUtil','ajaxQueue','underscore','backbone','i18n-load!com/fitbit/app/unit','i18n-load!com/fitbit/app/ngd/betas'],function(require) {
	    
	
	    require('galileo/prototype/all');
	    require('jquery.numberformatter');
	    var Activities = require('galileo/model/activities');
	    var Subscription = require('galileo/model/subscription');
	    var Goals = require('galileo/model/goals');
	    var ajax = require('galileo/ajax/ajax');
	    var i18n = require('i18n/i18n')();
	    var dateUtil = require('galileo/util/dateUtil');
	    var ajaxQueue = require('ajaxQueue');
	    var _ = require('underscore');
	    var Backbone = require('backbone');
	
	    i18n.namespace(require('i18n-load!com/fitbit/app/unit'));
	    i18n.namespace(require('i18n-load!com/fitbit/app/ngd/betas'));
	
		var NGD_RELEASE_DATE = new Date('2013/05/01');
		var NEW_USER_DURATION = 30 * 24 * 60 * 60 * 1000;  // 30 days in MS
		
	    var UNIT_SPACE_LOCALES = ['it_IT'];
	
	    var TRACKER_PRODUCT_NAMES = {
	        GALILEO  : 'zip',
	        HADRON  : 'one',
	        QUARK    : 'flex',
	        NEUTRINO : 'force'
	    };
	    var SettingsModel = Backbone.Model.extend({
	        parse: function(response) {
	            try {
	                return JSON.parse(response.settings['galileo user settings']);
	            } catch (e) {}
	        },
	        sync: function() {
	            // this is a fairly non standard sync model for a backbone model, basically using the model for
	            // change events and some other helpful functions. We
	            ajaxQueue.push({
	                method:             'post',
	                url:                '/userSettings/dh/save?apiFormat=json',
	                value:              {'settings[\'galileo user settings\']': JSON.stringify(this.toJSON()),'csrfToken':window.fitbitCsrfToken}
	            });
	        }
	    });
	
	    var settingsModel = new SettingsModel();
	    
	    var User = new Class({
	
	        _activities: null,
	
	        _water: null,
	
	        _isFirstVisit: false,
	
	        deviceFeatures: {},
	
	        goals: Goals,
	
	        trainerPlan: false,
	
	        initialize: function(userData){
	            Object.merge(this, userData);
	
	            // setup subscriptions
	            Object.forEach(this.subscriptions, function(val, key){
	                this.subscriptions[key] = new Subscription(key, val);
	            }, this);
	        },
	
	        activities: function(){
	            this._activities = this._activities || new Activities();
	            return this._activities;
	        },
	
	        loadFriends: function(k) {
	            ajax.getOwner('data', 'leaderboardAjaxService', {}, function(data) {
	                 k(data);
	            });
	        },
	
	        loadActivitiesLogsSummary: function(callback) {
	            ajax.get('user', 'getActivitiesLogsSummary', {}, function(data) {
	                 callback(data);
	            });
	        },
	
	        loadFriendSuggestions: function(callback) {
	            ajax.get('getSuggestions', 'friend', {}, function(data) {
	                 callback(data);
	            });
	        },
	
	        unitsString: function(units, isLong, digits) {
	            var gramsPer = (this.weightSystem === 'US' && 453.592) ||
	                (this.weightSystem === 'UK' && 453.592*14) ||
	                1000;
	            return this.gramsString(units*gramsPer, isLong, digits);
	        },
	
	        gramsString: function(grams, isLong, digits) {
	            digits = digits === undefined ? 1 : digits;
	            var pattern = (digits > 0) ? '#,###.' + new Array(digits+1).join('0') : '#,###';
	            var lbs = grams / 453.592;
	            var stones = Math.floor(lbs/14);
	            var st = isLong ? i18n.plural('stone_full') : i18n.plural('stone_short');
	            var kg = isLong ? i18n.plural('kilogram_full') : i18n.plural('kilogram_short');
	            var lb = isLong ? i18n.plural('pound_full') : i18n.plural('pound_short');
	
	            var unitSpace = '';
	            if ($.inArray(this.locale, UNIT_SPACE_LOCALES) !== -1) {
	                unitSpace = ' ';
	            }
	
	            if(this.weightSystem === 'UK') {
	                lbs -= stones*14;
	                //return stones + st(stones) + ' ' + lbs.toFixed(digits) + lb(lbs);
	                return stones + unitSpace + st(stones) + ' ' + this.formatNumber(lbs, pattern) + unitSpace + lb(lbs);
	            } else if(this.weightSystem === 'US') {
	                //return lbs.toFixed(digits) + lb(lbs);
	                return this.formatNumber(lbs, pattern) + unitSpace + lb(lbs);
	            } else {
	                //return (grams/1000).toFixed(digits) + kg(grams/1000);
	                return this.formatNumber(grams/1000, pattern) + unitSpace + kg(grams/1000);
	            }
	        },
	
	        formatNumber: function(n, fmt) {
	            return $.formatNumber(n, {format: fmt, locale: this.locale});
	        },
	
	        parseNumber: function(n, fmt) {
	            return $.parseNumber(n, {format: fmt, locale: this.locale});
	        },
	
	        thousands: function(n) {
	            return this.formatNumber(n, '#,###') || '0';
	        },
	
	        formatTime: function(date) {
	            return this.clock12 ? dateUtil.localeFormat(date, 'hh:mm a') : dateUtil.localeFormat(date, 'HH:mm');
	        },
	
	        isFirstVisit: function() {
	            return this._isFirstVisit;
	        },
	
	        isNewUser: function() {
	            return (new Date() - new Date(settingsModel.get('firstVisitDate'))) <= NEW_USER_DURATION;
	        },
	
	        isLegacyUser: function() {
	            return settingsModel.get('firstVisitDate') < NGD_RELEASE_DATE;
	        },
	
	        hasTrainerPlan: function() {
	            var trainer = this.subscriptions.trainer;
	
	            return trainer && trainer.isActive();
	        },
	
	        hasSeenTile: function(tileName) {
	            return !!(settingsModel.get('seenTiles') && settingsModel.get('seenTiles')[tileName]);
	        },
	
	        seeTile: function(tileName) {
	            var seenTiles = _.clone(settingsModel.get('seenTiles')) || {};
	            seenTiles[tileName] = 1;
	            this.saveSetting('seenTiles', seenTiles);
	        },
	
	        initSettings: function(settings) {
	            settingsModel.set(settings);
	
	            if (!settings.firstVisitDate) {
	                this._isFirstVisit = true;
	                this.saveSetting('firstVisitDate', new Date().getTime());
	            }
	        },
	
			saveSetting: function(setting, value, options) {
	            settingsModel.save(setting, value, options);
			},
	
	        getDeviceFeatures: function() {
	            return _.clone(this.deviceFeatures) || {};
	        },
	
	        getTrackerType: function() {
	            return this.trackerType;
	        },
	
	        getTrackerProductName: function() {
	            return TRACKER_PRODUCT_NAMES[this.trackerType];
	        },
	
	        getSettingsModel: function() {
	            return settingsModel;
	        },
	
	        hasRole:function(role){
	            return this.roles && this.roles.contains(role);
	        }
	    });
	
	    User.viewer = new User(window.global_page_viewer);
	    return User;
	});
	
	;
	(function() {
	
	    var object = typeof exports != 'undefined' ? exports : this; // #8: web workers
	    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	    function InvalidCharacterError(message) {
	        this.message = message;
	    }
	    InvalidCharacterError.prototype = new Error;
	    InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	    // encoder
	    // [https://gist.github.com/999166] by [https://github.com/nignag]
	    object.btoa || (
	        object.btoa = function(input) {
	            var str = String(input);
	            for (
	                // initialize result and counter
	                var block, charCode, idx = 0, map = chars, output = '';
	                // if the next str index does not exist:
	                //   change the mapping table to "="
	                //   check if d has no fractional digits
	                str.charAt(idx | 0) || (map = '=', idx % 1);
	                // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	                output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
	                charCode = str.charCodeAt(idx += 3 / 4);
	                if (charCode > 0xFF) {
	                    throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
	                }
	                block = block << 8 | charCode;
	            }
	            return output;
	        });
	
	    // decoder
	    // [https://gist.github.com/1020396] by [https://github.com/atk]
	    object.atob || (
	        object.atob = function(input) {
	            var str = String(input).replace(/=+$/, '');
	            if (str.length % 4 == 1) {
	                throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	            }
	            for (
	                // initialize result and counters
	                var bc = 0, bs, buffer, idx = 0, output = '';
	                // get next character
	                buffer = str.charAt(idx++);
	                // character found in table? initialize bit storage and add its ascii value;
	                ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	                    // and if not first of each 4 characters,
	                    // convert the first 8 bits to one ascii character
	                bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	                // try to find character in table (0-63, not found => -1)
	                buffer = chars.indexOf(buffer);
	            }
	            return output;
	        });
	
	}());
	
	define("shared/scripts/libs/polyfills/base64", function(){});
	
	define('shared/scripts/modules/api-client',['require','../libs/jquery/plugins/iecors/jquery.iecors','jquery','underscore','Logger','galileo/model/user','../libs/polyfills/base64'],function(require) {
	    
	    require('../libs/jquery/plugins/iecors/jquery.iecors');
	
	    var $ = require('jquery'),
	        _ = require('underscore'),
	        logger = require('Logger'),
	        config = require('galileo/model/user').viewer || {},
	        apiUrl = config.apiUrl,
	        oauth2Token = config.oauth2Token,
	        // polyfill for base64 encode/decode, IE 8/9
	        atob = window.atob || require('../libs/polyfills/base64'),
	        FUZZ = 300,
	        oauthRequest,
	        ACCEPT_LANGUAGE = 'Accept-Language';
	
	    // these log through to our FrontEndErrorLogActionBean logger
	    if(!oauth2Token) {
	        logger('no oauth2Token in config ajax requests will not work');
	    }
	    if(!apiUrl) {
	        logger('no apiUrl in config ajax requests will not work');
	    }
	
	    var getExpirationTime = function(token) {
	        var splits = token.split('.');
	
	        if(splits.length !== 3) {
	            // this logs through to our FrontEndErrorLogActionBean logger
	            logger('incorrect number of segments in oauth token to decode, number: ' + splits.length + ' token: ');
	        } else {
	            var payload;
	            try {
	                payload = JSON.parse(atob(splits[1]));
	
	                if (!_.isNumber(payload.exp)) {
	                    logger('expire time is not a number it is a ' + (typeof payload.exp) + ' of value ' + payload.exp);
	                }
	            } catch (e) {
	                logger('could not get/parse OAuth token payload token is: ' + token);
	            }
	
	            return payload.exp * 1000;
	        }
	    };
	
	    var headers = {
	        // todo change this not to hardcode and instead to get token type from backend
	        Authorization: 'Bearer ' + oauth2Token
	    };
	
	    // default is metric
	    if(config.weightSystem === 'US') {
	        headers[ACCEPT_LANGUAGE] = 'en_US';
	    } else if(config.weightSystem === 'UK') {
	        headers[ACCEPT_LANGUAGE] = 'en_GB';
	    } else {
	        headers[ACCEPT_LANGUAGE] = 'METRIC';
	    }
	
	    function setAcceptLanguageHeader(settings) {
	        var unitSystem = settings.useDistanceUnitSystem ? config.distanceUnit : config.weightSystem;
	
	        if (settings.acceptsLanguageHeader) {
	            return settings.acceptsLanguageHeader;
	        }
	
	        if (unitSystem === 'US') {
	            return 'en_US';
	        } else if (unitSystem === 'UK') {
	            return 'en_GB';
	        } else {
	            return 'METRIC';
	        }
	    }
	
	    var makeFullUrl = function(url) {
	        return 'https://' + apiUrl + (url.charAt(0) === '/' ? '' : '/') + url;
	    };
	
	    var refreshToken = function() {
	        return $.get('/dashOAuth/token')
	            .done(function(data) {
	                headers.Authorization = 'Bearer ' + data.oauthToken;
	            }).fail(function(xhr, status, error) {
	                // this logs through to our FrontEndErrorLogActionBean logger
	                logger('cannot refresh oauth token: ' + error);
	            });
	    };
	
	    var ajax = function(settings) {
	        if(!_.isObject(settings)) {
	            window.onerror('settings must be an object not: ' + settings);
	        }
	        if((Date.now() + FUZZ) >= getExpirationTime(headers.Authorization)) {
	            // if oauthRequest is 'resolved' it's leftover from a previous request
	            if(!oauthRequest || oauthRequest.state() === 'resolved') {
	                oauthRequest = refreshToken();
	            }
	
	            // this allows us to return a useful promise which can be used to synchronize
	            // multiple fetchs or what have you. However this is not really a jqXHR object.
	            var deferred = new $.Deferred();
	
	            oauthRequest.done(function() {
	                var jqxhr = ajax(settings);
	                jqxhr.done(function() {
	                    deferred.resolve.apply(this, arguments);
	                });
	                jqxhr.fail(function() {
	                    deferred.reject.apply(this, arguments);
	                });
	            });
	
	            return deferred;
	        } else {
	            settings.headers = _.defaults(settings.headers || {}, headers);
	            settings.headers[ACCEPT_LANGUAGE] = setAcceptLanguageHeader(settings);
	            return $.ajax(settings);
	        }
	    };
	
	    var updateBackbone = function(backbone) {
	        //overriding in order to support our OAuth and units system
	        backbone.ajax = ajax;
	    };
	
	    return {
	        ajax: ajax,
	        refreshToken: refreshToken,
	        makeFullUrl: makeFullUrl,
	        updateBackbone: updateBackbone
	    };
	});
	
	define('relationshipStatus',['require','shared/scripts/modules/api-client'],function(require) {
	
	    var API_VERSION = 1;
	    var apiClient = require('shared/scripts/modules/api-client');
	
	    function determineBlockedState(encodedUserId, callback) {
	        var url = apiClient.makeFullUrl('/' + API_VERSION + '/user/-/blocked-users.json');
	
	        apiClient.ajax({
	            url: url,
	            type: 'GET',
	            success: function (data, textStatus, xhr) {
	                for (i = 0; i < data.data.length; i++) {
	                    var blockedUser = data.data[i];
	                    if (blockedUser.id === encodedUserId) {
	                        return callback(true);
	                    }
	                }
	                callback(false);
	
	            },
	            error: function (jqXHR, textStatus, errorThrown) {
	                callback(false); // Give benefit of doubt, if can't check blocked users.
	            }
	        });
	    }
	
	
	    function determineFriendState(encodedUserId, callback) {
	        var url = apiClient.makeFullUrl('/' + API_VERSION + '/user/-/friends.json');
	
	        apiClient.ajax({
	            url: url,
	            type: 'GET',
	            success: function(data, textStatus, xhr) {
	                for (var i = 0; i < data.friends.length; i++) {
	                    var friend = data.friends[i];
	                    if (friend.user && friend.user.encodedId === encodedUserId) {
	                        return callback(true);
	                    }
	                }
	                callback(false);
	
	            },
	            error: function(jqXHR, textStatus, errorThrown) {
	                callback(true); // Give benefit of doubt, if can't check friends.
	            }
	        });
	    }
	
	    /*
	      Determines whether the given encodedUserId is 
	      'blocked', 'friend', or 'nonfriend' with the logged in user.
	      It does this by making two api requests,
	      one to get the list of friends for the logged in user,
	      and one to get the list of blocked users.
	      When both calls have completed, the relationship status can be determined,
	      and the given callback will be called with the result.
	    */
	
	
	    function determine(encodedUserId, callback) {
	        var isBlocked = undefined;
	        var isFriend = undefined;
	        var status = undefined;
	        var requestComplete = function() {
	            if (isBlocked !== undefined && isFriend !== undefined) {
	                status = ( isBlocked ) ? 'blocked' : ( isFriend ) ? 'friend' : 'nonfriend';
	                callback(status);
	            }
	        };
	
	        determineBlockedState(encodedUserId, function(blockedState) {
	            isBlocked = blockedState;
	            requestComplete();
	        });
	        determineFriendState(encodedUserId, function(friendState) {
	            isFriend = friendState;
	            requestComplete();
	        })
	    }
	
	
	    return {
	        determine: determine
	    };
	
	});
	}.call(window));

/***/ }
/******/ ])


/** WEBPACK FOOTER **
 ** relationshipStatus.js.4e074e838a667dd469327c785ab29e4d.js
 **/